import { Component, OnInit, Input } from '@angular/core';
import { ApiService } from './../../shared/api.service';
import { Router, ActivatedRoute } from '@angular/router';
import { saveAs } from 'file-saver';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { NbDialogRef } from '@nebular/theme';
import { UserService } from './../../@core/data/users.service';
import { ConfirmationService } from 'primeng/api';



@Component({
  selector: 'educational',
  template: `
  <style>
  .mat-form-field--inline {
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .mat-form-field--inline .mat-form-field {
        display: inline-block;
        width: 100%;
        vertical-align: middle;
    }

    .mat-form-field--inline .mat-form-field:nth-child(1) {
        margin-right: 10px;
    }
    
    @media (max-width: 767px) {
      #selectLine{  
        width: 65%;
      } 
    }
      
    @media (min-width: 1200px) {
      #selectLine{  
        width: 145%;
      } 
    }
      
    @media (min-width: 768px) {
      #selectLine{  
        width: 65%;
      } 
    }
      
    @media (min-width: 992px) {
      #selectLine{  
        width: 145%;
      } 
    }

    /* .example-full-width {
      
    } */
  </style>
  <nb-card status="success"  [style.height.px]="630" [style.overflow]="'auto'">
    <nb-card-header>Add Educational Details</nb-card-header>
    <nb-card-body> 
      <span *ngIf="instructionValidation===false" style="color:red;">Please add medium of instruction which is below subjects.</span>
      <form [formGroup]="edu_form"  class="step-container">
        <div class="row">
          <div class="col-md-3">Course Name : </div>
          <div class="col-md-2"> 
            <!--<input  ngModel="{{edu_data?.CourseName}}" nbInput type="text" [ngClass]="{'form-control-danger': edu_form.controls.courseNameCtrl.invalid && (edu_form.controls.courseNameCtrl.dirty || edu_form.controls.courseNameCtrl.touched)}" formControlName="courseNameCtrl" placeholder="" id="" class="form-control">-->
            <mat-form-field id="selectLine">
              <mat-select ngModel="{{course_name}}" name="coursename" formControlName="courseNameCtrl" disabled>
                  <mat-option value="{{course.CourseShortForm}}" *ngFor="let course of course_data">{{course.CourseName}}</mat-option>
              </mat-select>
            </mat-form-field>
            <span *ngIf="courseValidation===false" style="color:red;">Please select College Year.</span>  
          </div>
          <div class="col-md-2" style="padding-left: 9%;">Enter Seat Number: </div>
            <div class="col-md-2" style="padding-left: 5%;" *ngIf="college_year=='First' || college_year=='Second'" >
                <input style = 'width: 80% !important;' ngModel="{{edu_data?.seat_number ? edu_data?.seat_number : seat_number}}" nbInput type="text" [ngClass]="{'form-control-danger': edu_form.controls.seatNumberCtrl.invalid && (edu_form.controls.seatNumberCtrl.dirty || edu_form.controls.seatNumberCtrl.touched)}" formControlName="seatNumberCtrl"  placeholder="Enter Seat No."  id="" class="form-control">
            </div>
            <div class="col-md-2" *ngIf="college_year=='Third'">
              <input style = 'width: 80% !important;' ngModel="{{edu_data?.seat_number ? edu_data?.seat_number : mu_seat_number}}" nbInput type="text" [ngClass]="{'form-control-danger': edu_form.controls.seatNumberCtrl.invalid && (edu_form.controls.seatNumberCtrl.dirty || edu_form.controls.seatNumberCtrl.touched)}" formControlName="seatNumberCtrl"  placeholder="Enter Seat No."  id="" class="form-control">
            </div>          
        </div>
        <div class="row">
          <div class="col-md-3">College Year : </div>
          <div class="col-md-2">
            <mat-form-field id="selectLine" >
              <mat-select ngModel="{{college_year}}" name="collegeYear" formControlName="collegeYearCtrl" disabled>
              <mat-option *ngIf="edu_level == 'Degree' || edu_level == 'Master' || edu_level == 'Bachelor'" value="First">First</mat-option>
              <mat-option *ngIf="edu_level == 'Degree' || edu_level == 'Master' || edu_level == 'Bachelor'" value="Second">Second</mat-option>
              <mat-option *ngIf="edu_level == 'Degree' || edu_level == 'Bachelor'" value="Third">Third</mat-option>
                  <!-- <mat-option value="Fourth">Fourth</mat-option> -->
              </mat-select>
            </mat-form-field>
            <span *ngIf="collegeYearValidation===false" style="color:red;">Please select College Year.</span> 
          </div>
          <div class="col-md-3"  style="padding-left: 9%;"> Semester : </div>
          <div class="col-md-2"  style="padding-left: 5%;">
              <mat-form-field id="selectLine" >
                  <mat-select ngModel="{{semester_auto}}" name="semester" formControlName="semesterCtrl">
                  <mat-option *ngIf="edu_form.controls['collegeYearCtrl'].value==='First'" value="I">I</mat-option>
                  <mat-option *ngIf="edu_form.controls['collegeYearCtrl'].value==='First'" value="II">II</mat-option>
                  <mat-option *ngIf="edu_form.controls['collegeYearCtrl'].value==='Second'" value="III">III</mat-option>
                  <mat-option *ngIf="edu_form.controls['collegeYearCtrl'].value==='Second'" value="IV">IV</mat-option>
                  <mat-option *ngIf="edu_form.controls['collegeYearCtrl'].value==='Third'" value="V">V</mat-option>
                  <mat-option *ngIf="edu_form.controls['collegeYearCtrl'].value==='Third'" value="VI">VI</mat-option>
                   <!--   <mat-option value="VII">VII</mat-option>
                      <mat-option value="VIII">VIII</mat-option> -->
                  </mat-select>
              </mat-form-field>
              <span *ngIf="semesterValidation===false" style="color:red;">Please select semester</span> 
          </div>
      </div>
      <div class="row">
          <div class="col-md-3">Month : </div>
          <div class="col-md-2">
            <mat-form-field id="selectLine" >
              <mat-select  ngModel="{{edu_data?.Month}}" name="month" formControlName="monthCtrl">
                <mat-option value="January">January</mat-option>
                <mat-option value="February">February</mat-option>
                <mat-option value="March">March</mat-option>
                <mat-option value="April">April</mat-option>
                <mat-option value="May">May</mat-option>
                <mat-option value="June">June</mat-option>
                <mat-option value="July">July</mat-option>
                <mat-option value="August">August</mat-option>
                <mat-option value="September">September</mat-option>
                <mat-option value="October">October</mat-option>
                <mat-option value="November">November</mat-option>
                <mat-option value="December">December</mat-option>
              </mat-select>
            </mat-form-field>
            <span *ngIf="monthValidation===false" style="color:red;">Please select month</span> 
          </div>
          
          <div class="col-md-3"  style="padding-left: 9%;">Year : </div>
          <div class="col-md-2"  style="padding-left: 5%;">
              <mat-form-field id="selectLine" >
              <mat-select ngModel="{{enrollment_year}}" name="year" formControlName="yearCtrl">
              <mat-option value="{{years}}" *ngFor="let years of enrollYear">{{years}}</mat-option>
                  </mat-select>
              </mat-form-field>
              <span *ngIf="yearValidation===false" style="color:red;">Please select year.</span> 
          </div>
         </div>
         <div class="row">
         <div class="col-md-3" >Result : </div>
          <div class="col-md-2" >
          <mat-form-field id = 'selectLine'>
            <mat-select formControlName="resultCtrl" ngModel="{{edu_data?.result}}">
            <!-- <input type="text" style="width:100% !important;" ngModel="{{edu_data?.remarks}}"  formControlName="resultCtrl" placeholder="Remarks" > -->
              <mat-option value = 'DISTINCTION'>DISTINCTION</mat-option>
              <mat-option value = 'SUCCESSFUL'>SUCCESSFUL</mat-option>
              <mat-option value = 'PASSES'>PASSES</mat-option>
              <mat-option value = 'FIRST CLASS'>FIRST CLASS</mat-option>
              <mat-option value = 'SECOND CLASS'>SECOND CLASS</mat-option>
              <mat-option value = ''>NONE</mat-option>
            </mat-select>
            </mat-form-field>
          <!-- <input  ngModel="{{edu_data?.final_grade_special_instruction}}" nbInput type="text" formControlName="finalgradespecialInstrctionCtrl" placeholder="" id="" class="form-control"> -->
          </div>

          <div class="col-md-3"  style="padding-left: 9%;" *ngIf="admin_show == 'true' && stillStudy == 'yes'"> Still Studying Month : </div>
          <div class="col-md-2"  style="padding-left: 5%;" *ngIf="admin_show == 'true' && stillStudy == 'yes'">
            <mat-form-field id="selectLine" >
              <mat-select  ngModel="{{edu_data?.stillStdMonth}}" name="stillStdMonth" formControlName="stlStdmonthCtrl">
                <mat-option value="January">January</mat-option>
                <mat-option value="February">February</mat-option>
                <mat-option value="March">March</mat-option>
                <mat-option value="April">April</mat-option>
                <mat-option value="May">May</mat-option>
                <mat-option value="June">June</mat-option>
                <mat-option value="July">July</mat-option>
                 
                <mat-option value="August">August</mat-option>
                <mat-option value="September">September</mat-option>
                <mat-option value="October">October</mat-option>
                <mat-option value="November">November</mat-option>
                <mat-option value="December">December</mat-option>
              </mat-select>
            </mat-form-field>
            <span *ngIf="monthValidation===false" style="color:red;">Please select month</span> 
          </div>

          <div class="col-md-3" style="padding-left: 9%;" *ngIf="(edu_form.controls['collegeYearCtrl'].value==='Third' && (edu_form.controls['courseNameCtrl'].value=='B.M.M.'  || edu_form.controls['courseNameCtrl'].value=='B.M.S.' ) ) || (edu_form.controls['courseNameCtrl'].value=='M.Com' &&  edu_form.controls['collegeYearCtrl'].value==='Second')">
          Specialization in(subject) : </div>
        <div class="col-md-2" style="padding-left: 5%;" >
          <mat-form-field id="selectLine" *ngIf="(edu_form.controls['collegeYearCtrl'].value==='Third' && (edu_form.controls['courseNameCtrl'].value=='B.M.M.'  || edu_form.controls['courseNameCtrl'].value=='B.M.S.' ) ) || (edu_form.controls['courseNameCtrl'].value=='M.Com' &&  edu_form.controls['collegeYearCtrl'].value==='Second')"> 
            <mat-select  ngModel="{{specialisation_name}}"  name="specialisationname" formControlName="SpecialisationCtrl" disabled>
                <mat-option value="{{specialisation.specialisation_name}}" *ngFor="let specialisation of specialisation_data">{{specialisation.specialisation_name}}</mat-option>
            </mat-select>
          </mat-form-field>
         </div>
        </div>
        <div class="row">
        <!-- <div class="col-md-2" *ngIf="admin_show == 'true'"  >Start Month : </div>
        <div class="col-md-2" *ngIf="admin_show == 'true'">
          <mat-form-field id="selectLine" >
            <mat-select  ngModel="{{edu_data?.endmonth}}" name="month" formControlName="endmonthCtrl">
                <mat-option value="January">January</mat-option>
                <mat-option value="February">February</mat-option>
                <mat-option value="March">March</mat-option>
                <mat-option value="April">April</mat-option>
                <mat-option value="May">May</mat-option>
                <mat-option value="June">June</mat-option>
                <mat-option value="July">July</mat-option>
                <mat-option value="August">August</mat-option>
                <mat-option value="September">September</mat-option>
                <mat-option value="October">October</mat-option>
                <mat-option value="November">November</mat-option>
                <mat-option value="December">December</mat-option>
            </mat-select>
          </mat-form-field>
         
        </div>  -->

        <div class="col-md-2"  *ngIf="admin_show == 'true'" >Academic Year Start from : </div>
      <div class="col-md-2" style="padding-left: 9%;" *ngIf="admin_show == 'true'" >
          <mat-form-field id="selectLine" >
          <mat-select style="padding-left: 9%;" ngModel="{{edu_data?.endYear}}" name="year" formControlName="endyearCtrl">
          <mat-option value="{{years}}" *ngFor="let years of enrollYear">{{years}}</mat-option>
              </mat-select>
          </mat-form-field> 
      </div>

        <div class="col-md-2" style="padding-left: 10%;" *ngIf="admin_show == 'true'" >To Academic Year : </div>
        <div class="col-md-2" style="padding-left: 9%;" *ngIf="admin_show == 'true'" >
            <mat-form-field id="selectLine" >
            <mat-select style="padding-left: 9%;" ngModel="{{edu_data?.startYear}}" name="year" formControlName="startyearCtrl">
            <mat-option value="{{years}}" *ngFor="let years of enrollYear">{{years}}</mat-option>
                </mat-select>
            </mat-form-field> 
        </div>
       </div>
         <marquee *ngIf="admin_show == 'false'"><u><b  style="color:red; font-size: 18px;">Please input the educational details exactly as per your marksheets, or else your application will be rejected</b></u></marquee>
      <div class="row">
      <div class="col-md-1"></div>
      <div class="col-md-2">Course Code</div>
      <div class="col-md-2">Subject Name</div>
      <div class="col-md-1" style="padding-left :63px" *ngIf="edu_form.controls['semesterCtrl'].value!='IV' && edu_form.controls['courseNameCtrl'].value=='M.Com'">Course Credits</div>
      <div class="col-md-1" style="padding-left :69px" *ngIf="edu_form.controls['semesterCtrl'].value!='IV' && edu_form.controls['courseNameCtrl'].value=='M.Com'">TH</div>
      <div class="col-md" style="padding-left :60px" *ngIf="edu_form.controls['semesterCtrl'].value!='IV' && edu_form.controls['courseNameCtrl'].value=='M.Com'">IA</div>
      <div class="col-md-1" style="padding-left :63px" *ngIf="edu_form.controls['semesterCtrl'].value=='IV' && edu_form.controls['courseNameCtrl'].value=='M.Com'">Internal</div>
          <div class="col-md-1" style="padding-left :69px" *ngIf="edu_form.controls['semesterCtrl'].value=='IV' && edu_form.controls['courseNameCtrl'].value=='M.Com'">Sem. End</div> 
          <div class="col-md" style="padding-left :60px" *ngIf="edu_form.controls['semesterCtrl'].value=='IV' && edu_form.controls['courseNameCtrl'].value=='M.Com'">Total</div>
      <div class="col-md">Grades Obtained </div>
      <div class="col-md">Credits Earned (C)</div>
      <div class="col-md">Grade points (G)</div>
      <div class="col-md">C * G</div>
      </div>
      <br>
      <div class="row">
        <div class="col-md-1">Subject 1 :</div>
        <div class="col-md-1">
            <div class="row"   *ngIf="  edu_data?.course_code_first != null && edu_data?.course_code_first != '' &&  edu_data?.course_code_first != undefined &&  showcodeDropdown == false  "   >
              <input disabled formControlName = "courseEdit1Ctrl" style="width: 150px;" [value]="edu_data?.course_code_first" nbInput type="text"  id=""  />
            </div>  
            <mat-form-field [formGroup]="formData" *ngIf="showcodeDropdown == true " style="width:150px;">
             
              <mat-select placeholder="Course Code" #singleSelect>
                <mat-option>
                  <ngx-mat-select-search [formControl]="filterInput2" [placeholderLabel]="'Course Code...'">
                    <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
                  </ngx-mat-select-search>
                </mat-option>
                <mat-option *ngFor="
                                      let college2 of course_code2
                                        | filter: { Course_code: filterText2 }
                                     " [value]="college2" (click)="getCourse(college2)">
                  {{ college2.Course_code }}
                </mat-option>
              </mat-select>
                </mat-form-field>
            
            <br>
            <div class="row">
              Can't Find ? &nbsp; <i class="fas fa-phone-square fa-lg" title="Contact" style="color: green;" (click)= "showContactDetails()"></i>
              <i class="fas fa-pen-alt fa-lg" *ngIf="admin_show == 'true'"  (click)="showcoursecodeDropdown()"></i>
              
            </div>
          </div>
          <div class="col-md-2">
            <div  *ngIf= "edu_data?.Subject_First != null && edu_data?.Subject_First != '' && edu_data?.Subject_First != undefined && showcodeDropdown == false">
              <textarea disabled nbInput formControlName = 'subjectEditFirstCtrl'  [value]="edu_data?.Subject_First" style="width: 210px; margin-left: 50px;" nbInput type="text" id="" ></textarea>
             
            </div>
            
          

            <mat-form-field appearance="outline"  style="width: 210px; margin-left: 50px;" [formGroup]="formData" *ngIf = "showcodeDropdown == true">
              <mat-select ngModel="{{ edu_data?.Subject_First }}" name="semester" formControlName="subjectFirstCtrl" [ngClass]="{
                                    'form-control-danger':
                                      edu_form.controls.subjectFirstCtrl.invalid &&
                                      (edu_form.controls.subjectFirstCtrl.dirty ||
                                        edu_form.controls.subjectFirstCtrl.touched)
                                  }">
                <mat-option *ngFor="let course of subjectArray" value="{{ course.Course_Subject_name }}">{{ course.Course_Subject_name }}</mat-option>
              </mat-select>
            </mat-form-field>

        </div>
        &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <div class="col-md" *ngIf = "edu_form.controls['semesterCtrl'].value=='IV' && edu_form.controls['courseNameCtrl'].value=='M.Com'">
            <input style = 'width: 80% !important; ' ngModel="{{edu_data?.internal_Marks_one}}" nbInput type="text"  formControlName="internalMarksCtrl"  placeholder="Internal" id="" class="form-control">
          </div>

          <div class="col-md" *ngIf = "edu_form.controls['semesterCtrl'].value=='IV' && edu_form.controls['courseNameCtrl'].value=='M.Com'">
            <input style = 'width: 80% !important; ' ngModel="{{edu_data?.sem_end_first}}" nbInput type="text"  formControlName="semEndFirstCtrl" (change)="myFunc()"  placeholder="Sem. End" id="" class="form-control">
          </div>
          <div class="col-md" *ngIf = "edu_form.controls['semesterCtrl'].value=='IV' && edu_form.controls['courseNameCtrl'].value=='M.Com'">
            <input style = 'width: 80% !important; ' ngModel="{{totalValue ? totalValue :edu_data?.marks_obt_First}}" nbInput type="text" [ngClass]="{'form-control-danger': edu_form.controls.markObtFirstCtrl.invalid && (edu_form.controls.markObtFirstCtrl.dirty || edu_form.controls.markObtFirstCtrl.touched)}" formControlName="markObtFirstCtrl" (change) = "totalsMarksObtained()" placeholder="Marks Obtained" id="" class="form-control">
          </div>
        <div class="col-md" *ngIf = "edu_form.controls['semesterCtrl'].value!='IV' && edu_form.controls['courseNameCtrl'].value=='M.Com'"><input style = 'width: 80% !important; '  ngModel="{{edu_data?.course_credits_first}}" nbInput type="text" [ngClass]="{'form-control-danger': edu_form.controls.courseCreditsFirstCtrl.invalid && (edu_form.controls.courseCreditsFirstCtrl.dirty || edu_form.controls.courseCreditsFirstCtrl.touched)}" formControlName="courseCreditsFirstCtrl" placeholder="Course Credits" (change)='getTotalCourseCredits()' id="" class="form-control"></div>
        <div class="col-md" *ngIf = "edu_form.controls['semesterCtrl'].value!='IV' && edu_form.controls['courseNameCtrl'].value=='M.Com'"><input style = 'width: 80% !important; ' ngModel="{{edu_data?.th_first}}" nbInput type="text" [ngClass]="{'form-control-danger': edu_form.controls.thFirstCtrl.invalid && (edu_form.controls.thFirstCtrl.dirty || edu_form.controls.thFirstCtrl.touched)}" formControlName="thFirstCtrl" placeholder="TH" id="" class="form-control"></div>
        <div class="col-md" *ngIf = "edu_form.controls['semesterCtrl'].value!='IV' && edu_form.controls['courseNameCtrl'].value=='M.Com'"><input style = 'width: 80% !important; ' ngModel="{{edu_data?.ia_first}}" nbInput type="text"  formControlName="iaFirstCtrl" placeholder="IA" id="" class="form-control"></div>
        <div class="col-md"><input style = 'width: 80% !important; ' ngModel="{{edu_data?.grade_First}}" nbInput type="text" [ngClass]="{'form-control-danger': edu_form.controls.gradeFirstCtrl.invalid && (edu_form.controls.gradeFirstCtrl.dirty || edu_form.controls.gradeFirstCtrl.touched)}" formControlName="gradeFirstCtrl" placeholder="Grades Obtained" id="" class="form-control"></div>
        <div class="col-md"><input style = 'width: 80% !important; ' ngModel="{{edu_data?.credits_Earned_c_First ? edu_data?.credits_Earned_c_First : this.edu_form.controls.courseCreditsFirstCtrl.value}}" nbInput type="text" [ngClass]="{'form-control-danger': edu_form.controls.creditsEarnedCFirstCtrl.invalid && (edu_form.controls.creditsEarnedCFirstCtrl.dirty || edu_form.controls.creditsEarnedCFirstCtrl.touched)}" formControlName="creditsEarnedCFirstCtrl" placeholder="Credits Earned C" (change)='getTotalCredits()' id="" class="form-control"></div>
        <div class="col-md"><input style = 'width: 80% !important; ' ngModel="{{edu_data?.grade_points_First}}" nbInput type="text" [ngClass]="{'form-control-danger': edu_form.controls.gradepointsFirstCtrl.invalid && (edu_form.controls.gradepointsFirstCtrl.dirty || edu_form.controls.gradepointsFirstCtrl.touched)}" formControlName="gradepointsFirstCtrl" placeholder="Grade points G" id="" class="form-control"></div>
        <div class="col-md"><input style = 'width: 80% !important; ' ngModel="{{edu_data?.grade_credits_First}}" nbInput type="text" [ngClass]="{'form-control-danger': edu_form.controls.gradecreditsFirstCtrl.invalid && (edu_form.controls.gradecreditsFirstCtrl.dirty || edu_form.controls.gradecreditsFirstCtrl.touched)}" formControlName="gradecreditsFirstCtrl" placeholder="C * G" (change)='getTotalCnG()' id="" class="form-control"></div>
        
      </div>
      <div class="row">
      <div class="col-md-1">Subject 2 :</div>
      <div class="col-md-1">
        <div class="row"  *ngIf=" edu_data?.course_code_second != null && edu_data?.course_code_second != '' && edu_data?.course_code_second != undefined && showcodeDropdown2 == false " >
          <input disabled formControlName = 'courseEdit2Ctrl' [value]="edu_data?.course_code_second" style="width: 150px;" nbInput type="text" id="" />
          
        </div>
        <!-- <div class="row" *ngIf="showcodeDropdown2 == false">
          <i  class="fas fa-pen-alt fa-2x" (click)="showcoursecodeDropdown2()"  ></i>
        </div>     -->
          <mat-form-field [formGroup]="formData" *ngIf="showcodeDropdown2 == true" style="width:100px;" >
            <mat-select placeholder="Course Code" #singleSelect2>
              <mat-option>
                <ngx-mat-select-search [formControl]="filterInput" [placeholderLabel]="'Course Code...'">
                  <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
                </ngx-mat-select-search>
              </mat-option>
              <mat-option *ngFor="
                              let college of course_code
                                | filter: { Course_code: filterText }
                            " [value]="college" (click)="getCourse2(college)">
                {{ college.Course_code }}
              </mat-option>
            </mat-select>
        </mat-form-field>
        
        <br>
        <div class="row">
          Can't Find ? &nbsp; <i class="fas fa-phone-square fa-lg" title="Contact" style="color: green;" (click)= "showContactDetails()"></i>
          <i class="fas fa-pen-alt fa-lg" *ngIf="admin_show == 'true'"  (click)="showcoursecodeDropdown2()"></i>
          <i class="fas fa-pen-alt fa-lg" *ngIf="admin_show == 'false'" (click)="editDropdown2()"></i>
        </div>
       </div>
      <div class="col-md-2">
        <div  *ngIf= "edu_data?.Subject_Second != null && edu_data?.Subject_Second != '' && edu_data?.Subject_Second != undefined && showcodeDropdown2 == false">
          <textarea disabled nbInput formControlName="subjectEditSecondCtrl"  [value]="edu_data?.Subject_Second" style="width: 210px; margin-left: 50px;" nbInput type="text" id="" ></textarea>
         
        </div>
        
      

        <mat-form-field appearance="outline"  style="width: 210px; margin-left: 50px;" [formGroup]="formData" *ngIf = "showcodeDropdown2 == true">
          <mat-select ngModel="{{ edu_data?.Subject_Second }}" name="semester" formControlName="subjectSecondCtrl" [ngClass]="{
                                'form-control-danger':
                                  edu_form.controls.subjectSecondCtrl.invalid &&
                                  (edu_form.controls.subjectSecondCtrl.dirty ||
                                    edu_form.controls.subjectSecondCtrl.touched)
                              }">
            <mat-option *ngFor="let course of subjectArray2" value="{{ course.Course_Subject_name }}">{{
              course.Course_Subject_name }}</mat-option>
          </mat-select>
        </mat-form-field>
  </div>
      &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <div class="col-md" *ngIf = "edu_form.controls['semesterCtrl'].value=='IV' && edu_form.controls['courseNameCtrl'].value=='M.Com'">
          <input style = 'width: 80% !important; ' ngModel="{{edu_data?.internal_Marks_two}}" nbInput type="text"  formControlName="internalMarksSecondCtrl"  placeholder="Internal" id="" class="form-control">
        </div>

        <div class="col-md" *ngIf = "edu_form.controls['semesterCtrl'].value=='IV' && edu_form.controls['courseNameCtrl'].value=='M.Com'">
          <input style = 'width: 80% !important; ' ngModel="{{edu_data?.sem_end_second}}" nbInput type="text"  formControlName="semEndSecondCtrl" (change)="myFunc()"  placeholder="Sem. End" id="" class="form-control">
        </div>
        <div class="col-md" *ngIf = "edu_form.controls['semesterCtrl'].value=='IV' && edu_form.controls['courseNameCtrl'].value=='M.Com'">
          <input style = 'width: 80% !important; ' ngModel="{{totalValue2 ? totalValue2 :edu_data?.marks_obt_Second}}" nbInput type="text" formControlName="markObtSecondCtrl" (change) = "totalsMarksObtainedMyFunc()" placeholder="Marks Obtained" id="" class="form-control">
        </div>
      <div class="col-md" *ngIf = "edu_form.controls['semesterCtrl'].value!='IV' && edu_form.controls['courseNameCtrl'].value=='M.Com'"><input style = 'width: 80% !important; ' ngModel="{{edu_data?.course_credits_second}}" nbInput type="text"  formControlName="courseCreditsSecondCtrl" placeholder="Course Credits" (change)='getTotalCourseCredits()' id="" class="form-control"></div>
      <div class="col-md" *ngIf = "edu_form.controls['semesterCtrl'].value!='IV' && edu_form.controls['courseNameCtrl'].value=='M.Com'"><input style = 'width: 80% !important; ' ngModel="{{edu_data?.th_second}}" nbInput type="text"  formControlName="thSecondCtrl" placeholder="TH" id="" class="form-control"></div>
      <div class="col-md" *ngIf = "edu_form.controls['semesterCtrl'].value!='IV' && edu_form.controls['courseNameCtrl'].value=='M.Com'"><input style = 'width: 80% !important; ' ngModel="{{edu_data?.ia_second}}" nbInput type="text"  formControlName="iaSecondCtrl" placeholder="IA" id="" class="form-control"></div>
      <div class="col-md"><input style = 'width: 80% !important; ' ngModel="{{edu_data?.grade_Second}}" nbInput type="text" formControlName="gradeSecondCtrl" placeholder="Grades Obtained" id="" class="form-control"></div>
      <div class="col-md"><input style = 'width: 80% !important; ' ngModel="{{edu_data?.credits_Earned_c_Second ? edu_data?.credits_Earned_c_Second : this.edu_form.controls.courseCreditsSecondCtrl.value}}" nbInput type="text"  formControlName="creditsEarnedCSecondCtrl" placeholder="Credits Earned C" (change)='getTotalCredits()' id="" class="form-control"></div>
      <div class="col-md"><input style = 'width: 80% !important; ' ngModel="{{edu_data?.grade_points_Second}}" nbInput type="text"  formControlName="gradepointsSecondCtrl" placeholder="Grade points G" id="" (change)='getTotalCnG()' class="form-control"></div>
      <div class="col-md"><input style = 'width: 80% !important; ' ngModel="{{edu_data?.grade_credits_Second}}" nbInput type="text"  formControlName="gradecreditsSecondCtrl" placeholder="C * G"  id="" class="form-control"></div>
              
    </div>
    <div class="row">
      <div class="col-md-1">Subject 3 :</div>
      <div class="col-md-1">
        <div class="row"  *ngIf=" edu_data?.course_code_third != null && edu_data?.course_code_third != '' && edu_data?.course_code_third != undefined && showcodeDropdown3 == false " >
          <input disabled formControlName = 'courseEdit3Ctrl' [value]="edu_data?.course_code_third" style="width: 150px;" nbInput type="text" id="" />
          <!-- <i class="fas fa-pen-alt fa-2x"  (click)="showcoursecodeDropdown3()"></i> -->
        </div>
      <mat-form-field [formGroup]="formData" *ngIf="showcodeDropdown3 == true" style="width:100px;" >
          <mat-select  placeholder="Course Code" #singleSelect2 >
            <mat-option>
              <ngx-mat-select-search  [formControl]="filterInput3"  [placeholderLabel]="'Course Code...'">
                <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
              </ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor=" let college of course_code3 | filter: { Course_code: filterText3 } " [value]="college" (click)="getCourse3(college)" >
              {{ college.Course_code }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        
        <br>
        <div class="row">
          Can't Find ? &nbsp; <i class="fas fa-phone-square fa-lg" title="Contact" style="color: green;" (click)= "showContactDetails()"></i>
          <i class="fas fa-pen-alt fa-lg" *ngIf="admin_show == 'true'"  (click)="showcoursecodeDropdown3()"></i>
          
        </div>
      </div>
      <div class="col-md-2" >
        <div  *ngIf= "edu_data?.Subject_Third != null && edu_data?.Subject_Third != '' && edu_data?.Subject_Third != undefined && showcodeDropdown3 == false">
          <textarea disabled nbInput formControlName = 'subjectEditThirdCtrl'  [value]="edu_data?.Subject_Third" style="width: 210px; margin-left: 50px;" nbInput type="text" id="" ></textarea>
          
        </div>


        <mat-form-field appearance="outline"  style="width: 210px; margin-left: 50px;" [formGroup]="formData" *ngIf = "showcodeDropdown3 == true">
          <mat-select ngModel="{{ edu_data?.Subject_Third }}" name="semester" formControlName="subjectThirdCtrl" [ngClass]="{
                                'form-control-danger':
                                  edu_form.controls.subjectThirdCtrl.invalid &&
                                  (edu_form.controls.subjectThirdCtrl.dirty ||
                                    edu_form.controls.subjectThirdCtrl.touched)
                              }">
            <mat-option *ngFor="let course of subjectArray3" value="{{ course.Course_Subject_name }}">{{
              course.Course_Subject_name }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <div class="col-md" *ngIf = "edu_form.controls['semesterCtrl'].value==='IV' && edu_form.controls['courseNameCtrl'].value=='M.Com'">
          <input style = 'width: 80% !important; ' ngModel="{{edu_data?.internal_Marks_three}}" nbInput type="text"  formControlName="internalMarksThirdCtrl"  placeholder="Internal" id="" class="form-control">
        </div>

        <div class="col-md" *ngIf = "edu_form.controls['semesterCtrl'].value==='IV' && edu_form.controls['courseNameCtrl'].value=='M.Com'">
          <input style = 'width: 80% !important; ' ngModel="{{edu_data?.sem_end_third}}" nbInput type="text"  formControlName="semEndThirdCtrl" (change)="myFunc()"  placeholder="Sem. End" id="" class="form-control">
        </div>
        <div class="col-md" *ngIf = "edu_form.controls['semesterCtrl'].value==='IV' && edu_form.controls['courseNameCtrl'].value=='M.Com'">
          <input style = 'width: 80% !important; ' ngModel="{{totalValue3 ? totalValue3 :edu_data?.marks_obt_Third}}" nbInput type="text" formControlName="markObtThirdCtrl" (change) = "totalsMarksObtainedMyFunc()" placeholder="Marks Obtained" id="" class="form-control">
        </div>
      <div class="col-md" *ngIf = "edu_form.controls['semesterCtrl'].value!='IV' && edu_form.controls['courseNameCtrl'].value=='M.Com'"><input style = 'width: 80% !important; ' ngModel="{{edu_data?.course_credits_third}}" nbInput type="text"  formControlName="courseCreditsThirdCtrl" placeholder="Course Credits" (change)='getTotalCourseCredits()' id="" class="form-control"></div>
      <div class="col-md" *ngIf = "edu_form.controls['semesterCtrl'].value!='IV' && edu_form.controls['courseNameCtrl'].value=='M.Com'"><input style = 'width: 80% !important; ' ngModel="{{edu_data?.th_third}}" nbInput type="text"  formControlName="thThirdCtrl" placeholder="TH" id="" class="form-control"></div>
      <div class="col-md" *ngIf = "edu_form.controls['semesterCtrl'].value!='IV' && edu_form.controls['courseNameCtrl'].value=='M.Com'"><input style = 'width: 80% !important; ' ngModel="{{edu_data?.ia_third}}" nbInput type="text"  formControlName="iaThirdCtrl" placeholder="IA" id="" class="form-control"></div>
      <div class="col-md"><input style = 'width: 80% !important; ' ngModel="{{edu_data?.grade_Third}}" nbInput type="text"  formControlName="gradeThirdCtrl" placeholder="Grades Obtained" id="" class="form-control"></div>
      <div class="col-md"><input style = 'width: 80% !important; ' ngModel="{{edu_data?.credits_Earned_c_Third ? edu_data?.credits_Earned_c_Third : this.edu_form.controls.courseCreditsThirdCtrl.value}}" nbInput type="text"  formControlName="creditsEarnedCThirdCtrl" placeholder="Credits Earned C" (change)='getTotalCredits()' id="" class="form-control"></div>
      <div class="col-md"><input style = 'width: 80% !important; ' ngModel="{{edu_data?.grade_points_Third}}" nbInput type="text"  formControlName="gradepointsThirdCtrl" placeholder="Grade points G" id="" (change)='getTotalCnG()' class="form-control"></div>
      <div class="col-md"><input style = 'width: 80% !important; ' ngModel="{{edu_data?.grade_credits_Third}}" nbInput type="text"  formControlName="gradecreditsThirdCtrl" placeholder="C * G"  id="" class="form-control"></div>

    </div>
    <div class="row">
      <div class="col-md-1">Subject 4 :</div>
      <div class="col-md-1">
        <div class="row" *ngIf=" edu_data?.course_code_fourth != null && edu_data?.course_code_fourth != '' && edu_data?.course_code_fourth != undefined &&  showcodeDropdown4 == false " >
          <input disabled formControlName = 'courseEdit4Ctrl' [value]="edu_data?.course_code_fourth"  style="width: 150px;" nbInput type="text" id="" />
          <!-- <i class="fas fa-pen-alt fa-2x" (click)="showcoursecodeDropdown4()" ></i> -->
        </div>
         <mat-form-field [formGroup]="formData" *ngIf="showcodeDropdown4 == true" style="width:100px;" >
          <mat-select placeholder="Course Code"  #singleSelect2  >
            <mat-option>
              <ngx-mat-select-search  [formControl]="filterInput4"  [placeholderLabel]="'Course Code...'" >
                <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
              </ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor=" let college of course_code4 | filter: { Course_code: filterText4 } " [value]="college"  (click)="getCourse4(college)" >
              {{ college.Course_code }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        
        <br>
        <div class="row">
          Can't Find ? &nbsp; <i class="fas fa-phone-square fa-lg" title="Contact" style="color: green;" (click)= "showContactDetails()"></i>
          <i class="fas fa-pen-alt fa-lg" *ngIf="admin_show == 'true'"  (click)="showcoursecodeDropdown4()"></i>
          
        </div> 
      </div>
      <div class="col-md-2" >
        <div  *ngIf= "edu_data?.Subject_Fourth != null && edu_data?.Subject_Fourth != '' && edu_data?.Subject_Fourth != undefined && showcodeDropdown4 == false">
          <textarea disabled nbInput  formControlName = 'subjectEditFourthCtrl'  [value]="edu_data?.Subject_Fourth" style="width: 210px; margin-left: 50px;" nbInput type="text" id="" ></textarea>
         
        </div>

        <mat-form-field appearance="outline" style="width: 210px; margin-left: 50px;" [formGroup]="formData" *ngIf = "showcodeDropdown4 == true">
          <mat-select
                  ngModel="{{ edu_data?.Subject_Fourth }}"
                  name="semester"
                  formControlName="subjectFourthCtrl"
                  [ngClass]="{
                    'form-control-danger':
                      edu_form.controls.subjectFourthCtrl.invalid &&
                      (edu_form.controls.subjectFourthCtrl.dirty ||
                        edu_form.controls.subjectFourthCtrl.touched)
                  }"
                >
                  <mat-option
                    *ngFor="let course of subjectArray4"
                    value="{{ course.Course_Subject_name }}"
                    >{{ course.Course_Subject_name }}</mat-option
                  >
                </mat-select>
        </mat-form-field>
   
        <!-- <textarea  ngModel="{{edu_data?.Subject_Fourth}}" nbInput type="text" [ngClass]="{'form-control-danger': edu_form.controls.subjectFourthCtrl.invalid && (edu_form.controls.subjectFourthCtrl.dirty || edu_form.controls.subjectFourthCtrl.touched)}" formControlName="subjectFourthCtrl" placeholder="name" id="" class="form-control"></textarea> -->
      </div>
      &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <div class="col-md" *ngIf = "edu_form.controls['semesterCtrl'].value=='IV' && edu_form.controls['courseNameCtrl'].value=='M.Com'">
          <input style = 'width: 80% !important; ' ngModel="{{edu_data?.internal_Marks_four}}" nbInput type="text"  formControlName="internalMarksFourthCtrl"  placeholder="Internal" id="" class="form-control">
        </div>

        <div class="col-md" *ngIf = "edu_form.controls['semesterCtrl'].value=='IV' && edu_form.controls['courseNameCtrl'].value=='M.Com'">
          <input style = 'width: 80% !important; ' ngModel="{{edu_data?.sem_end_fourth}}" nbInput type="text"  formControlName="semEndFourthCtrl" (change)="myFunc()"  placeholder="Sem. End" id="" class="form-control">
        </div>
        <div class="col-md" *ngIf = "edu_form.controls['semesterCtrl'].value=='IV' && edu_form.controls['courseNameCtrl'].value=='M.Com'">
          <input style = 'width: 80% !important; ' ngModel="{{totalValue4 ? totalValue4 :edu_data?.marks_obt_Fourth}}" nbInput type="text" formControlName="markObtFourthCtrl" (change) = "totalsMarksObtainedMyFunc()" placeholder="Marks Obtained" id="" class="form-control">
        </div>
      <div class="col-md" *ngIf = "edu_form.controls['semesterCtrl'].value!='IV' && edu_form.controls['courseNameCtrl'].value=='M.Com'"><input style = 'width: 80% !important; ' ngModel="{{edu_data?.course_credits_fourth}}" nbInput type="text"  formControlName="courseCreditsFourthCtrl" placeholder="Course Credits" (change)='getTotalCourseCredits()' id="" class="form-control"></div>
      <div class="col-md" *ngIf = "edu_form.controls['semesterCtrl'].value!='IV' && edu_form.controls['courseNameCtrl'].value=='M.Com'"><input style = 'width: 80% !important; ' ngModel="{{edu_data?.th_fourth}}" nbInput type="text"   formControlName="thFourthCtrl" placeholder="TH" id="" class="form-control"></div>
      <div class="col-md" *ngIf = "edu_form.controls['semesterCtrl'].value!='IV' && edu_form.controls['courseNameCtrl'].value=='M.Com'"><input style = 'width: 80% !important; ' ngModel="{{edu_data?.ia_fourth}}" nbInput type="text"  formControlName="iaFourthCtrl" placeholder="IA" id="" class="form-control"></div>
      <div class="col-md"><input style = 'width: 80% !important; ' ngModel="{{edu_data?.grade_Fourth}}" nbInput type="text"  formControlName="gradeFourthCtrl" placeholder="Grades Obtained" id="" class="form-control"></div>
      <div class="col-md"><input style = 'width: 80% !important; ' ngModel="{{edu_data?.credits_Earned_c_Fourth ? edu_data?.credits_Earned_c_Fourth : this.edu_form.controls.courseCreditsFourthCtrl.value}}" nbInput type="text"  formControlName="creditsEarnedCFourthCtrl" placeholder="Credits Earned C" (change)='getTotalCredits()' id="" class="form-control"></div>
      <div class="col-md"><input style = 'width: 80% !important; ' ngModel="{{edu_data?.grade_points_Fourth}}" nbInput type="text"  formControlName="gradepointsFourthCtrl" placeholder="Grade points G" (change)='getTotalCnG()' id="" class="form-control"></div>
      <div class="col-md"><input style = 'width: 80% !important; ' ngModel="{{edu_data?.grade_credits_Fourth}}" nbInput type="text"  formControlName="gradecreditsFourthCtrl" placeholder="C * G" id="" class="form-control"></div>
          
    </div>
    <div class="row">
      <div class="col-md-1">Subject 5 :</div>
      <div class="col-md-1">
        <div class="row" *ngIf=" edu_data?.course_code_fifth != null &&  edu_data?.course_code_fifth != '' && edu_data?.course_code_fifth != undefined &&  showcodeDropdown5 == false" >
          <input disabled formControlName = 'courseEdit5Ctrl' [value]="edu_data?.course_code_fifth"  style="width: 150px;" nbInput type="text" id="" />
          <!-- <i class="fas fa-pen-alt fa-2x" (click)="showcoursecodeDropdown5()" ></i> -->
        </div>

        <mat-form-field [formGroup]="formData" *ngIf="showcodeDropdown5 == true" style="width:100px;" >
          <mat-select placeholder="Course Code" #singleSelect2 >
            <mat-option>
              <ngx-mat-select-search [formControl]="filterInput5" [placeholderLabel]="'Course Code...'" >
                <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
              </ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let college of course_code5  | filter: { Course_code: filterText5 } " [value]="college"  (click)="getCourse5(college)">
              {{ college.Course_code }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        
        <br>
        <div class="row">
          Can't Find ? &nbsp; <i class="fas fa-phone-square fa-lg" title="Contact" style="color: green;" (click)= "showContactDetails()"></i>
          <i class="fas fa-pen-alt fa-lg" *ngIf="admin_show == 'true'"  (click)="showcoursecodeDropdown5()"></i>
          
        </div> 
      </div>
      <div class="col-md-2" >
        <div  *ngIf= "edu_data?.Subject_Fifth != null && edu_data?.Subject_Fifth != '' && edu_data?.Subject_Fifth != undefined && showcodeDropdown5 == false">
          <textarea disabled nbInput formControlName = 'subjectEditFifthCtrl' [value]="edu_data?.Subject_Fifth"  style="width: 210px; margin-left: 50px;" nbInput type="text" id="" ></textarea>
       </div>
       
      <mat-form-field  appearance="outline"  style="width: 210px; margin-left: 50px;" [formGroup]="formData" *ngIf = "showcodeDropdown5 == true">
        <mat-select ngModel="{{ edu_data?.Subject_Fifth }}" name="semester" formControlName="subjectFifthCtrl" [ngClass]="{
                    'form-control-danger':
                      edu_form.controls.subjectFifthCtrl.invalid &&
                      (edu_form.controls.subjectFifthCtrl.dirty ||
                        edu_form.controls.subjectFifthCtrl.touched)
                  }">
          <mat-option *ngFor="let course of subjectArray5" value="{{ course.Course_Subject_name }}">{{
            course.Course_Subject_name }}</mat-option>
        </mat-select>
        </mat-form-field>
   
       <!-- <textarea  ngModel="{{edu_data?.Subject_Fifth}}" nbInput type="text"  formControlName="subjectFifthCtrl" placeholder="name" id="" class="form-control"></textarea> -->
      </div>
      &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <div class="col-md" *ngIf = "edu_form.controls['semesterCtrl'].value=='IV' && edu_form.controls['courseNameCtrl'].value=='M.Com'">
      <input style = 'width: 80% !important; ' ngModel="{{edu_data?.internal_Marks_five}}" nbInput type="text"  formControlName="internalMarksFifthCtrl"  placeholder="Internal" id="" class="form-control">
    </div>

    <div class="col-md" *ngIf = "edu_form.controls['semesterCtrl'].value=='IV' && edu_form.controls['courseNameCtrl'].value=='M.Com'">
      <input style = 'width: 80% !important; ' ngModel="{{edu_data?.sem_end_fifth}}" nbInput type="text"  formControlName="semEndFifthCtrl" (change)="myFunc()"  placeholder="Sem. End" id="" class="form-control">
    </div>
    <div class="col-md" *ngIf = "edu_form.controls['semesterCtrl'].value=='IV' && edu_form.controls['courseNameCtrl'].value=='M.Com'">
      <input style = 'width: 80% !important; ' ngModel="{{totalValue5 ? totalValue5 :edu_data?.marks_obt_Fifth}}" nbInput type="text" formControlName="markObtFifthCtrl" (change) = "totalsMarksObtainedMyFunc()" placeholder="Marks Obtained" id="" class="form-control">
    </div>
      <div class="col-md" *ngIf = "edu_form.controls['semesterCtrl'].value!='IV' && edu_form.controls['courseNameCtrl'].value=='M.Com'"><input style = 'width: 80% !important; '  ngModel="{{edu_data?.course_credits_fifth}}" nbInput type="text" formControlName="courseCreditsFifthCtrl" placeholder="Course Credits" (change)='getTotalCourseCredits()' id="" class="form-control"></div>
      <div class="col-md" *ngIf = "edu_form.controls['semesterCtrl'].value!='IV' && edu_form.controls['courseNameCtrl'].value=='M.Com'"><input style = 'width: 80% !important; ' ngModel="{{edu_data?.th_fifth}}" nbInput type="text" formControlName="thFifthCtrl" placeholder="TH" id="" class="form-control"></div>
      <div class="col-md" *ngIf = "edu_form.controls['semesterCtrl'].value!='IV' && edu_form.controls['courseNameCtrl'].value=='M.Com'"><input style = 'width: 80% !important; ' ngModel="{{edu_data?.ia_fifth}}" nbInput type="text" formControlName="iaFifthCtrl" placeholder="IA" id="" class="form-control"></div>
      <div class="col-md"><input style = 'width: 80% !important; ' ngModel="{{edu_data?.grade_Fifth}}" nbInput type="text" formControlName="gradeFifthCtrl" placeholder="Grades Obtained" id="" class="form-control"></div>
      <div class="col-md"><input style = 'width: 80% !important; ' ngModel="{{edu_data?.credits_Earned_c_Fifth ? edu_data?.credits_Earned_c_Fifth : this.edu_form.controls.courseCreditsFifthCtrl.value}}" nbInput type="text" formControlName="creditsEarnedCFifthCtrl" placeholder="Credits Earned C" (change)='getTotalCredits()' id="" class="form-control"></div>
      <div class="col-md"><input style = 'width: 80% !important; ' ngModel="{{edu_data?.grade_points_Fifth}}" nbInput type="text" formControlName="gradepointsFifthCtrl" placeholder="Grade points G" (change)='getTotalCnG()' id="" class="form-control"></div>
      <div class="col-md"><input style = 'width: 80% !important; ' ngModel="{{edu_data?.grade_credits_Fifth}}" nbInput type="text" formControlName="gradecreditsFifthCtrl" placeholder="C * G"  id="" class="form-control"></div>
          
    </div>
    <div class="row">
        <div class="col-md-1">Subject 6 :</div>
        <div class="col-md-1">
            <div class="row" *ngIf="edu_data?.course_code_sixth != null && edu_data?.course_code_sixth != '' &&  edu_data?.course_code_sixth != undefined && showcodeDropdown6 == false " >
              <input disabled formControlName = 'courseEdit6Ctrl' [value]="edu_data?.course_code_sixth"  style="width: 150px;" nbInput  type="text" id="" />
              <!-- <i class="fas fa-pen-alt fa-2x" (click)="showcoursecodeDropdown6()" ></i> -->
            </div>
              <mat-form-field  [formGroup]="formData" *ngIf="showcodeDropdown6 == true" style="width:100px;" >
              <mat-select placeholder="Course Code"  #singleSelect2 >
                <mat-option>
                  <ngx-mat-select-search [formControl]="filterInput6" [placeholderLabel]="'Course Code...'" >
                    <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
                  </ngx-mat-select-search>
                </mat-option>
                <mat-option *ngFor="let college of course_code6  | filter: { Course_code: filterText6 }" [value]="college" (click)="getCourse6(college)" >
                  {{ college.Course_code }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            
            <br>
            <div class="row">
              Can't Find ? &nbsp; <i class="fas fa-phone-square fa-lg" title="Contact" style="color: green;" (click)= "showContactDetails()"></i>
              <i class="fas fa-pen-alt fa-lg" *ngIf="admin_show == 'true'"  (click)="showcoursecodeDropdown6()"></i>
              
            </div>
          </div>
          <div class="col-md-2" >
            <div  *ngIf= "edu_data?.Subject_Six != null && edu_data?.Subject_Six != '' && edu_data?.Subject_Six != undefined && showcodeDropdown6 == false">
              <textarea disabled nbInput formControlName = 'subjectEditSixthCtrl' [value]="edu_data?.Subject_Six" style="width: 210px; margin-left: 50px;" nbInput type="text" id="" ></textarea>
             
            </div>
            
            <mat-form-field  appearance="outline" [formGroup]="formData"  style="width: 210px; margin-left: 50px;" *ngIf = "showcodeDropdown6 == true ">
              <mat-select ngModel="{{ edu_data?.Subject_Six }}" name="semester" formControlName="subjectSixthCtrl" [ngClass]="{
                                    'form-control-danger':
                                      edu_form.controls.subjectSixthCtrl.invalid &&
                                      (edu_form.controls.subjectSixthCtrl.dirty ||
                                        edu_form.controls.subjectSixthCtrl.touched)
                                  }">
                <mat-option *ngFor="let course of subjectArray6" value="{{ course.Course_Subject_name }}">{{
                  course.Course_Subject_name }}</mat-option>
              </mat-select>
            </mat-form-field>
  
            <!-- <textarea  ngModel="{{edu_data?.Subject_Six}}" nbInput type="text"  formControlName="subjectSixthCtrl" placeholder="name" id="" class="form-control"></textarea> -->
          </div>
        &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <div class="col-md" *ngIf = "edu_form.controls['semesterCtrl'].value==='IV' && edu_form.controls['courseNameCtrl'].value=='M.Com'">
            <input style = 'width: 80% !important; ' ngModel="{{edu_data?.internal_Marks_six}}" nbInput type="text"  formControlName="internalMarksSixthCtrl"  placeholder="Internal" id="" class="form-control">
          </div>
  
          <div class="col-md" *ngIf = "edu_form.controls['semesterCtrl'].value=='IV' && edu_form.controls['courseNameCtrl'].value=='M.Com'">
            <input style = 'width: 80% !important; ' ngModel="{{edu_data?.sem_end_sixth}}" nbInput type="text"  formControlName="semEndSixthCtrl" (change)="myFunc()"  placeholder="Sem. End" id="" class="form-control">
          </div>
          <div class="col-md" *ngIf = "edu_form.controls['semesterCtrl'].value=='IV' && edu_form.controls['courseNameCtrl'].value=='M.Com'">
            <input style = 'width: 80% !important; ' ngModel="{{totalValue6 ? totalValue6 :edu_data?.marks_obt_Six}}" nbInput type="text" formControlName="markObtSixthCtrl" (change) = "totalsMarksObtainedMyFunc()" placeholder="Marks Obtained" id="" class="form-control">
          </div>
        <div class="col-md" *ngIf = "edu_form.controls['semesterCtrl'].value!='IV' && edu_form.controls['courseNameCtrl'].value=='M.Com'"><input style = 'width: 80% !important; ' ngModel="{{edu_data?.course_credits_sixth}}" nbInput type="text" formControlName="courseCreditsSixthCtrl" placeholder="Course Credits" (change)='getTotalCourseCredits()' id="" class="form-control"></div>
        <div class="col-md" *ngIf = "edu_form.controls['semesterCtrl'].value!='IV' && edu_form.controls['courseNameCtrl'].value=='M.Com'"><input style = 'width: 80% !important; ' ngModel="{{edu_data?.th_sixth}}" nbInput type="text" formControlName="thSixthCtrl" placeholder="TH" id="" class="form-control"></div>
        <div class="col-md" *ngIf = "edu_form.controls['semesterCtrl'].value!='IV' && edu_form.controls['courseNameCtrl'].value=='M.Com'"><input  style = 'width: 80% !important; 'ngModel="{{edu_data?.ia_sixth}}" nbInput type="text" formControlName="iaSixthCtrl" placeholder="IA" id="" class="form-control"></div>
        <div class="col-md"><input style = 'width: 80% !important; ' ngModel="{{edu_data?.grade_Six}}" nbInput type="text" formControlName="gradeSixthCtrl" placeholder="Grades Obtained" id="" class="form-control"></div>
        <div class="col-md"><input style = 'width: 80% !important; ' ngModel="{{edu_data?.credits_Earned_c_Sixth ? edu_data?.credits_Earned_c_Sixth : this.edu_form.controls.courseCreditsSixthCtrl.value}}" nbInput type="text" formControlName="creditsEarnedCSixthCtrl" placeholder="Credits Earned C" (change)='getTotalCredits()' id="" class="form-control"></div>
        <div class="col-md"><input style = 'width: 80% !important; ' ngModel="{{edu_data?.grade_points_Six}}" nbInput type="text" formControlName="gradepointsSixthCtrl" placeholder="Grade points G" (change)='getTotalCnG()' id="" class="form-control"></div>
        <div class="col-md"><input style = 'width: 80% !important; ' ngModel="{{edu_data?.grade_credits_Six}}" nbInput type="text" formControlName="gradecreditsSixthCtrl" placeholder="C * G" id="" class="form-control"></div>
      
      </div>
      <div class="row">
        <div class="col-md-1">Subject 7 :</div>
        <div class="col-md-1">
            <div class="row" *ngIf="edu_data?.course_code_seventh != null && edu_data?.course_code_seventh != '' && edu_data?.course_code_seventh != undefined && showcodeDropdown7 == false" >
              <input disabled formControlName = 'courseEdit7Ctrl' [value]="edu_data?.course_code_seventh" style="width: 150px;" nbInput type="text" id="" />
              <!-- <i class="fas fa-pen-alt fa-2x" (click)="showcoursecodeDropdown7()" ></i> -->
            </div>
  
            <mat-form-field [formGroup]="formData" *ngIf="showcodeDropdown7 == true" style="width:100px;" >
              <mat-select placeholder="Course Code" #singleSelect2>
                <mat-option>
                  <ngx-mat-select-search [formControl]="filterInput7" [placeholderLabel]="'Course Code...'" >
                    <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
                  </ngx-mat-select-search>
                </mat-option>
                <mat-option *ngFor="let college of course_code7   | filter: { Course_code: filterText7 }" [value]="college" (click)="getCourse7(college)" >
                  {{ college.Course_code }}
                </mat-option>
              </mat-select>
            </mat-form-field>
           
            <br>
            <div class="row">
              Can't Find ? &nbsp; <i class="fas fa-phone-square fa-lg" title="Contact" style="color: green;" (click)= "showContactDetails()"></i>
              <i class="fas fa-pen-alt fa-lg" *ngIf="admin_show == 'true'"  (click)="showcoursecodeDropdown7()"></i>
              
            </div>
          </div>
          <div class="col-md-2" >
            <div  *ngIf= "edu_data?.Subject_Seventh != null && edu_data?.Subject_Seventh != '' && edu_data?.Subject_Seventh != undefined && showcodeDropdown7 == false">
              <textarea disabled nbInput formControlName = 'subjectEditSeventhCtrl' [value]="edu_data?.Subject_Seventh" style="width: 210px; margin-left: 50px;" nbInput type="text" id="" ></textarea>
             
            </div>
            
  
            <mat-form-field  appearance="outline" [formGroup]="formData"  style="width: 210px; margin-left: 50px;" *ngIf = "showcodeDropdown7 == true">
              <mat-select ngModel="{{ edu_data?.Subject_Seventh }}" name="semester" formControlName="subjectSeventhCtrl" [ngClass]="{
                            'form-control-danger':
                              edu_form.controls.subjectSeventhCtrl.invalid &&
                              (edu_form.controls.subjectSeventhCtrl.dirty ||
                                edu_form.controls.subjectSeventhCtrl.touched)
                          }">
                <mat-option *ngFor="let course of subjectArray7" value="{{ course.Course_Subject_name }}">{{
                  course.Course_Subject_name }}</mat-option>
              </mat-select>
            </mat-form-field>
  
           <!-- <textarea  ngModel="{{edu_data?.Subject_Seventh}}" nbInput type="text"  formControlName="subjectSeventhCtrl" placeholder="name" id="" class="form-control"></textarea> -->
          </div>
        &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <div class="col-md" *ngIf = "edu_form.controls['semesterCtrl'].value=='IV' && edu_form.controls['courseNameCtrl'].value=='M.Com'">
          <input style = 'width: 80% !important; ' ngModel="{{edu_data?.internal_Marks_seven}}" nbInput type="text"  formControlName="internalMarksSeventhCtrl"  placeholder="Internal" id="" class="form-control">
        </div>

        <div class="col-md" *ngIf = "edu_form.controls['semesterCtrl'].value=='IV' && edu_form.controls['courseNameCtrl'].value=='M.Com'">
          <input style = 'width: 80% !important; ' ngModel="{{edu_data?.sem_end_seventh}}" nbInput type="text"  formControlName="semEndSeventhCtrl" (change)="myFunc()"  placeholder="Sem. End" id="" class="form-control">
        </div>
        <div class="col-md" *ngIf = "edu_form.controls['semesterCtrl'].value=='IV' && edu_form.controls['courseNameCtrl'].value=='M.Com'">
          <input style = 'width: 80% !important; ' ngModel="{{totalValue7 ? totalValue7 :edu_data?.marks_obt_Seventh}}" nbInput type="text" formControlName="markObtSeventhCtrl" (change) = "totalsMarksObtainedMyFunc()" placeholder="Marks Obtained" id="" class="form-control">
        </div>
        <div class="col-md" *ngIf = "edu_form.controls['semesterCtrl'].value!='IV' && edu_form.controls['courseNameCtrl'].value=='M.Com'"><input style = 'width: 80% !important; ' ngModel="{{edu_data?.course_credits_seventh}}" nbInput type="text" formControlName="courseCreditsSeventhCtrl" placeholder="Course Credits" (change)='getTotalCourseCredits()' id="" class="form-control"></div>
        <div class="col-md" *ngIf = "edu_form.controls['semesterCtrl'].value!='IV' && edu_form.controls['courseNameCtrl'].value=='M.Com'"><input style = 'width: 80% !important; ' ngModel="{{edu_data?.th_seventh}}" nbInput type="text" formControlName="thSeventhCtrl" placeholder="TH" id="" class="form-control"></div>
        <div class="col-md" *ngIf = "edu_form.controls['semesterCtrl'].value!='IV' && edu_form.controls['courseNameCtrl'].value=='M.Com'"><input style = 'width: 80% !important; ' ngModel="{{edu_data?.ia_seventh}}" nbInput type="text" formControlName="iaSeventhCtrl" placeholder="IA" id="" class="form-control"></div>
        <div class="col-md"><input style = 'width: 80% !important; ' ngModel="{{edu_data?.grade_Seventh}}" nbInput type="text" formControlName="gradeSeventhCtrl" placeholder="Grades Obtained" id="" class="form-control"></div>
        <div class="col-md"><input style = 'width: 80% !important; ' ngModel="{{edu_data?.credits_Earned_c_Seven ? edu_data?.credits_Earned_c_Seven : this.edu_form.controls.courseCreditsSeventhCtrl.value}}" nbInput type="text" formControlName="creditsEarnedCSevenCtrl" placeholder="Credits Earned C" (change)='getTotalCredits()' id="" class="form-control"></div>
        <div class="col-md"><input style = 'width: 80% !important; ' ngModel="{{edu_data?.grade_points_Seventh}}" nbInput type="text" formControlName="gradepointsSeventhCtrl" placeholder="Grade points G"(change)='getTotalCnG()' id="" class="form-control"></div>
        <div class="col-md"><input style = 'width: 80% !important; ' ngModel="{{edu_data?.grade_credits_Seventh}}" nbInput type="text" formControlName="gradecreditsSeventhCtrl" placeholder="C * G"  id="" class="form-control"></div>   
        
      </div>
      <div class="row">
        <div class="col-md-1">Subject 8 :</div>
        <div class="col-md-1">
            <div class="row" *ngIf=" edu_data?.course_code_eight != null && edu_data?.course_code_eight != '' && edu_data?.course_code_eight != undefined && showcodeDropdown8 == false " >
              <input disabled formControlName = 'courseEdit8Ctrl' [value]="edu_data?.course_code_eight" style="width: 150px;" nbInput  type="text" id="" />
              <!-- <i class="fas fa-pen-alt fa-2x" (click)="showcoursecodeDropdown8()" ></i> -->
            </div>
  
            <mat-form-field [formGroup]="formData" *ngIf="showcodeDropdown8 == true" style="width:100px;" >
              <mat-select placeholder="Course Code"  #singleSelect2 >
                <mat-option>
                  <ngx-mat-select-search [formControl]="filterInput8" [placeholderLabel]="'Course Code...'">
                    <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
                  </ngx-mat-select-search>
                </mat-option>
                <mat-option *ngFor=" let college of course_code8  | filter: { Course_code: filterText8 } " [value]="college" (click)="getCourse8(college)" >
                  {{ college.Course_code }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            
            <br>
            <div class="row">
              Can't Find ? &nbsp; <i class="fas fa-phone-square fa-lg" title="Contact" style="color: green;" (click)= "showContactDetails()"></i>
              <i class="fas fa-pen-alt fa-lg" *ngIf="admin_show == 'true'"  (click)="showcoursecodeDropdown8()"></i>
              
            </div>
          </div>
          <div class="col-md-2" >
            <div  *ngIf= "edu_data?.Subject_Eighth != null && edu_data?.Subject_Eighth != '' && edu_data?.Subject_Eighth != undefined && showcodeDropdown8 == false">
              <textarea disabled nbInput formControlName = 'subjectEditEightCtrl' [value]="edu_data?.Subject_Eighth" style="width: 210px; margin-left: 50px;" nbInput type="text" id="" ></textarea>
             
            </div>
            
            <mat-form-field appearance="outline" [formGroup]="formData" style="width: 210px; margin-left: 50px;" *ngIf = "showcodeDropdown8 == true">
              <mat-select ngModel="{{ edu_data?.Subject_Eighth }}" name="semester" formControlName="subjectEighthCtrl" [ngClass]="{
                                    'form-control-danger':
                                      edu_form.controls.subjectEighthCtrl.invalid &&
                                      (edu_form.controls.subjectEighthCtrl.dirty ||
                                        edu_form.controls.subjectEighthCtrl.touched)
                                  }">
                <mat-option *ngFor="let course of subjectArray8" value="{{ course.Course_Subject_name }}">{{
                  course.Course_Subject_name }}</mat-option>
              </mat-select>
            </mat-form-field>
  
            <!-- <textarea  ngModel="{{edu_data?.Subject_Eighth}}" nbInput type="text"  formControlName="subjectEighthCtrl" placeholder="name" id="" class="form-control"></textarea> -->
          </div>
        &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <div class="col-md" *ngIf = "edu_form.controls['semesterCtrl'].value=='IV' && edu_form.controls['courseNameCtrl'].value=='M.Com'">
            <input style = 'width: 80% !important; ' ngModel="{{edu_data?.internal_Marks_eight}}" nbInput type="text"  formControlName="internalMarksEightCtrl"  placeholder="Internal" id="" class="form-control">
          </div>
  
          <div class="col-md" *ngIf = "edu_form.controls['semesterCtrl'].value=='IV' && edu_form.controls['courseNameCtrl'].value=='M.Com'">
            <input style = 'width: 80% !important; ' ngModel="{{edu_data?.sem_end_eight}}" nbInput type="text"  formControlName="semEndEightCtrl" (change)="myFunc()"  placeholder="Sem. End" id="" class="form-control">
          </div>

          <div class="col-md" *ngIf = "edu_form.controls['semesterCtrl'].value=='IV' && edu_form.controls['courseNameCtrl'].value=='M.Com'">
            <input style = 'width: 80% !important; ' ngModel="{{totalValue8 ? totalValue8 :edu_data?.marks_obt_Eighth}}" nbInput type="text" formControlName="markObtEightCtrl" (change) = "totalsMarksObtainedMyFunc()" placeholder="Marks Obtained" id="" class="form-control">
          </div>
        <div class="col-md" *ngIf = "edu_form.controls['semesterCtrl'].value!='IV' && edu_form.controls['courseNameCtrl'].value=='M.Com'"><input style = 'width: 80% !important; ' ngModel="{{edu_data?.course_credits_eight}}" nbInput type="text" formControlName="courseCreditsEightCtrl" placeholder="Course Credits" (change)='getTotalCourseCredits()' id="" class="form-control"></div>
        <div class="col-md" *ngIf = "edu_form.controls['semesterCtrl'].value!='IV' && edu_form.controls['courseNameCtrl'].value=='M.Com'"><input style = 'width: 80% !important; ' ngModel="{{edu_data?.th_eight}}" nbInput type="text" formControlName="thEightCtrl" placeholder="TH" id="" class="form-control"></div>
        <div class="col-md" *ngIf = "edu_form.controls['semesterCtrl'].value!='IV' && edu_form.controls['courseNameCtrl'].value=='M.Com'"><input  style = 'width: 80% !important; 'ngModel="{{edu_data?.ia_eight}}" nbInput type="text" formControlName="iaEightCtrl" placeholder="IA" id="" class="form-control"></div>
        <div class="col-md"><input  style = 'width: 80% !important; 'ngModel="{{edu_data?.grade_Eighth}}" nbInput type="text" formControlName="gradeEighthCtrl" placeholder="Grades Obtained" id="" class="form-control"></div>
        <div class="col-md"><input style = 'width: 80% !important; ' ngModel="{{edu_data?.credits_Earned_c_Eight ? edu_data?.credits_Earned_c_Eight  : this.edu_form.controls.courseCreditsEightCtrl.value }}" nbInput type="text" formControlName="creditsEarnedCEightCtrl" placeholder="Credits Earned C" (change)='getTotalCredits()' id="" class="form-control"></div>
        <div class="col-md"><input style = 'width: 80% !important; ' ngModel="{{edu_data?.grade_points_Eighth}}" nbInput type="text" formControlName="gradepointsEighthCtrl" placeholder="Grade points G" id="" (change)='getTotalCnG()' class="form-control"></div>
        <div class="col-md"><input style = 'width: 80% !important; ' ngModel="{{edu_data?.grade_credits_Eighth}}" nbInput type="text" formControlName="gradecreditsEighthCtrl" placeholder="C * G"  id="" class="form-control"></div>
          
      </div>
      <div class="row">
        <div class="col-md-1">Subject 9 :</div>
        <div class="col-md-1">
            <div class="row" *ngIf=" edu_data?.course_code_ninth != null && edu_data?.course_code_ninth != '' && edu_data?.course_code_ninth != undefined && showcodeDropdown9 == false" >
              <input disabled formControlName = 'courseEdit9Ctrl' [value]="edu_data?.course_code_ninth" style="width: 150px;" nbInput type="text" id="" />
              <!-- <i class="fas fa-pen-alt fa-2x"  (click)="showcoursecodeDropdown9()" ></i> -->
            </div>
  
            <mat-form-field [formGroup]="formData" *ngIf="showcodeDropdown9 == true"  style="width:100px;" >
              <mat-select  placeholder="Course Code"  #singleSelect2>
                <mat-option>
                  <ngx-mat-select-search  [formControl]="filterInput9"  [placeholderLabel]="'Course Code...'" >
                    <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
                  </ngx-mat-select-search>
                </mat-option>
                <mat-option *ngFor=" let college of course_code9   | filter: { Course_code: filterText9 } "  [value]="college"  (click)="getCourse9(college)">
                  {{ college.Course_code }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            
            <br>
            <div class="row">
              Can't Find ? &nbsp; <i class="fas fa-phone-square fa-lg" title="Contact" style="color: green;" (click)= "showContactDetails()"></i>
              <i class="fas fa-pen-alt fa-lg" *ngIf="admin_show == 'true'"  (click)="showcoursecodeDropdown9()"></i>
              
            </div>
          </div>
          <div class="col-md-2" >
            <div  *ngIf= "edu_data?.Subject_Ninth != null && edu_data?.Subject_Ninth != '' && edu_data?.Subject_Ninth != undefined && showcodeDropdown9 == false">
              <textarea disabled nbInput formControlName = 'subjectEditNinthCtrl' [value]="edu_data?.Subject_Ninth" style="width: 210px; margin-left: 50px;" nbInput type="text" id="" ></textarea>
              
            </div>
            
            
            <mat-form-field appearance="outline" [formGroup]="formData"  style="width: 210px; margin-left: 50px;" *ngIf = "showcodeDropdown9 == true">
              <mat-select ngModel="{{ edu_data?.Subject_Ninth }}" name="semester" formControlName="subjectNinthCtrl" [ngClass]="{
                            'form-control-danger':
                              edu_form.controls.subjectNinthCtrl.invalid &&
                              (edu_form.controls.subjectNinthCtrl.dirty ||
                                edu_form.controls.subjectNinthCtrl.touched)
                          }">
                <mat-option *ngFor="let course of subjectArray9" value="{{ course.Course_Subject_name }}">{{
                  course.Course_Subject_name }}</mat-option>
              </mat-select>
            </mat-form-field>
  
  
  
            <!-- <textarea  ngModel="{{edu_data?.Subject_Ninth}}" nbInput type="text"  formControlName="subjectNinthCtrl" placeholder="name" id="" class="form-control"></textarea> -->
          </div>
        &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <div class="col-md" *ngIf = "edu_form.controls['semesterCtrl'].value=='IV' && edu_form.controls['courseNameCtrl'].value=='M.Com'">
        <input style = 'width: 80% !important; ' ngModel="{{edu_data?.internal_Marks_nine}}" nbInput type="text"  formControlName="internalMarksNineCtrl"  placeholder="Internal" id="" class="form-control">
      </div>

      <div class="col-md" *ngIf = "edu_form.controls['semesterCtrl'].value=='IV' && edu_form.controls['courseNameCtrl'].value=='M.Com'">
        <input style = 'width: 80% !important; ' ngModel="{{edu_data?.sem_end_ninth}}" nbInput type="text"  formControlName="semEndNinthCtrl" (change)="myFunc()"  placeholder="Sem. End" id="" class="form-control">
      </div>
      <div class="col-md" *ngIf = "edu_form.controls['semesterCtrl'].value=='IV' && edu_form.controls['courseNameCtrl'].value=='M.Com'">
        <input style = 'width: 80% !important; ' ngModel="{{totalValue9 ? totalValue9 :edu_data?.marks_obt_Ninth}}" nbInput type="text" formControlName="markObtNinthCtrl" (change) = "totalsMarksObtainedMyFunc()" placeholder="Marks Obtained" id="" class="form-control">
      </div>
        <div class="col-md" *ngIf = "edu_form.controls['semesterCtrl'].value!='IV' && edu_form.controls['courseNameCtrl'].value=='M.Com'"><input style = 'width: 80% !important; '  ngModel="{{edu_data?.course_credits_ninth}}" nbInput type="text" formControlName="courseCreditsNinthCtrl" placeholder="Course Credits" (change)='getTotalCourseCredits()' id="" class="form-control"></div>
        <div class="col-md" *ngIf = "edu_form.controls['semesterCtrl'].value!='IV' && edu_form.controls['courseNameCtrl'].value=='M.Com'"><input style = 'width: 80% !important; ' ngModel="{{edu_data?.th_ninth}}" nbInput type="text" formControlName="thNinthCtrl" placeholder="TH" id="" class="form-control"></div>
        <div class="col-md" *ngIf = "edu_form.controls['semesterCtrl'].value!='IV' && edu_form.controls['courseNameCtrl'].value=='M.Com'"><input style = 'width: 80% !important; ' ngModel="{{edu_data?.ia_ninth}}" nbInput type="text" formControlName="iaNinthCtrl" placeholder="IA" id="" class="form-control"></div>
        <div class="col-md" *ngIf = "edu_form.controls['semesterCtrl'].value!='IV' && edu_form.controls['courseNameCtrl'].value=='M.Com'"><input  style = 'width: 80% !important; 'ngModel="{{edu_data?.grade_Ninth}}" nbInput type="text" formControlName="gradeNinthCtrl" placeholder="Grades Obtained" id="" class="form-control"></div>
        <div class="col-md"><input style = 'width: 80% !important; ' ngModel="{{edu_data?.credits_Earned_c_Ninth ? edu_data?.credits_Earned_c_Ninth : this.edu_form.controls.courseCreditsNinthCtrl.value}}" nbInput type="text" formControlName="creditsEarnedCNinthCtrl" placeholder="Credits Earned C" (change)='getTotalCredits()' id="" class="form-control"></div>
        <div class="col-md"><input style = 'width: 80% !important; ' ngModel="{{edu_data?.grade_points_Ninth}}" nbInput type="text" formControlName="gradepointsNinthCtrl" placeholder="Grade points G" id=""(change)='getTotalCnG()' class="form-control"></div>
        <div class="col-md"><input style = 'width: 80% !important; ' ngModel="{{edu_data?.grade_credits_Ninth}}" nbInput type="text" formControlName="gradecreditsNinthCtrl" placeholder="C * G" id="" class="form-control"></div>
          
      </div>
      <div class="row">
        <div class="col-md-1">Subject 10 :</div>
        <div class="col-md-1">
            <div class="row" *ngIf=" edu_data?.course_code_tenth != null && edu_data?.course_code_tenth != '' && edu_data?.course_code_tenth != undefined && showcodeDropdown10 == false ">
              <input disabled formControlName = 'courseEdit10Ctrl' [value]="edu_data?.course_code_tenth" style="width: 150px;" nbInput type="text" id=""/>
              <!-- <i class="fas fa-pen-alt fa-2x"  (click)="showcoursecodeDropdown10()" ></i> -->
            </div>
  
            <mat-form-field [formGroup]="formData" *ngIf="showcodeDropdown10 == true" style="width:100px;">
              <mat-select placeholder="Course Code" #singleSelect2 >
                <mat-option>
                  <ngx-mat-select-search [formControl]="filterInput10" [placeholderLabel]="'Course Code...'">
                    <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
                  </ngx-mat-select-search>
                </mat-option>
                <mat-option *ngFor="let college of course_code10  | filter: { Course_code: filterText10 } " [value]="college" (click)="getCourse10(college)" >
                  {{ college.Course_code }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            
            <br>
            <div class="row">
              Can't Find ? &nbsp; <i class="fas fa-phone-square fa-lg" title="Contact" style="color: green;" (click)= "showContactDetails()"></i>
              <i class="fas fa-pen-alt fa-lg" *ngIf="admin_show == 'true'"  (click)="showcoursecodeDropdown10()"></i>
              
            </div>
          </div>
          <div class="col-md-2" >
            <div  *ngIf= "edu_data?.Subject_Tenth != null && edu_data?.Subject_Tenth != '' && edu_data?.Subject_Tenth != undefined && showcodeDropdown10 == false">
              <textarea disabled nbInput formControlName = 'subjectEditTenthCtrl' [value]="edu_data?.Subject_Tenth"style="width: 210px; margin-left: 50px;"  nbInput type="text" id="" ></textarea>
              
            </div>
            
            <mat-form-field  appearance="outline" [formGroup]="formData" style="width: 210px; margin-left: 50px;" *ngIf = "showcodeDropdown10 == true">
              <mat-select ngModel="{{ edu_data?.Subject_Tenth }}" name="semester" formControlName="subjectTenthCtrl" [ngClass]="{
                                    'form-control-danger':
                                      edu_form.controls.subjectTenthCtrl.invalid &&
                                      (edu_form.controls.subjectTenthCtrl.dirty ||
                                        edu_form.controls.subjectTenthCtrl.touched)
                                  }">
                <mat-option *ngFor="let course of subjectArray10" value="{{ course.Course_Subject_name }}">{{
                  course.Course_Subject_name }}</mat-option>
              </mat-select>
            </mat-form-field>
  
  
            <!-- <textarea  ngModel="{{edu_data?.Subject_Tenth}}" nbInput type="text"  formControlName="subjectTenthCtrl" placeholder="name" id="" class="form-control"></textarea> -->
          </div>
        &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <div class="col-md" *ngIf = "edu_form.controls['semesterCtrl'].value=='IV' && edu_form.controls['courseNameCtrl'].value=='M.Com'">
            <input style = 'width: 80% !important; ' ngModel="{{edu_data?.internal_Marks_ten}}" nbInput type="text"  formControlName="internalMarksTenCtrl"  placeholder="Internal" id="" class="form-control">
          </div>
  
          <div class="col-md" *ngIf = "edu_form.controls['semesterCtrl'].value=='IV' && edu_form.controls['courseNameCtrl'].value=='M.Com'">
            <input style = 'width: 80% !important; ' ngModel="{{edu_data?.sem_end_tenth}}" nbInput type="text"  formControlName="semEndTenthCtrl" (change)="myFunc()"  placeholder="Sem. End" id="" class="form-control">
          </div>
          <div class="col-md" *ngIf = "edu_form.controls['semesterCtrl'].value=='IV' && edu_form.controls['courseNameCtrl'].value=='M.Com'">
            <input style = 'width: 80% !important; ' ngModel="{{totalValue10 ? totalValue10 :edu_data?.marks_obt_Tenth}}" nbInput type="text" formControlName="markObtTenthCtrl" (change) = "totalsMarksObtainedMyFunc()" placeholder="Marks Obtained" id="" class="form-control">
          </div>
        <div class="col-md" *ngIf = "edu_form.controls['semesterCtrl'].value!='IV' && edu_form.controls['courseNameCtrl'].value=='M.Com'"><input style = 'width: 80% !important; ' ngModel="{{edu_data?.course_credits_tenth}}" nbInput type="text" formControlName="courseCreditsTenthCtrl" placeholder="Course Credits" (change)='getTotalCourseCredits()' id="" class="form-control"></div>
        <div class="col-md" *ngIf = "edu_form.controls['semesterCtrl'].value!='IV' && edu_form.controls['courseNameCtrl'].value=='M.Com'"><input style = 'width: 80% !important; ' ngModel="{{edu_data?.th_tenth}}" nbInput type="text" formControlName="thTenthCtrl" placeholder="TH" id="" class="form-control"></div>
        <div class="col-md" *ngIf = "edu_form.controls['semesterCtrl'].value!='IV' && edu_form.controls['courseNameCtrl'].value=='M.Com'"><input style = 'width: 80% !important; ' ngModel="{{edu_data?.ia_tenth}}" nbInput type="text" formControlName="iaTenthCtrl" placeholder="IA" id="" class="form-control"></div>
        <div class="col-md"><input style = 'width: 80% !important; ' ngModel="{{edu_data?.grade_Tenth}}" nbInput type="text" formControlName="gradeTenthCtrl" placeholder="Grades Obtained" id="" class="form-control"></div>
        <div class="col-md"><input style = 'width: 80% !important; ' ngModel="{{edu_data?.credits_Earned_c_ten ? edu_data?.credits_Earned_c_ten : this.edu_form.controls.courseCreditsTenthCtrl.value}}" nbInput type="text" formControlName="creditsEarnedCtehthCtrl" placeholder="Credits Earned C" (change)='getTotalCredits()' id="" class="form-control"></div>
        <div class="col-md"><input style = 'width: 80% !important; ' ngModel="{{edu_data?.grade_points_Tenth}}" nbInput type="text" formControlName="gradepointsTenthCtrl" placeholder="Grade points G" (change)='getTotalCnG()' id="" class="form-control"></div>
        <div class="col-md"><input style = 'width: 80% !important; ' ngModel="{{edu_data?.grade_credits_Tenth}}" nbInput type="text" formControlName="gradecreditsTenthCtrl" placeholder="C * G"  id="" class="form-control"></div>
          
      </div> 
      <br>
      <div class="row">
       <div class="col-md-2">Total Credits Points: </div>
          <div class="col-md-2">
            <input  ngModel="{{totalMarks ? totalMarks : edu_data?.total_credits_Earned_C}}" nbInput type="text" [ngClass]="{'form-control-danger': edu_form.controls.totalCCtrl.invalid && (edu_form.controls.totalCCtrl.dirty || edu_form.controls.totalCCtrl.touched)}" formControlName="totalCCtrl" placeholder="Total C" id="" class="form-control"> 
          </div>
          <div class="col-md-2">Total of C * G  : </div>
          <div class="col-md-2">
            <input  ngModel="{{totalCnG ? totalCnG : edu_data?.total_CnG}}" nbInput type="text" [ngClass]="{'form-control-danger': edu_form.controls.totalCnGCtrl.invalid && (edu_form.controls.totalCnGCtrl.dirty || edu_form.controls.totalCnGCtrl.touched)}" formControlName="totalCnGCtrl" placeholder="Total (C*G)" id="" class="form-control"> 
          </div>
          <!--<div class="col-md-2"> Specialisation in  : </div>
          <div class="col-md-2">
          <input  ngModel="{{edu_data?.total_weeks}}" nbInput type="text" [ngClass]="{'form-control-danger': edu_form.controls.SpecialisationCtrl.invalid && (edu_form.controls.SpecialisationCtrl.dirty || edu_form.controls.SpecialisationCtrl.touched)}" formControlName="SpecialisationCtrl" placeholder="Specialisation" id="" class="form-control"> 
        </div>-->
        <!--<div class="col-md-2" *ngIf="admin_show == 'true'">Result Instruction : </div>
          <div class="col-md-2" *ngIf="admin_show == 'true'">
          <mat-form-field  appearance="outline" style="width:100% !important;  ">
            
              <mat-select ngModel="{{edu_data?.footnotes}}" formControlName="footnotesCtrl">
                <mat-option value = '@ As per University of Mumbai Ordinance 0.5042A/0.5043A/0.5044A'>@ As per University of Mumbai Ordinance 0.5042A/0.5043A/0.5044A</mat-option>
                <mat-option value = '& Scaled Down, Cir. No. UG/61 of 2013-2014'>& Scaled Down, Cir. No. UG/61 of 2013-2014</mat-option>
                <mat-option value = '+ Carried Forward Marks as per Ordinance of University of Mumbai'>+ Carried Forward Marks as per Ordinance of University of Mumbai</mat-option>
                <mat-option value = '* As per University of Mumbai Ordinance 0.5045a'>* As per University of Mumbai Ordinance 0.5045a</mat-option>
                <mat-option value = '$ - Carried forward grade as per ordinance of the University of Mumbai'>$ - Carried forward grade as per ordinance of the University of Mumbai</mat-option>
                <mat-option value = '# As per University of Mumbai, Ordinance 0.229'># As per University of Mumbai, Ordinance 0.229</mat-option>
                
              </mat-select>
            </mat-form-field>
          
          </div>-->
      </div>
      <br>
      <div class="row">
          <div class="col-md-2" *ngIf="admin_show == 'true'">SGPI Instruction : </div>
          <div class="col-md-2" *ngIf="admin_show == 'true'">
          <mat-form-field  appearance="outline" style="width:100% !important;   ">
            
            <mat-select ngModel="{{edu_data?.sgpi_instruction}}" formControlName="sgpiInstCtrl">
              <mat-option [value] = 'null'>--Clear Options--</mat-option>
              <mat-option value = '@ As per University of Mumbai Ordinance 0.5042A/0.5043A/0.5044A'>@ As per University of Mumbai Ordinance 0.5042A/0.5043A/0.5044A</mat-option>
              <mat-option value = '& Scaled Down, Cir. No. UG/61 of 2013-2014'>& Scaled Down, Cir. No. UG/61 of 2013-2014</mat-option>
              <mat-option value = '+ Carried Forward Marks as per Ordinance of University of Mumbai'>+ Carried Forward Marks as per Ordinance of University of Mumbai</mat-option>
              <mat-option value = '* As per University of Mumbai Ordinance 0.5045a'>* As per University of Mumbai Ordinance 0.5045a</mat-option>
              <mat-option value = '$ - Carried forward grade as per ordinance of the University of Mumbai'>$ - Carried forward grade as per ordinance of the University of Mumbai</mat-option>
              <mat-option value = '# As per University of Mumbai, Ordinance 0.229'># As per University of Mumbai, Ordinance 0.229</mat-option>
              
            </mat-select>
          </mat-form-field>
          </div>
          <div class="col-md-2" *ngIf="admin_show == 'true'">Result Instruction : </div>
          <div class="col-md-2" *ngIf="admin_show == 'true'">
              <mat-form-field *ngIf="admin_show == 'true'"  appearance="outline" >
                
                  <mat-select ngModel="{{edu_data?.footnotes}}" formControlName="footnotesCtrl">
                    <mat-option [value] = 'null'>--Clear Options--</mat-option>
                    <mat-option value = '@ As per University of Mumbai Ordinance 0.5042A/0.5043A/0.5044A'>@ As per University of Mumbai Ordinance 0.5042A/0.5043A/0.5044A</mat-option>
                    <mat-option value = '& Scaled Down, Cir. No. UG/61 of 2013-2014'>& Scaled Down, Cir. No. UG/61 of 2013-2014</mat-option>
                    <mat-option value = '+ Carried Forward Marks as per Ordinance of University of Mumbai'>+ Carried Forward Marks as per Ordinance of University of Mumbai</mat-option>
                    <mat-option value = '* As per University of Mumbai Ordinance 0.5045a'>* As per University of Mumbai Ordinance 0.5045a</mat-option>
                    <mat-option value = '$ - Carried forward grade as per ordinance of the University of Mumbai'>$ - Carried forward grade as per ordinance of the University of Mumbai</mat-option>
                    <mat-option value = '# As per University of Mumbai, Ordinance 0.229'># As per University of Mumbai, Ordinance 0.229</mat-option>
                    
                  </mat-select>
                </mat-form-field>
                </div>
        </div>
        <br>
      <div class="row" *ngIf = "edu_form.controls['semesterCtrl'].value==='IV' && edu_form.controls['courseNameCtrl'].value=='M.Com'">
       <div class="col-md-2">Total Marks Obtained:</div>
        <div class="col-md-2">
        <input  ngModel="{{totalMarksmyFunc ? totalMarksmyFunc : edu_data?.overall_marks_obt}}" nbInput type="text"  formControlName="totalMarksObtCtrl" placeholder="Total Marks" id="" class="form-control">
        </div>
        </div>
        <br>
      <div class="row">
          <div class="col-md-2" *ngIf = "edu_form.controls['semesterCtrl'].value=='IV' && edu_form.controls['courseNameCtrl'].value=='M.Com'">Over All Grade : </div>
          <div class="col-md-2" *ngIf = "edu_form.controls['semesterCtrl'].value=='IV' && edu_form.controls['courseNameCtrl'].value=='M.Com'">
            <input  ngModel="{{edu_data?.OverAllGrade}}" nbInput type="text"  formControlName="overAllGradeCtrl" placeholder="" id="" class="form-control"> 
          </div>
          <h6>OR</h6>
          <div class="col-md-2" *ngIf = "edu_form.controls['semesterCtrl'].value=='IV' && edu_form.controls['courseNameCtrl'].value=='M.Com'">PERCENTAGE : </div>
          <div class="col-md-2" *ngIf = "edu_form.controls['semesterCtrl'].value=='IV' && edu_form.controls['courseNameCtrl'].value=='M.Com'">
            <input  ngModel="{{edu_data?.OverAllpercentage}}" nbInput type="text" formControlName="overAllpercentageCtrl" placeholder="" id="" class="form-control"> 
          </div>
        </div>
        <br>
      <div class="row">
      <div class="col-md-2">SGPI : </div>
          <div class="col-md-2">
            <input  ngModel="{{totalcgpa ? totalcgpa : edu_data?.overall_gpa_sgpi}}" nbInput type="number" [ngClass]="{'form-control-danger': edu_form.controls.overAllgpasgpiCtrl.invalid && (edu_form.controls.overAllgpasgpiCtrl.dirty || edu_form.controls.overAllgpasgpiCtrl.touched)}" formControlName="overAllgpasgpiCtrl" placeholder="" id="" class="form-control"  onchange="(function(el){el.value=parseFloat(el.value).toFixed(2);})(this)" value="0.00" min="0.00" max="1.00" step="0.05"> 
          </div>
          <br>
          <div class="col-md-2" *ngIf = "edu_form.controls['semesterCtrl'].value=='IV' && edu_form.controls['courseNameCtrl'].value=='M.Com'">OVERALL CGPI : </div>
          <div class="col-md-2" *ngIf = "edu_form.controls['semesterCtrl'].value=='IV' && edu_form.controls['courseNameCtrl'].value=='M.Com'"> <input  ngModel="{{edu_data?.overall_CGPA}}" nbInput type="text"  formControlName="OverallCGPACtrl" placeholder="OVERALL CGPA" id="" class="form-control"> </div>
          
      </div>
      <br>
     <div class="row">
          <div class="col-md-2">Medium of instruction : </div>
          <div class="col-md-2"> <input [ngModel]="edu_data ? edu_data?.medium_instruction : 'English' "   nbInput type="text" [ngClass]="{'form-control-danger': edu_form.controls.instructionCtrl.invalid && (edu_form.controls.instructionCtrl.dirty || edu_form.controls.instructionCtrl.touched)}" formControlName="instructionCtrl" placeholder="" id="" class="form-control"> </div>
          <div class="col-md-2" *ngIf="admin_show == 'true'">Special Instruction : </div>
          <div class="col-md-2" *ngIf="admin_show == 'true'">
          <!--   <mat-form-field  appearance="outline" style="width:100% !important;  ">
              <input type="text" style="width:100% !important;" [ngModel]="specialInstruction ? specialInstruction : edu_data?.special_instruction" (change)='getSpecialInst($event)'  formControlName="specialInstrctionCtrl" placeholder="Choose Final Grade Special Instruction"  matInput [matAutocomplete]="auto2">
              <mat-autocomplete #auto2="matAutocomplete"  style="width:100% !important;  " >
                <mat-option *ngFor="let option of specialInstructionArray" [value]="option" (click)="updateSpecialInstruction(option)">
                  {{ option }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field> -->
            <mat-checkbox class="example-margin" (change)="onChange($event,1)" [ngModelOptions]="{standalone: true}" [(ngModel)]="instruction1">@ As per University of Mumbai Ordinance 0.5042A/0.5043A/0.5044A</mat-checkbox>
            <mat-checkbox class="example-margin" (change)="onChange($event,2)" [ngModelOptions]="{standalone: true}" [(ngModel)]="instruction2">& Scaled Down, Cir. No. UG/61 of 2013-2014</mat-checkbox>
            <mat-checkbox class="example-margin" (change)="onChange($event,3)" [ngModelOptions]="{standalone: true}" [(ngModel)]="instruction3">+ Carried Forward Marks as per Ordinance of University of Mumbai</mat-checkbox>
            <mat-checkbox class="example-margin" (change)="onChange($event,4)" [ngModelOptions]="{standalone: true}" [(ngModel)]="instruction4">* As per University of Mumbai Ordinance 0.5045a</mat-checkbox>
            <mat-checkbox class="example-margin" (change)="onChange($event,5)" [ngModelOptions]="{standalone: true}" [(ngModel)]="instruction5">$ - Carried forward grade as per ordinance of the University of Mumbai</mat-checkbox>
            <mat-checkbox class="example-margin" (change)="onChange($event,6)" [ngModelOptions]="{standalone: true}" [(ngModel)]="instruction6"># As per University of Mumbai, Ordinance 0.229</mat-checkbox>
            <mat-checkbox class="example-margin" (change)="onChange($event,7)" [ngModelOptions]="{standalone: true}" [(ngModel)]="instruction7">& As per University of Mumbai Ordinance. O.224</mat-checkbox>
      
            <!-- <input  ngModel="{{edu_data?.special_instruction}}" nbInput type="text" formControlName="specialInstrctionCtrl" placeholder="" id="" class="form-control"> -->
          </div>
        </div>
        <br>
        <div class="row">
          <div class="col-md-2" *ngIf= "admin_show == 'true' && edu_form.controls['semesterCtrl'].value=='IV'">Sem I Details : </div>
          <div class="col-md-3" *ngIf= "admin_show == 'true' && edu_form.controls['semesterCtrl'].value=='IV'">
             <input  ngModel="{{edu_data?.mcom_sem_I_Details}}" nbInput type="text" formControlName="sem1detailsctrl" placeholder="" id="" class="form-control"> 
          </div>
          <div class="col-md-2" *ngIf= "admin_show == 'true' && edu_form.controls['semesterCtrl'].value=='IV' ">Sem II Details : </div>
          <div class="col-md-3" *ngIf= "admin_show == 'true' && edu_form.controls['semesterCtrl'].value=='IV'">
             <input  ngModel="{{edu_data?.mcom_sem_II_Details}}" nbInput type="text" formControlName="sem2detailsctrl" placeholder="" id="" class="form-control"> 
          </div>
          </div> 
            <br>
         <div class="row" >
           <div class="col-md-2" *ngIf= "admin_show == 'true' && edu_form.controls['semesterCtrl'].value=='IV' ">Sem III Details : </div>
          <div class="col-md-3" *ngIf= "admin_show == 'true' && edu_form.controls['semesterCtrl'].value=='IV'">
             <input  ngModel="{{edu_data?.mcom_sem_III_Details}}" nbInput type="text" formControlName="sem3detailsctrl" placeholder="" id="" class="form-control"> 
          </div>
         </div>

        
      </form>
    </nb-card-body>
    <nb-card-footer>
        <button nbButton hero status="primary" (click)="dismiss()">Close</button> 
        <button *ngIf="amount_paid == 'false'" nbButton status="info" (click)="saveEdu()">save</button>
    </nb-card-footer>
</nb-card>
<p-confirmDialog [style]="{width: '425px'}"></p-confirmDialog>

  `,
  providers: [ConfirmationService]
})
export class addMasterEducationalDetailsSemesterSGPI implements OnInit {
  FeedbackForm: FormGroup;
  @Input() user_id: any;
  @Input() edu_id: any;
  @Input() amount_paid: string;
  @Input() admin_show: string;
  @Input() showSpecialization: string;
  @Input() course_name_auto: string;
  @Input() college_year_auto: string;
  @Input() enrollment_year_auto: number;
  @Input() specialisationlevel_auto: string;
  @Input() sgpi_gpa: string;
  @Input() seat_number: any;
  @Input() mu_seat_number: any;
  @Input() stillSd: any;

  preEditFirst: boolean = false;
  preEditSecond: boolean = false;
  preEditThird: boolean = false;
  preEditFourth: boolean = false;
  preEditFifth: boolean = false;
  preEditSixth: boolean = false;
  preEditSeventh: boolean = false;
  preEditEight: boolean = false;
  preEditNinth: boolean = false;
  preEditTenth: boolean = false;

  specialisation_data;
  still_studying;
  specialisation_name: any;

  validations_flag = false;
  feedback_message;
  showExperience = false;
  totalMarks: number;
  totalMarksOut: number;
  creditTotal: number;
  totalCnG: number;
  totalcgpa: any;

  edu_form: FormGroup;
  years_array;
  courseValidation = true;
  collegeYearValidation = true;
  semesterValidation = true;
  monthValidation = true;
  yearValidation = true;
  attemptValidation = true;
  instructionValidation = true;
  endmonthValidation = true;
  endYearValidation = true;

  edu_data;
  course_data;
  user: any;
  totalCourseCredits: any;
  hourValue: any;
  hourValue8: any;
  hourValue7: any;
  hourValue6: any;
  hourValue5: any;
  hourValue4: any;
  hourValue3: any;
  hourValue2: any;
  lecVal1: any;
  lecVal2: any;
  lecVal3: any;
  lecVal4: any;
  lecVal5: any;
  lecVal6: any;
  lecVal7: any;
  lecVal8: any;
  monthTaken2: any;
  monthTaken1: any;
  monthTaken3: any;
  monthTaken8: any;
  monthTaken7: any;
  monthTaken6: any;
  monthTaken5: any;
  monthTaken4: any;
  hourValue9: any;
  hourValue10: any;
  lecVal9: any;
  lecVal10: any;
  monthTaken9: any;
  monthTaken10: any;
  enrollYear = [];
  enrollment_year: any;
  public filterInput = new FormControl();
  public filterInput2 = new FormControl();
  public filterInput3 = new FormControl();
  public filterInput4 = new FormControl();
  public filterInput5 = new FormControl();
  public filterInput6 = new FormControl();
  public filterInput7 = new FormControl();
  public filterInput8 = new FormControl();
  public filterInput9 = new FormControl();
  public filterInput10 = new FormControl();
  subjectName: any;
  withoutCodeSub: any;
  subjectName2: any;
  withoutCodeSub2: any;
  withoutCodeSub3: any;
  subjectName3: any;
  subjectName4: any;
  withoutCodeSub4: any;
  subjectName5: any;
  withoutCodeSub5: any;
  subjectName6: any;
  withoutCodeSub6: any;
  subjectName7: any;
  withoutCodeSub7: any;
  subjectName8: any;
  withoutCodeSub8: any;
  subjectName9: any;
  withoutCodeSub9: any;
  subjectName10: any;
  withoutCodeSub10: any;
  course_code: any;
  course_code8: any;
  course_code2: any;
  course_code3: any;
  course_code4: any;
  course_code5: any;
  course_code6: any;
  course_code7: any;
  course_code9: any;
  course_code10: any;
  public filterText: any;
  public filterText2: any;
  filterText3: any
  public filterText4: any;
  public filterText5: any;
  public filterText6: any;
  public filterText7: any;
  public filterText8: any;
  public filterText9: any;
  public filterText10: any;
  autocheck = true;
  stillStudy: any;
  specialInstructionArray = ['@ As per University of Mumbai Ordinance 0.5042A/0.5043A/0.5044A',
    '& Scaled Down, Cir. No. UG/61 of 2013-2014',
    '+ Carried Forward Marks as per Ordinance of University of Mumbai',
    '* As per University of Mumbai Ordinance 0.5045a',
    '$ - Carried forward grade as per ordinance of the University of Mumbai',
    '# As per University of Mumbai, Ordinance 0.229',
'    & As per University of Mumbai Ordinance. O.224'
 ]
  specialInstruction: any;
  specI: any;
  GradespecialInstruction: any;
  DradespecI: any;
  newcourse_code = [];

  course_name: any;
  edu_level: any;
  college_year: any;
  semester_auto: any;
  showcodeDropdown: boolean = true;
  showcodeDropdown2: boolean = true;
  showcodeDropdown3: boolean = true;
  showcodeDropdown4: boolean = true;
  showcodeDropdown5: boolean = true;
  showcodeDropdown6: boolean = true;
  showcodeDropdown7: boolean = true;
  showcodeDropdown8: boolean = true;
  showcodeDropdown9: boolean = true;
  showcodeDropdown10: boolean = true;
  isDisabled = false;
  startmonth;
  startYear: any;
  totalMarksmyFunc: number;
  totalMarksOutmyFunc: number;
  totalValue: number;
  totalValue2: number;
  totalValue3: number;
  totalValue4: number;
  totalValue5: number;
  totalValue6: number;
  totalValue7: number;
  totalValue8: number;
  totalValue9: number;
  totalValue10: number;
  totalMarksObtainedmyFunc: number;

  subjectArray = [];
  subjectArray2 = [];
  subjectArray3 = [];
  subjectArray4 = [];
  subjectArray5 = [];
  subjectArray6 = [];
  subjectArray7 = [];
  subjectArray8 = [];
  subjectArray9 = [];
  subjectArray10 = [];

  instruction1: boolean = false;
  instruction2: boolean = false;
  instruction3: boolean = false;
  instruction4: boolean = false;
  instruction5: boolean = false;
  instruction6: boolean = false;
  instruction7: boolean = false;

  special_instruction1: any = null;
  special_instruction2: any = null;
  special_instruction3: any = null;
  special_instruction4: any = null;
  special_instruction5: any = null;
  special_instruction6: any = null;
  special_instruction7: any = null;

  constructor(protected api: ApiService,
    private router: Router,
    private userService: UserService,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private confirmationService: ConfirmationService,
    protected ref: NbDialogRef<addMasterEducationalDetailsSemesterSGPI>) { }

  async ngOnInit() {
    
    if (this.admin_show == "true") {
      
      this.isDisabled = false;
    } else {
      //this.edu_form.controls['lecturehourFirstCtrl'].disable();

      this.isDisabled = !this.isDisabled;
    }
    // this.userService.onUserChange()
    // .subscribe((user: any) => this.user = user);
    // if(this.user.role == 'admin'){
    //   this.admin_show = false;
    // }

    this.edu_form = this.formBuilder.group({
      courseNameCtrl: ['', Validators.required],
      collegeYearCtrl: ['', Validators.required],
      semesterCtrl: ['', Validators.required],
      monthCtrl: ['', Validators.required],
     
      yearCtrl: ['', Validators.required],
      endyearCtrl: [''],
      stlStdmonthCtrl :  [''],

      endmonthCtrl: [''],
      overAllGradeCtrl: [''],
      // stlStdmonthCtrl : [''],
      overAllgpasgpiCtrl: ['',[Validators.required , Validators.pattern("^[0-9]+(.[0-9]{0,2})?$")]],
      subjectFirstCtrl: [''],
      // markFirstCtrl: ['', Validators.required],
      // markFirstOutCtrl: ['', Validators.required],
      gradeFirstCtrl: ['', Validators.required],
      gradepointsFirstCtrl: ['', Validators.required],
      gradecreditsFirstCtrl: ['', Validators.required],
      subjectSecondCtrl: [''],
      markSecondCtrl: [''],
      markSecondOutCtrl: [''],
      gradeSecondCtrl: [''],
      gradepointsSecondCtrl: [''],
      gradecreditsSecondCtrl: [''],
      subjectThirdCtrl: [''],
      markThirdCtrl: [''],
      markThirdOutCtrl: [''],
      gradeThirdCtrl: [''],
      gradepointsThirdCtrl: [''],
      gradecreditsThirdCtrl: [''],
      subjectFourthCtrl: [''],
      markFourthCtrl: [''],
      markFourthOutCtrl: [''],
      gradeFourthCtrl: [''],
      gradepointsFourthCtrl: [''],
      gradecreditsFourthCtrl: [''],
      subjectFifthCtrl: [''],
      markFifthCtrl: [''],
      markFifthOutCtrl: [''],
      gradeFifthCtrl: [''],
      gradepointsFifthCtrl: [''],
      gradecreditsFifthCtrl: [''],
      subjectSixthCtrl: [''],
      markSixthCtrl: [''],
      markSixthOutCtrl: [''],
      gradeSixthCtrl: [''],
      gradepointsSixthCtrl: [''],
      gradecreditsSixthCtrl: [''],
      subjectSeventhCtrl: [''],
      markSeventhCtrl: [''],
      markSeventhOutCtrl: [''],
      gradeSeventhCtrl: [''],
      gradepointsSeventhCtrl: [''],
      gradecreditsSeventhCtrl: [''],
      subjectEighthCtrl: [''],
      markEighthCtrl: [''],
      markEighthOutCtrl: [''],
      gradeEighthCtrl: [''],
      gradepointsEighthCtrl: [''],
      gradecreditsEighthCtrl: [''],
      instructionCtrl: ['', Validators.required],
      subjectNinthCtrl: [''],
      markNinthCtrl: [''],
      markNinthOutCtrl: [''],
      gradeNinthCtrl: [''],
      gradepointsNinthCtrl: [''],
      gradecreditsNinthCtrl: [''],
      subjectTenthCtrl: [''],
      markTenthCtrl: [''],
      markTenthOutCtrl: [''],
      gradeTenthCtrl: [''],
      gradepointsTenthCtrl: [''],
      gradecreditsTenthCtrl: [''],
      specialInstrctionCtrl: [''],
      finalgradespecialInstrctionCtrl: [''],
      SpecialisationCtrl: [''],
      creditsEarnedCFirstCtrl: ['', Validators.required],
      creditsEarnedCSecondCtrl: [''],
      creditsEarnedCThirdCtrl: [''],
      creditsEarnedCFourthCtrl: [''],
      creditsEarnedCFifthCtrl: [''],
      creditsEarnedCSixthCtrl: [''],
      creditsEarnedCSevenCtrl: [''],
      creditsEarnedCEightCtrl: [''],
      creditsEarnedCNinthCtrl: [''],
      creditsEarnedCtehthCtrl: [''],
      internalMarksCtrl: [''],
      internalMarksSecondCtrl: [''],
      internalMarksThirdCtrl: [''],
      internalMarksFourthCtrl: [''],
      internalMarksFifthCtrl: [''],
      internalMarksSixthCtrl: [''],
      internalMarksSeventhCtrl: [''],
      internalMarksEightCtrl: [''],
      internalMarksNineCtrl: [''],
      internalMarksTenCtrl: [''],

      semEndFirstCtrl: [''],
      semEndSecondCtrl: [''],
      semEndThirdCtrl: [''],
      semEndFourthCtrl: [''],
      semEndFifthCtrl: [''],
      semEndSixthCtrl: [''],
      semEndSeventhCtrl: [''],
      semEndEightCtrl: [''],
      semEndNinthCtrl: [''],
      semEndTenthCtrl: [''],
      overmarksoutCtrl: [''],
      overAllpercentageCtrl: [''],


      totalCCtrl: ['', Validators.required],
      totalCnGCtrl: ['', Validators.required],
      seatNumberCtrl: ['', Validators.required],
      OverallCGPACtrl: [''],
      startyearCtrl: [''],
      markObtFirstCtrl: [''],
      markObtSecondCtrl: [''],
      markObtThirdCtrl: [''],
      markObtFourthCtrl: [''],
      markObtFifthCtrl: [''],
      markObtSixthCtrl: [''],
      markObtSeventhCtrl: [''],
      markObtEightCtrl: [''],
      markObtNinthCtrl: [''],
      markObtTenthCtrl: [''],

      iaFirstCtrl: [''],
      iaSecondCtrl: [''],
      iaThirdCtrl: [''],
      iaFourthCtrl: [''],
      iaFifthCtrl: [''],
      iaSixthCtrl: [''],
      iaSeventhCtrl: [''],
      iaEightCtrl: [''],
      iaNinthCtrl: [''],
      iaTenthCtrl: [''],

      thFirstCtrl: [''],
      thSecondCtrl: [''],
      thThirdCtrl: [''],
      thFourthCtrl: [''],
      thFifthCtrl: [''],
      thSixthCtrl: [''],
      thSeventhCtrl: [''],
      thEightCtrl: [''],
      thNinthCtrl: [''],
      thTenthCtrl: [''],

      courseCreditsFirstCtrl: [''],
      courseCreditsSecondCtrl: [''],
      courseCreditsThirdCtrl: [''],
      courseCreditsFourthCtrl: [''],
      courseCreditsFifthCtrl: [''],
      courseCreditsSixthCtrl: [''],
      courseCreditsSeventhCtrl: [''],
      courseCreditsEightCtrl: [''],
      courseCreditsNinthCtrl: [''],
      courseCreditsTenthCtrl: [''],
      totalMarksObtCtrl: [''],

      subjectEditFirstCtrl: [''],
      subjectEditSecondCtrl: [''],
      subjectEditThirdCtrl: [''],
      subjectEditFourthCtrl: [''],
      subjectEditFifthCtrl: [''],
      subjectEditSixthCtrl: [''],
      subjectEditSeventhCtrl: [''],
      subjectEditEightCtrl: [''],
      subjectEditNinthCtrl: [''],
      subjectEditTenthCtrl: [''],


      courseEdit1Ctrl: [''],
      courseEdit2Ctrl: [''],
      courseEdit3Ctrl: [''],
      courseEdit4Ctrl: [''],
      courseEdit5Ctrl: [''],
      courseEdit6Ctrl: [''],
      courseEdit7Ctrl: [''],
      courseEdit8Ctrl: [''],
      courseEdit9Ctrl: [''],
      courseEdit10Ctrl: [''],

      remarksCtrl: [''],
      resultCtrl: [''],
      footnotesCtrl : [''],
      sem1detailsctrl : [''],
      sem2detailsctrl : [''],
      sem3detailsctrl : [''],
      sgpiInstCtrl : [''],
      // finalGradeCtrl: [''],
    })

    if (this.college_year_auto == 'SemesterOne' || this.college_year_auto == 'SemesterTwo') {
      this.college_year = 'First';
      if (this.college_year_auto == 'SemesterOne') {
        this.semester_auto = 'I';
      } else {
        this.semester_auto = 'II';
      }
    } else if (this.college_year_auto == 'SemesterThree' || this.college_year_auto == 'SemesterFour') {
      this.college_year = 'Second';
      if (this.college_year_auto == 'SemesterThree') {
        this.semester_auto = 'III';
      } else {
        this.semester_auto = 'IV';
      }
    } else if (this.college_year_auto == 'SemesterFive' || this.college_year_auto == 'SemesterSix') {
      this.college_year = 'Third';
      if (this.college_year_auto == 'SemesterFive') {
        this.semester_auto = 'V';
      } else {
        this.semester_auto = 'VI';
      }
    }

    this.api.getStillStudying(this.user_id)
    .subscribe(
      (data: any) => {
        
        if (data['status'] == 200) {
          this.still_studying = data['data'];
          
          
          this.stillStudy = this.still_studying.stillStudying;
          
        } else {

        }
      });
      
    this.api.getCouses()
      .subscribe(
        (data: any) => {
          if (data['status'] == 200) {
            this.course_data = data['data'];
            if (this.course_name_auto != null) {
              this.course_data.forEach(element => {
                if (element.CourseName == this.course_name_auto || element.CourseShortForm == this.course_name_auto) {
                  this.course_name = element.CourseShortForm;
                  this.edu_level = element.type;
                }
              });
            }
           
          } else {

          }
          this.api.getCouseCode('sem', this.course_name, this.semester_auto, this.sgpi_gpa).subscribe((data: any) => {
            if (data["status"] == 200) {

              this.autocheck = false;
              this.filterText = "";
              this.course_code = data["data"];
              this.filterInput.valueChanges.debounceTime(200).subscribe((term) => {
                this.filterText = term;
              });

              // this.autocheck = false;
              this.filterText2 = "";
              this.course_code2 = data["data"];
              this.filterInput2.valueChanges.debounceTime(200).subscribe((term) => {
                this.filterText2 = term;
              });

              // this.autocheck = false;
              this.filterText3 = "";
              this.course_code3 = data["data"];
              this.filterInput3.valueChanges.debounceTime(200).subscribe((term) => {
                this.filterText3 = term;
              });

              // this.autocheck = false;
              this.filterText4 = "";
              this.course_code4 = data["data"];
              this.filterInput4.valueChanges.debounceTime(200).subscribe((term) => {
                this.filterText4 = term;
              });

              // this.autocheck = false;
              this.filterText5 = "";
              this.course_code5 = data["data"];
              this.filterInput5.valueChanges.debounceTime(200).subscribe((term) => {
                this.filterText5 = term;
              });

              // this.autocheck = false;
              this.filterText6 = "";
              this.course_code6 = data["data"];
              this.filterInput6.valueChanges.debounceTime(200).subscribe((term) => {
                this.filterText6 = term;
              });

              // this.autocheck = false;
              this.filterText7 = "";
              this.course_code7 = data["data"];
              this.filterInput7.valueChanges.debounceTime(200).subscribe((term) => {
                this.filterText7 = term;
              });

              // this.autocheck = false;
              this.filterText8 = "";
              this.course_code8 = data["data"];
              this.filterInput8.valueChanges.debounceTime(200).subscribe((term) => {
                this.filterText8 = term;
              });

              // this.autocheck = false;
              this.filterText9 = "";
              this.course_code9 = data["data"];
              this.filterInput9.valueChanges.debounceTime(200).subscribe((term) => {
                this.filterText9 = term;
              });

              // this.autocheck = false;
              this.filterText10 = "";
              this.course_code10 = data["data"];
              this.filterInput10.valueChanges.debounceTime(200).subscribe((term) => {
                this.filterText10 = term;
              });



              
            } else {
            }
          });
        });

    this.api.getAllSpecialisation()
      .subscribe(
        (data: any) => {
          if (data['status'] == 200) {
            this.specialisation_data = data['data'];
            if (this.specialisationlevel_auto != null) {
              this.specialisation_data.forEach(element => {
                
                if (element.specialisation_name == this.specialisationlevel_auto) {
                  this.specialisation_name = element.specialisation_name;
                }
              });
            }
           
          } else {

          }
        });

    const now = new Date().getUTCFullYear();
    this.years_array = Array(now - (now - 50)).fill('').map((v, idx) => now - idx);
    for (let info of this.years_array) {
      if (info >= this.enrollment_year_auto) {
        this.enrollYear.push(info)
      }
    }
    
    
    if (this.user_id != null && this.edu_id != null) {
      this.api.getEducation(this.edu_id, this.user_id)
        .subscribe(
          (data: any) => {
            if (data['status'] == 200) {
              this.edu_data = data['data'];
              if (this.edu_data.special_instruction1) {
                this.instruction1 = true;
                this.special_instruction1 = this.edu_data.special_instruction1;
              } else {
                this.instruction1 = false;
                this.special_instruction1 = null;
              }
              if (this.edu_data.special_instruction2) {
                this.instruction2 = true;
                this.special_instruction2 = this.edu_data.special_instruction2;
              } else {
                this.instruction2 = false;
                this.special_instruction2 = null;
              }
              if (this.edu_data.special_instruction3) {
                this.instruction3 = true;
                this.special_instruction3 = this.edu_data.special_instruction3;
              } else {
                this.instruction3 = false;
                this.special_instruction3 = null;
              }
              if (this.edu_data.special_instruction4) {
                this.instruction4 = true;
                this.special_instruction4 = this.edu_data.special_instruction4;
              } else {
                this.instruction4 = false;
                this.special_instruction4 = null;
              }
              if (this.edu_data.special_instruction5) {
                this.special_instruction5 = this.edu_data.special_instruction5;
                this.instruction5 = true;
              } else {
                this.instruction5 = false;
                this.special_instruction5 = null;
              }
              if (this.edu_data.special_instruction6) {
                this.instruction6 = true;
                this.special_instruction6 = this.edu_data.special_instruction6;
              } else {
                this.instruction6 = false;
                this.special_instruction6 = null;
              }
              if(this.edu_data.special_instruction7){
                this.instruction7=true;
                this.special_instruction7 =this.edu_data.special_instruction7;
              }else{
                this.instruction7=false;
                this.special_instruction7 =null;
              }
              this.course_name = this.edu_data.CourseName;
              this.college_year = this.edu_data.CollegeYear;
              this.semester_auto = this.edu_data.Semester;
              this.enrollment_year = this.edu_data.Year;
              this.specialisation_name = this.edu_data.specialisation;
              if (
                this.edu_data.course_code_first != null &&
                this.edu_data.course_code_first != "" &&
                this.edu_data.course_code_first != undefined
              ) {
                this.showcodeDropdown = false;
                setTimeout(() => {
                  
                  this.course_code.forEach((element) => {
                    
                    if (element["Course_code"] == this.edu_data.course_code_first) {
                      this.subjectArray.push(element);
                    }
                  });
                }, 3000);
                
              } else {
                
                this.showcodeDropdown = true;
              }
              if (this.edu_data.course_code_second != null) {
                this.showcodeDropdown2 = false;
                setTimeout(() => {
                  this.course_code2.forEach((element) => {
                    if (element["Course_code"] == this.edu_data.course_code_second) {
                      this.subjectArray2.push(element);
                    }
                  });
                }, 3000);
                
              } else {
                
                this.showcodeDropdown2 = true;
              }
              if (
                this.edu_data.course_code_third != null &&
                this.edu_data.course_code_third != "" &&
                this.edu_data.course_code_third != undefined
              ) {
                this.showcodeDropdown3 = false;
                
                setTimeout(() => {
                  this.course_code3.forEach((element) => {
                    if (
                      element["Course_code"] == this.edu_data.course_code_third
                    ) {
                      this.subjectArray3.push(element);
                    }
                  });
                }, 3000);
              } else {
                
                this.showcodeDropdown3 = true;
              }
              if (
                this.edu_data.course_code_fourth != null &&
                this.edu_data.course_code_fourth != "" &&
                this.edu_data.course_code_fourth != undefined
              ) {
                this.showcodeDropdown4 = false;
                
                setTimeout(() => {
                  this.course_code4.forEach((element) => {
                    if (
                      element["Course_code"] == this.edu_data.course_code_fourth
                    ) {
                      this.subjectArray4.push(element);
                    }
                  });
                }, 4000);
              } else {
                
                this.showcodeDropdown4 = true;
              }
              if (
                this.edu_data.course_code_fifth != null &&
                this.edu_data.course_code_fifth != "" &&
                this.edu_data.course_code_fifth != undefined
              ) {
                this.showcodeDropdown5 = false;
                
                setTimeout(() => {
                  this.course_code5.forEach((element) => {
                    if (
                      element["Course_code"] == this.edu_data.course_code_fifth
                    ) {
                      this.subjectArray5.push(element);
                    }
                  });
                }, 4000);
              } else {
                
                this.showcodeDropdown5 = true;
              }
              if (
                this.edu_data.course_code_sixth != null &&
                this.edu_data.course_code_sixth != "" &&
                this.edu_data.course_code_sixth != undefined
              ) {
                this.showcodeDropdown6 = false;
                
                setTimeout(() => {
                  this.course_code6.forEach((element) => {
                    if (element["Course_code"] == this.edu_data.course_code_sixth) {
                      this.subjectArray6.push(element);
                    }
                  });
                }, 4000);
              } else {
                
                this.showcodeDropdown6 = true;
              }
              if (
                this.edu_data.course_code_seventh != null &&
                this.edu_data.course_code_seventh != "" &&
                this.edu_data.course_code_seventh != undefined
              ) {
                this.showcodeDropdown7 = false;
                
                setTimeout(() => {
                  this.course_code7.forEach((element) => {
                    if (
                      element["Course_code"] == this.edu_data.course_code_seventh
                    ) {
                      this.subjectArray7.push(element);
                    }
                  });
                }, 4000);
              } else {
                
                this.showcodeDropdown7 = true;
              }
              if (
                this.edu_data.course_code_eight != null &&
                this.edu_data.course_code_eight != "" &&
                this.edu_data.course_code_eight != undefined
              ) {
                this.showcodeDropdown8 = false;
                setTimeout(() => {
                  this.course_code8.forEach((element) => {
                    if (
                      element["Course_code"] == this.edu_data.course_code_eight
                    ) {
                      this.subjectArray8.push(element);
                    }
                  });
                }, 5000);
                
              } else {
                
                this.showcodeDropdown8 = true;
              }
              if (
                this.edu_data.course_code_ninth != null &&
                this.edu_data.course_code_ninth != "" &&
                this.edu_data.course_code_ninth != undefined
              ) {
                this.showcodeDropdown9 = false;
                setTimeout(() => {
                  this.course_code9.forEach((element) => {
                    if (
                      element["Course_code"] == this.edu_data.course_code_ninth
                    ) {
                      this.subjectArray9.push(element);
                    }
                  });
                }, 4000);
                
              } else {
                
                this.showcodeDropdown9 = true;
              }
              if (
                this.edu_data.course_code_tenth != null &&
                this.edu_data.course_code_tenth != "" &&
                this.edu_data.course_code_tenth != undefined
              ) {
                this.showcodeDropdown10 = false;
                setTimeout(() => {
                  this.course_code10.forEach((element) => {
                    if (
                      element["Course_code"] == this.edu_data.course_code_tenth
                    ) {
                      this.subjectArray10.push(element);
                    }
                  });
                }, 4000);
                
              } else {
                
                this.showcodeDropdown10 = true;
              }
              if (this.edu_data.Subject_First != null && this.edu_data.Subject_First != '' && this.edu_data.Subject_First != undefined) {
                this.showcodeDropdown = false
                
              } else {
                
                this.showcodeDropdown = true
              }
              if (this.edu_data.Subject_Second != null) {
                this.showcodeDropdown2 = false
                
              } else {
                
                this.showcodeDropdown2 = true
              }
              if (this.edu_data.Subject_Third != null && this.edu_data.Subject_Third != '' && this.edu_data.Subject_Third != undefined) {
                this.showcodeDropdown3 = false
                
              } else {
                
                this.showcodeDropdown3 = true
              }
              if (this.edu_data.Subject_Fourth != null && this.edu_data.Subject_Fourth != '' && this.edu_data.Subject_Fourth != undefined) {
                this.showcodeDropdown4 = false
                
              } else {
                
                this.showcodeDropdown4 = true
              }
              if (this.edu_data.Subject_Fifth != null && this.edu_data.Subject_Fifth != '' && this.edu_data.Subject_Fifth != undefined) {
                this.showcodeDropdown5 = false
                
              } else {
                
                this.showcodeDropdown5 = true
              }
              if (this.edu_data.Subject_Six != null && this.edu_data.Subject_Six != '' && this.edu_data.Subject_Six != undefined) {
                this.showcodeDropdown6 = false
                
              } else {
                
                this.showcodeDropdown6 = true
              }
              if (this.edu_data.Subject_Seventh != null && this.edu_data.Subject_Seventh != '' && this.edu_data.Subject_Seventh != undefined) {
                this.showcodeDropdown7 = false
                
              } else {
                
                this.showcodeDropdown7 = true
              }
              if (this.edu_data.Subject_Eighth != null && this.edu_data.Subject_Eighth != '' && this.edu_data.Subject_Eighth != undefined) {
                this.showcodeDropdown8 = false
                
              } else {
                
                this.showcodeDropdown8 = true
              }

              if (this.edu_data.Subject_Ninth != null && this.edu_data.Subject_Ninth != '' && this.edu_data.Subject_Ninth != undefined) {
                this.showcodeDropdown9 = false
                
              } else {
                
                this.showcodeDropdown9 = true
              }
              if (this.edu_data.Subject_Tenth != null && this.edu_data.Subject_Tenth != '' && this.edu_data.Subject_Tenth != undefined) {
                this.showcodeDropdown10 = false
                
              } else {
                
                this.showcodeDropdown10 = true
              }
             
            } else {
              
            }
          });
    } else {

    }
  }

  getCourse(value) {
    
    //this.filterText = "";
    this.subjectName = value;


    var count = 0;
    this.newcourse_code = [];
    this.course_code.forEach((element) => {
      if (element["Course_code"] == value["Course_code"]) {
        this.subjectArray.push(element);
      }
      count++;
      if (element["id"] == this.subjectName["id"]) {
        
      } else {
        
        this.newcourse_code.push(element);

        
      }

      if (count == this.course_code.length) {
        this.course_code = this.newcourse_code;
      }
    });
    //this.filterPlaceholder = "Search";
    // this.adminApi.getAllCourse(value).subscribe((data)=>{
    //   this.courses = data['data'];
    // })
    // this.filterInput
    //   .valueChanges
    //   .debounceTime(200)
    //   .subscribe(term => {
    //   this.filterText = term;
    // });
  }

  getSubject(event: any) {
    
    this.withoutCodeSub = event.target.value;
    for (let a of this.course_code2) {
     
      if (a.Course_code == this.withoutCodeSub) {
        
        this.subjectName = a;
      }
    }
    if (this.subjectName) {
      
    } else {
      
    }
  }

  getCourse2(value) {
    
    //this.filterText = "";
    this.subjectName2 = value;
    this.course_code2.forEach((element) => {
      if (element["Course_code"] == value["Course_code"]) {
        this.subjectArray2.push(element);
      }
    });

    var count = 0;
    this.newcourse_code = [];
    this.course_code3.forEach((element) => {
      count++;
      if (
        element["id"] == this.subjectName["id"] ||
        element["id"] == this.subjectName2["id"]
      ) {
        
      } else {
        
        this.newcourse_code.push(element);

        
      }

      if (count == this.course_code3.length) {
        this.course_code3 = [];
        this.course_code3 = this.newcourse_code;
      }
    });
  }

  getSubject2(event: any) {
    
    this.withoutCodeSub2 = event.target.value;
    for (let a of this.course_code) {
     
      if (a.Course_code == this.withoutCodeSub2) {
        
        this.subjectName2 = a;
      }
    }
  }

  getCourse3(value) {
    this.subjectName3 = value;
    this.course_code3.forEach((element) => {
      if (element["Course_code"] == value["Course_code"]) {
        this.subjectArray3.push(element);
      }
    });


    var count = 0;
    this.newcourse_code = [];
    this.course_code4.forEach((element) => {
      count++;
      if (
        element["id"] == this.subjectName["id"] ||
        element["id"] == this.subjectName2["id"] ||
        element["id"] == this.subjectName3["id"]
      ) {
        
      } else {
        
        this.newcourse_code.push(element);

        
      }

      if (count == this.course_code4.length) {
        this.course_code4 = [];
        this.course_code4 = this.newcourse_code;
      }
    });
  }

  getSubject3(event: any) {
    this.withoutCodeSub3 = event.target.value;
    for (let a of this.course_code3) {
     
      if (a.Course_code == this.withoutCodeSub3) {
        this.subjectName3 = a;
      }
    }
  }

  getCourse4(value) {
    this.subjectName4 = value;
    this.course_code4.forEach((element) => {
      if (element["Course_code"] == value["Course_code"]) {
        this.subjectArray4.push(element);
      }
    });


    var count = 0;
    this.newcourse_code = [];
    this.course_code5.forEach((element) => {
      count++;
      if (
        element["id"] == this.subjectName["id"] ||
        element["id"] == this.subjectName2["id"] ||
        element["id"] == this.subjectName3["id"] ||
        element["id"] == this.subjectName4["id"]
      ) {
      } else {
        this.newcourse_code.push(element);

        
      }

      if (count == this.course_code5.length) {
        this.course_code5 = [];
        this.course_code5 = this.newcourse_code;
      }
    });
  }

  getSubject4(event: any) {
   
    this.withoutCodeSub4 = event.target.value;
    for (let a of this.course_code4) {
     
      if (a.Course_code == this.withoutCodeSub4) {
       
        this.subjectName4 = a;
      }
    }
  }

  getCourse5(value) {
    this.subjectName5 = value;
    this.course_code5.forEach((element) => {
      if (element["Course_code"] == value["Course_code"]) {
        this.subjectArray5.push(element);
      }
    });


    var count = 0;
    this.newcourse_code = [];
    this.course_code6.forEach((element) => {
      count++;
      if (
        element["id"] == this.subjectName["id"] ||
        element["id"] == this.subjectName2["id"] ||
        element["id"] == this.subjectName3["id"] ||
        element["id"] == this.subjectName4["id"] ||
        element["id"] == this.subjectName5["id"]
      ) {
      } else {
        this.newcourse_code.push(element);

        
      }

      if (count == this.course_code6.length) {
        this.course_code6 = [];
        this.course_code6 = this.newcourse_code;
      }
    });
  }

  getSubject5(event: any) {
    
    this.withoutCodeSub5 = event.target.value;
    for (let a of this.course_code5) {
     
      if (a.Course_code == this.withoutCodeSub5) {
        
        this.subjectName5 = a;
      }
    }
  }

  getCourse6(value) {
    this.subjectName6 = value;
    this.course_code6.forEach((element) => {
      if (element["Course_code"] == value["Course_code"]) {
        this.subjectArray6.push(element);
      }
    });



    var count = 0;
    this.newcourse_code = [];
    this.course_code7.forEach((element) => {
      count++;
      if (
        element["id"] == this.subjectName["id"] ||
        element["id"] == this.subjectName2["id"] ||
        element["id"] == this.subjectName3["id"] ||
        element["id"] == this.subjectName4["id"] ||
        element["id"] == this.subjectName5["id"] ||
        element["id"] == this.subjectName6["id"]
      ) {
      } else {
        this.newcourse_code.push(element);

        
      }

      if (count == this.course_code7.length) {
        this.course_code7 = [];
        this.course_code7 = this.newcourse_code;
      }
    });
  }

  getSubject6(event: any) {
    
    this.withoutCodeSub6 = event.target.value;
    for (let a of this.course_code6) {
     
      if (a.Course_code == this.withoutCodeSub6) {
        
        this.subjectName6 = a;
      }
    }
  }

  getCourse7(value) {
    this.subjectName7 = value;
    this.course_code7.forEach((element) => {
      if (element["Course_code"] == value["Course_code"]) {
        this.subjectArray7.push(element);
      }
    });


    var count = 0;
    this.newcourse_code = [];
    this.course_code8.forEach((element) => {
      count++;
      if (
        element["id"] == this.subjectName["id"] ||
        element["id"] == this.subjectName2["id"] ||
        element["id"] == this.subjectName3["id"] ||
        element["id"] == this.subjectName4["id"] ||
        element["id"] == this.subjectName5["id"] ||
        element["id"] == this.subjectName6["id"] ||
        element["id"] == this.subjectName7["id"]
      ) {
      } else {
        this.newcourse_code.push(element);

        
      }

      if (count == this.course_code8.length) {
        this.course_code8 = [];
        this.course_code8 = this.newcourse_code;
      }
    });
  }

  getSubject8(event: any) {
   
    this.withoutCodeSub8 = event.target.value;
    for (let a of this.course_code8) {
     
      if (a.Course_code == this.withoutCodeSub8) {
       
        this.subjectName8 = a;
      }
    }
  }
  getCourse8(value) {
    this.subjectName8 = value;
    this.course_code8.forEach((element) => {
      if (element["Course_code"] == value["Course_code"]) {
        this.subjectArray8.push(element);
      }
    });

  }
  getSubject9(event: any) {
    
    this.withoutCodeSub9 = event.target.value;
    for (let a of this.course_code9) {
     
      if (a.Course_code == this.withoutCodeSub9) {
        
        this.subjectName9 = a;
      }
    }
  }
  getCourse10(value) {
    this.subjectName10 = value;
    this.course_code10.forEach((element) => {
      if (element["Course_code"] == value["Course_code"]) {
        this.subjectArray10.push(element);
      }
    });

  }

  getSubject10(event: any) {
    
    this.withoutCodeSub10 = event.target.value;
    for (let a of this.course_code10) {
     
      if (a.Course_code == this.withoutCodeSub10) {
        
        this.subjectName10 = a;
      }
    }
  }
  getCourse9(value) {
    this.subjectName9 = value;
    this.course_code9.forEach((element) => {
      if (element["Course_code"] == value["Course_code"]) {
        this.subjectArray9.push(element);
      }
    });

  }

  getSubject7(event: any) {
    
    this.withoutCodeSub7 = event.target.value;
    for (let a of this.course_code7) {
     
      if (a.Course_code == this.withoutCodeSub7) {
       
        this.subjectName7 = a;
      }
    }
  }

  editDropdown() {
    this.showcodeDropdown = true
    this.preEditFirst = true;
    this.api.getCouseCodeEdit('sem', this.course_name_auto, this.semester_auto, this.specialisation_name, this.college_year, this.sgpi_gpa)
      .subscribe(
        (data: any) => {
          
          if (data['status'] == 200) {
            // this.autocheck = false
            this.course_code2 = data['data']
            this.filterText2 = "";
            this.filterInput2
              .valueChanges
              .debounceTime(200)
              .subscribe(term => {
                this.filterText2 = term;
                //this.filterText2 = term;
              });


            
          } else {

          }
        });
  }

  editDropdown2() {
    
    
    this.showcodeDropdown2 = true
    this.preEditSecond = true;
    this.api.getCouseCodeEdit('sem', this.course_name_auto, this.semester_auto, this.specialisation_name, this.college_year, this.sgpi_gpa)
      .subscribe(
        (info: any) => {
          
          if (info['status'] == 200) {
            this.autocheck = false
            this.filterText = "";
            this.course_code = info['data'];

            this.filterInput
              .valueChanges
              .debounceTime(200)
              .subscribe(term => {
                //this.filterText = term;
                this.filterText = term;
              });
            
          } else {

          }
        });
  }

  editDropdown3() {
    this.showcodeDropdown3 = true
    this.preEditThird = true;
    this.api.getCouseCodeEdit('sem', this.course_name_auto, this.semester_auto, this.specialisation_name, this.college_year, this.sgpi_gpa)
      .subscribe(
        (info: any) => {
          
          if (info['status'] == 200) {
            this.autocheck = false
            this.filterText3 = "";
            this.course_code3 = info['data'];

            this.filterInput3
              .valueChanges
              .debounceTime(200)
              .subscribe(term => {
                //this.filterText = term;
                this.filterText3 = term;
              });
            
          } else {

          }
        });
  }

  editDropdown4() {
    this.showcodeDropdown4 = true
    this.preEditFourth = true;
    this.api.getCouseCodeEdit('sem', this.course_name_auto, this.semester_auto, this.specialisation_name, this.college_year, this.sgpi_gpa)
      .subscribe(
        (info: any) => {
          
          if (info['status'] == 200) {
            this.autocheck = false
            this.filterText4 = "";
            this.course_code4 = info['data'];

            this.filterInput3
              .valueChanges
              .debounceTime(200)
              .subscribe(term => {
                //this.filterText = term;
                this.filterText4 = term;
              });
            
          } else {

          }
        });
  }

  editDropdown5() {
    this.showcodeDropdown5 = true
    this.preEditFifth = true;
    this.api.getCouseCodeEdit('sem', this.course_name_auto, this.semester_auto, this.specialisation_name, this.college_year, this.sgpi_gpa)
      .subscribe(
        (info: any) => {
          
          if (info['status'] == 200) {
            this.autocheck = false
            this.filterText5 = "";
            this.course_code5 = info['data'];

            this.filterInput5
              .valueChanges
              .debounceTime(200)
              .subscribe(term => {
                //this.filterText = term;
                this.filterText5 = term;
              });
            
          } else {

          }
        });
  }

  editDropdown6() {
    this.showcodeDropdown6 = true
    this.preEditSixth = true;
    this.api.getCouseCodeEdit('sem', this.course_name_auto, this.semester_auto, this.specialisation_name, this.college_year, this.sgpi_gpa)
      .subscribe(
        (info: any) => {
          
          if (info['status'] == 200) {
            this.autocheck = false
            this.filterText6 = "";
            this.course_code6 = info['data'];

            this.filterInput6
              .valueChanges
              .debounceTime(200)
              .subscribe(term => {
                //this.filterText = term;
                this.filterText6 = term;
              });
            
          } else {

          }
        });
  }

  editDropdown7() {
    this.showcodeDropdown7 = true
    this.preEditSeventh = true;
    this.api.getCouseCodeEdit('sem', this.course_name_auto, this.semester_auto, this.specialisation_name, this.college_year, this.sgpi_gpa)
      .subscribe(
        (info: any) => {
          
          if (info['status'] == 200) {
            this.autocheck = false
            this.filterText7 = "";
            this.course_code7 = info['data'];

            this.filterInput7
              .valueChanges
              .debounceTime(200)
              .subscribe(term => {
                //this.filterText = term;
                this.filterText7 = term;
              });
            
          } else {

          }
        });
  }

  editDropdown8() {
    this.showcodeDropdown8 = true
    this.preEditEight = true;
    this.api.getCouseCodeEdit('sem', this.course_name_auto, this.semester_auto, this.specialisation_name, this.college_year, this.sgpi_gpa)
      .subscribe(
        (info: any) => {
          
          if (info['status'] == 200) {
            this.autocheck = false
            this.filterText8 = "";
            this.course_code8 = info['data'];

            this.filterInput8
              .valueChanges
              .debounceTime(200)
              .subscribe(term => {
                //this.filterText = term;
                this.filterText8 = term;
              });
            
          } else {

          }
        });
  }

  editDropdown9() {
    this.showcodeDropdown9 = true
    this.preEditNinth = true;
    this.api.getCouseCodeEdit('sem', this.course_name_auto, this.semester_auto, this.specialisation_name, this.college_year, this.sgpi_gpa)
      .subscribe(
        (info: any) => {
          
          if (info['status'] == 200) {
            this.autocheck = false
            this.filterText9 = "";
            this.course_code9 = info['data'];

            this.filterInput9
              .valueChanges
              .debounceTime(200)
              .subscribe(term => {
                //this.filterText = term;
                this.filterText9 = term;
              });
            
          } else {

          }
        });
  }

  editDropdown10() {
    this.preEditTenth = true;
    this.showcodeDropdown10 = true
    this.api.getCouseCodeEdit('sem', this.course_name_auto, this.semester_auto, this.specialisation_name, this.college_year, this.sgpi_gpa)
      .subscribe(
        (info: any) => {
          
          if (info['status'] == 200) {
            this.autocheck = false
            this.filterText10 = "";
            this.course_code10 = info['data'];

            this.filterInput10
              .valueChanges
              .debounceTime(200)
              .subscribe(term => {
                //this.filterText = term;
                this.filterText10 = term;
              });
            
          } else {

          }
        });
  }

  showContactDetails() {
    this.confirmationService.confirm({
      message: 'Email - lsraheja@etranscript.in &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;  &nbsp;' + ' Whatsapp -  022 2287 6115',
      header: 'Please contact the admin on ',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {

      },
      reject: () => {

      }
    });
  }


  saveEdu() {
    this.courseValidation = true;
    this.collegeYearValidation = true;
    this.semesterValidation = true;
    this.monthValidation = true;
    this.yearValidation = true;
    this.attemptValidation = true;
    this.instructionValidation = true;
    this.endYearValidation = true;

    if (this.edu_form.controls.semesterCtrl.value) {
      if (this.edu_form.controls.endmonthCtrl.value) {
        this.startmonth = this.edu_form.controls.endmonthCtrl.value
      } else {
        if (this.edu_form.controls.semesterCtrl.value == 'I' || this.edu_form.controls.semesterCtrl.value == 'III' || this.edu_form.controls.semesterCtrl.value == 'V') {
          this.startmonth = 'June'
        } else {
          this.startmonth = 'November'
        }
      }

    }

    if (this.edu_form.valid == false) {
      this.edu_form.controls.courseNameCtrl.markAsDirty();
      // this.edu_form.controls.overAllGradeCtrl.markAsDirty();
      this.edu_form.controls.overAllgpasgpiCtrl.markAsDirty();
      //this.edu_form.controls.subjectFirstCtrl.markAsDirty();
      this.edu_form.controls.markFirstCtrl.markAsDirty();
      this.edu_form.controls.markFirstOutCtrl.markAsDirty();
      this.edu_form.controls.gradeFirstCtrl.markAsDirty();
      this.edu_form.controls.gradepointsFirstCtrl.markAsDirty();
      this.edu_form.controls.gradecreditsFirstCtrl.markAsDirty();
      // this.edu_form.controls.subjectSecondCtrl.markAsDirty();
      // this.edu_form.controls.markSecondCtrl.markAsDirty();
      // this.edu_form.controls.markSecondOutCtrl.markAsDirty();
      // this.edu_form.controls.gradeSecondCtrl.markAsDirty();
      // this.edu_form.controls.gradepointsSecondCtrl.markAsDirty();
      // this.edu_form.controls.gradecreditsSecondCtrl.markAsDirty();
      // this.edu_form.controls.subjectThirdCtrl.markAsDirty();
      // this.edu_form.controls.markThirdCtrl.markAsDirty();
      // this.edu_form.controls.markThirdOutCtrl.markAsDirty();
      // this.edu_form.controls.gradeThirdCtrl.markAsDirty();
      // this.edu_form.controls.gradepointsThirdCtrl.markAsDirty();
      // this.edu_form.controls.gradecreditsThirdCtrl.markAsDirty();
      // this.edu_form.controls.subjectFourthCtrl.markAsDirty();
      // this.edu_form.controls.markFourthCtrl.markAsDirty();
      // this.edu_form.controls.markFourthOutCtrl.markAsDirty();
      // this.edu_form.controls.gradeFourthCtrl.markAsDirty();
      // this.edu_form.controls.gradepointsFourthCtrl.markAsDirty();
      // this.edu_form.controls.gradecreditsFourthCtrl.markAsDirty();
      this.edu_form.controls.instructionCtrl.markAsDirty();
      this.edu_form.controls.totalCCtrl.markAsDirty();
      this.edu_form.controls.totalCnGCtrl.markAsDirty();

      if (this.edu_form.controls.instructionCtrl.value === null || this.edu_form.controls.instructionCtrl.value === '' || this.edu_form.controls.instructionCtrl.value === undefined) {
        this.instructionValidation = false;
      } else {
        this.instructionValidation = true;
      }

      if (this.edu_form.controls.courseNameCtrl.value === null || this.edu_form.controls.courseNameCtrl.value === '' || this.edu_form.controls.courseNameCtrl.value === undefined) {
        this.courseValidation = false;
      } else {
        this.courseValidation = true;
      }

      if (this.edu_form.controls.collegeYearCtrl.value === null || this.edu_form.controls.collegeYearCtrl.value === '' || this.edu_form.controls.collegeYearCtrl.value === undefined) {
        this.collegeYearValidation = false;
      } else {
        this.collegeYearValidation = true;
      }

      if (this.edu_form.controls.semesterCtrl.value === null || this.edu_form.controls.semesterCtrl.value === '' || this.edu_form.controls.semesterCtrl.value === undefined) {
        this.semesterValidation = false;
      } else {
        this.semesterValidation = true;
      }

      if (this.edu_form.controls.monthCtrl.value === null || this.edu_form.controls.monthCtrl.value === '' || this.edu_form.controls.monthCtrl.value === undefined) {
        this.monthValidation = false;
      } else {
        this.monthValidation = true;
      }

      if (this.edu_form.controls.yearCtrl.value === null || this.edu_form.controls.yearCtrl.value === '' || this.edu_form.controls.yearCtrl.value === undefined) {
        this.yearValidation = false;
      } else {
        this.yearValidation = true;
      }

      // if(this.edu_form.controls.endmonthCtrl.value === null || this.edu_form.controls.endmonthCtrl.value ==='' || this.edu_form.controls.endmonthCtrl.value ===undefined){
      //   this.endmonthValidation = false;
      // }else {
      //   this.endmonthValidation = true;
      // }

      // if(this.edu_form.controls.endyearCtrl.value === null || this.edu_form.controls.endyearCtrl.value ==='' || this.edu_form.controls.endyearCtrl.value ===undefined){
      //   this.endYearValidation = false;
      // }else {
      //   this.endYearValidation = true;
      // }
    } else {
      var edu_data = {
        courseName: this.edu_form.controls.courseNameCtrl.value,
        collegeYear: this.edu_form.controls.collegeYearCtrl.value,
        semester: this.edu_form.controls.semesterCtrl.value,
        month: this.edu_form.controls.monthCtrl.value,
        year: this.edu_form.controls.yearCtrl.value,
        endmonth: this.startmonth ? this.startmonth : this.edu_form.controls.endmonthCtrl.value,
        startYear: this.startYear ? this.startYear : this.edu_form.controls.startyearCtrl.value,
        endYear: this.edu_form.controls.endyearCtrl.value,
        overAllGrade: this.edu_form.controls.overAllGradeCtrl.value.toUpperCase(),
        overall_gpa_sgpi: this.edu_form.controls.overAllgpasgpiCtrl.value,
        subjectFirst: this.subjectName ? this.subjectName['Course_Subject_name'] : this.withoutCodeSub,
        //subjectFirst : this.edu_form.controls.subjectFirstCtrl.value,
        marks_obt_First: this.edu_form.controls.markObtFirstCtrl.value,
        // marks_out_First: this.edu_form.controls.markFirstOutCtrl.value,
        markFirst: this.edu_form.controls.gradeFirstCtrl.value,
        grade_points_First: this.edu_form.controls.gradepointsFirstCtrl.value,
        grade_credits_First: this.edu_form.controls.gradecreditsFirstCtrl.value,
        //subjectSecond : this.edu_form.controls.subjectSecondCtrl.value,
        subjectSecond: this.subjectName2 ? this.subjectName2['Course_Subject_name'] : this.withoutCodeSub2,
        marks_obt_Second: this.edu_form.controls.markObtSecondCtrl.value,
        marks_out_Second: this.edu_form.controls.markSecondOutCtrl.value,
        markSecond: this.edu_form.controls.gradeSecondCtrl.value,
        grade_points_Second: this.edu_form.controls.gradepointsSecondCtrl.value,
        grade_credits_Second: this.edu_form.controls.gradecreditsSecondCtrl.value,
        subjectThird: this.subjectName3 ? this.subjectName3['Course_Subject_name'] : this.withoutCodeSub3,
        //subjectThird : this.edu_form.controls.subjectThirdCtrl.value,
        marks_obt_Third: this.edu_form.controls.markObtThirdCtrl.value,
        marks_out_Third: this.edu_form.controls.markThirdOutCtrl.value,
        markThird: this.edu_form.controls.gradeThirdCtrl.value,
        grade_points_Third: this.edu_form.controls.gradepointsThirdCtrl.value,
        grade_credits_Third: this.edu_form.controls.gradecreditsThirdCtrl.value,
        subjectFourth: this.subjectName4 ? this.subjectName4['Course_Subject_name'] : this.withoutCodeSub4,
        //subjectFourth : this.edu_form.controls.subjectFourthCtrl.value,
        marks_obt_Fourth: this.edu_form.controls.markObtFourthCtrl.value,
        marks_out_Fourth: this.edu_form.controls.markFourthOutCtrl.value,
        markFourth: this.edu_form.controls.gradeFourthCtrl.value,
        grade_points_Fourth: this.edu_form.controls.gradepointsFourthCtrl.value,
        grade_credits_Fourth: this.edu_form.controls.gradecreditsFourthCtrl.value,
        subjectFifth: this.subjectName5 ? this.subjectName5['Course_Subject_name'] : this.withoutCodeSub5,
        //subjectFifth : this.edu_form.controls.subjectFifthCtrl.value,
        marks_obt_Fifth: this.edu_form.controls.markObtFifthCtrl.value,
        marks_out_Fifth: this.edu_form.controls.markFifthOutCtrl.value,
        markFifth: this.edu_form.controls.gradeFifthCtrl.value,
        grade_points_Fifth: this.edu_form.controls.gradepointsFifthCtrl.value,
        grade_credits_Fifth: this.edu_form.controls.gradecreditsFifthCtrl.value,
        //subjectSixth : this.edu_form.controls.subjectSixthCtrl.value,
        subjectSixth: this.subjectName6 ? this.subjectName6['Course_Subject_name'] : this.withoutCodeSub6,
        marks_obt_Six: this.edu_form.controls.markObtSixthCtrl.value,
        marks_out_Six: this.edu_form.controls.markSixthOutCtrl.value,
        markSixth: this.edu_form.controls.gradeSixthCtrl.value,
        grade_points_Six: this.edu_form.controls.gradepointsSixthCtrl.value,
        grade_credits_Six: this.edu_form.controls.gradecreditsSixthCtrl.value,
        subjectSeventh: this.subjectName7 ? this.subjectName7['Course_Subject_name'] : this.withoutCodeSub7,
        //subjectSeventh : this.edu_form.controls.subjectSeventhCtrl.value,
        marks_obt_Seventh: this.edu_form.controls.markObtSeventhCtrl.value,
        marks_out_Seventh: this.edu_form.controls.markSeventhOutCtrl.value,
        markSeventh: this.edu_form.controls.gradeSeventhCtrl.value,
        grade_points_Seventh: this.edu_form.controls.gradepointsSeventhCtrl.value,
        grade_credits_Seventh: this.edu_form.controls.gradecreditsSeventhCtrl.value,
        subjectEighth: this.subjectName8 ? this.subjectName8['Course_Subject_name'] : this.withoutCodeSub8,
        //subjectEighth : this.edu_form.controls.subjectEighthCtrl.value,
        marks_obt_Eighth: this.edu_form.controls.markObtEightCtrl.value,
        marks_out_Eighth: this.edu_form.controls.markEighthOutCtrl.value,
        markEighth: this.edu_form.controls.gradeEighthCtrl.value,
        grade_points_Eighth: this.edu_form.controls.gradepointsEighthCtrl.value,
        grade_credits_Eighth: this.edu_form.controls.gradecreditsEighthCtrl.value,
        subjectNinth: this.subjectName9 ? this.subjectName9['Course_Subject_name'] : this.withoutCodeSub9,
        //subjectNinth : this.edu_form.controls.subjectNinthCtrl.value,
        marks_obt_Ninth: this.edu_form.controls.markObtNinthCtrl.value,
        marks_out_Ninth: this.edu_form.controls.markNinthOutCtrl.value,
        markNinth: this.edu_form.controls.gradeNinthCtrl.value,
        grade_points_Ninth: this.edu_form.controls.gradepointsNinthCtrl.value,
        grade_credits_Ninth: this.edu_form.controls.gradecreditsNinthCtrl.value,
        subjectTenth: this.subjectName10 ? this.subjectName10['Course_Subject_name'] : this.withoutCodeSub10,
        //subjectTenth : this.edu_form.controls.subjectTenthCtrl.value,
        marks_obt_Tenth: this.edu_form.controls.markObtTenthCtrl.value,
        marks_out_Tenth: this.edu_form.controls.markTenthOutCtrl.value,
        markTenth: this.edu_form.controls.gradeTenthCtrl.value,
        grade_points_Tenth: this.edu_form.controls.gradepointsTenthCtrl.value,
        grade_credits_Tenth: this.edu_form.controls.gradecreditsTenthCtrl.value,
        user_id: this.user_id,
        medium_instruction: this.edu_form.controls.instructionCtrl.value,
        id: this.edu_id,
        special_instruction: this.specialInstruction ? this.specialInstruction : this.specI,
        final_grade_special_instruction: this.GradespecialInstruction ? this.GradespecialInstruction : this.DradespecI,
        // special_instruction : this.edu_form.controls.specialInstrctionCtrl.value,
        // final_grade_special_instruction : this.edu_form.controls.finalgradespecialInstrctionCtrl.value,
        // total_weeks : this.edu_form.controls.SpecialisationCtrl.value,

        internal_Marks: this.edu_form.controls.internalMarksCtrl.value,
        internal_Marks_Second: this.edu_form.controls.internalMarksSecondCtrl.value,
        internal_Marks_Third: this.edu_form.controls.internalMarksThirdCtrl.value,
        internal_Marks_Fourth: this.edu_form.controls.internalMarksFourthCtrl.value,
        internal_Marks_Fifth: this.edu_form.controls.internalMarksFifthCtrl.value,
        internal_Marks_Sixth: this.edu_form.controls.internalMarksSixthCtrl.value,
        internal_Marks_Seventh: this.edu_form.controls.internalMarksSeventhCtrl.value,
        internal_Marks_Eight: this.edu_form.controls.internalMarksEightCtrl.value,
        internal_Marks_Nine: this.edu_form.controls.internalMarksNineCtrl.value,
        internal_Marks_Ten: this.edu_form.controls.internalMarksTenCtrl.value,

        credits_Earned_c_First: this.edu_form.controls.creditsEarnedCFirstCtrl.value.toUpperCase(),
        credits_Earned_c_Second: this.edu_form.controls.creditsEarnedCSecondCtrl.value.toUpperCase(),
        credits_Earned_c_Third: this.edu_form.controls.creditsEarnedCThirdCtrl.value.toUpperCase(),
        credits_Earned_c_Fourth: this.edu_form.controls.creditsEarnedCFourthCtrl.value.toUpperCase(),
        credits_Earned_c_Fifth: this.edu_form.controls.creditsEarnedCFifthCtrl.value.toUpperCase(),
        credits_Earned_c_Sixth: this.edu_form.controls.creditsEarnedCSixthCtrl.value.toUpperCase(),
        credits_Earned_c_Seven: this.edu_form.controls.creditsEarnedCSevenCtrl.value.toUpperCase(),
        credits_Earned_c_Eight: this.edu_form.controls.creditsEarnedCEightCtrl.value.toUpperCase(),
        credits_Earned_c_Ninth: this.edu_form.controls.creditsEarnedCNinthCtrl.value.toUpperCase(),
        credits_Earned_c_tehth: this.edu_form.controls.creditsEarnedCtehthCtrl.value.toUpperCase(),

        sem_end_first: this.edu_form.controls.semEndFirstCtrl.value,
        sem_end_second: this.edu_form.controls.semEndSecondCtrl.value,
        sem_end_third: this.edu_form.controls.semEndThirdCtrl.value,
        sem_end_fourth: this.edu_form.controls.semEndFourthCtrl.value,
        sem_end_fifth: this.edu_form.controls.semEndFifthCtrl.value,
        sem_end_sixth: this.edu_form.controls.semEndSixthCtrl.value,
        sem_end_seventh: this.edu_form.controls.semEndSeventhCtrl.value,
        sem_end_eight: this.edu_form.controls.semEndEightCtrl.value,
        sem_end_ninth: this.edu_form.controls.semEndNinthCtrl.value,
        sem_end_tenth: this.edu_form.controls.semEndTenthCtrl.value,

        overall_marks_obt: this.edu_form.controls.totalMarksObtCtrl.value,
        overall_marks_out: this.edu_form.controls.overmarksoutCtrl.value,

        special_instruction1: this.special_instruction1,
        special_instruction2: this.special_instruction2,
        special_instruction3: this.special_instruction3,
        special_instruction4: this.special_instruction4,
        special_instruction5: this.special_instruction5,
        special_instruction6: this.special_instruction6,
        special_instruction7 : this.special_instruction7,

        OverAllpercentage: this.edu_form.controls.overAllpercentageCtrl.value,
        // practical_hour_First  : this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value ,
        // practical_hour_Second  : this.edu_form.controls.hoursMinutesPerWeek1Ctrl2.value,
        // practical_hour_Third  : this.edu_form.controls.hoursMinutesPerWeek1Ctrl3.value,
        // practical_hour_Fourth  : this.edu_form.controls.hoursMinutesPerWeek1Ctrl4.value,
        // practical_hour_Fifth  : this.edu_form.controls.hoursMinutesPerWeek1Ctrl5.value,
        // practical_hour_Six  : this.edu_form.controls.hoursMinutesPerWeek1Ctrl6.value,
        // practical_hour_Seventh  : this.edu_form.controls.hoursMinutesPerWeek1Ctrl7.value,
        // practical_hour_Eighth  : this.edu_form.controls.hoursMinutesPerWeek1Ctrl8.value,
        // lecture_hour_First  : this.edu_form.controls.lecturesPerWeekCtrl1.value ,
        // lecture_hour_Second  : this.edu_form.controls.lecturesPerWeekCtrl2.value,
        // lecture_hour_Third  : this.edu_form.controls.lecturesPerWeekCtrl3.value,
        // lecture_hour_Fourth  : this.edu_form.controls.lecturesPerWeekCtrl4.value,
        // lecture_hour_Fifth  : this.edu_form.controls.lecturesPerWeekCtrl5.value,
        // lecture_hour_Six  : this.edu_form.controls.lecturesPerWeekCtrl6.value,
        // lecture_hour_Seventh  : this.edu_form.controls.lecturesPerWeekCtrl7.value,
        // lecture_hour_Eighth  : this.edu_form.controls.lecturesPerWeekCtrl8.value,
        // monthstakenCtrl  : this.edu_form.controls.monthstakenCtrl.value ,
        // monthstakenCtrl2  : this.edu_form.controls.monthstakenCtrl2.value,
        // monthstakenCtrl3  : this.edu_form.controls.monthstakenCtrl3.value,
        // monthstakenCtrl4  : this.edu_form.controls.monthstakenCtrl4.value,
        // monthstakenCtrl5  : this.edu_form.controls.monthstakenCtrl5.value,
        // monthstakenCtrl6  : this.edu_form.controls.monthstakenCtrl6.value,
        // monthstakenCtrl7  : this.edu_form.controls.monthstakenCtrl7.value,
        // monthstakenCtrl8  : this.edu_form.controls.monthstakenCtrl8.value,
        // lecture_hour_Ninth  : this.edu_form.controls.lecturesPerWeekCtrl9.value,
        // practical_hour_Ninth  : this.edu_form.controls.hoursMinutesPerWeek1Ctrl9.value,
        // months_taken_ninth  : this.edu_form.controls.monthstakenCtrl9.value,
        // practical_hour_Tenth  : this.edu_form.controls.hoursMinutesPerWeek1Ctrl10.value,
        // lecture_hour_Tenth  : this.edu_form.controls.lecturesPerWeekCtrl10.value,
        // months_taken_tenth  : this.edu_form.controls.monthstakenCtrl10.value,

        // monthstakenCtrl  : this.subjectName ? (this.edu_form.controls.monthstakenCtrl.value ? this.edu_form.controls.monthstakenCtrl.value : '4' ) : '',
        // monthstakenCtrl2  : this.subjectName2 ? (this.edu_form.controls.monthstakenCtrl2.value ? this.edu_form.controls.monthstakenCtrl2.value : '4') : '',
        // monthstakenCtrl3  :this.subjectName3 ? (this.edu_form.controls.monthstakenCtrl3.value ?  this.edu_form.controls.monthstakenCtrl3.value: '4') : '',
        // monthstakenCtrl4  :this.subjectName4 ? (this.edu_form.controls.monthstakenCtrl4.value ? this.edu_form.controls.monthstakenCtrl4.value : '4') : '',
        // monthstakenCtrl5  :this.subjectName5 ? (this.edu_form.controls.monthstakenCtrl5.value ? this.edu_form.controls.monthstakenCtrl5.value : '4') : '',
        // monthstakenCtrl6  :this.subjectName6 ? (this.edu_form.controls.monthstakenCtrl6.value ? this.edu_form.controls.monthstakenCtrl6.value : '4') : '',
        // monthstakenCtrl7  :this.subjectName7 ? (this.edu_form.controls.monthstakenCtrl7.value ? this.edu_form.controls.monthstakenCtrl7.value : '4') : '',
        // monthstakenCtrl8  :this.subjectName8 ? (this.edu_form.controls.monthstakenCtrl8.value ? this.edu_form.controls.monthstakenCtrl8.value : '4') : '',

        //months_taken_tenth: this.subjectName10 ? (this.edu_form.controls.monthstakenCtrl10.value ? this.edu_form.controls.monthstakenCtrl10.value : '4') : '',
        total_credits_Earned_C: this.edu_form.controls.totalCCtrl.value,
        totalC: this.edu_form.controls.totalCCtrl.value,
        totalCnG: this.edu_form.controls.totalCnGCtrl.value,
        overall_CGPA: this.edu_form.controls.OverallCGPACtrl.value,
        specialisation: this.edu_form.controls.SpecialisationCtrl.value,
        // overAllYearlyGrade: this.edu_form.controls.finalGradeCtrl.value,
        seat_number: this.edu_form.controls.seatNumberCtrl.value,
        sgpi_gpa: 'sgpi',

        course_credits_First: this.edu_form.controls.courseCreditsFirstCtrl.value,
        course_credits_Second: this.edu_form.controls.courseCreditsSecondCtrl.value,
        course_credits_Third: this.edu_form.controls.courseCreditsThirdCtrl.value,
        course_credits_Fourth: this.edu_form.controls.courseCreditsFourthCtrl.value,
        course_credits_Fifth: this.edu_form.controls.courseCreditsFifthCtrl.value,
        course_credits_Sixth: this.edu_form.controls.courseCreditsSixthCtrl.value,
        course_credits_Seventh: this.edu_form.controls.courseCreditsSeventhCtrl.value,
        course_credits_Eight: this.edu_form.controls.courseCreditsEightCtrl.value,
        course_credits_Ninth: this.edu_form.controls.courseCreditsNinthCtrl.value,
        course_credits_Tenth: this.edu_form.controls.courseCreditsTenthCtrl.value,

        th_First: this.edu_form.controls.thFirstCtrl.value.toUpperCase(),
        th_Second: this.edu_form.controls.thSecondCtrl.value.toUpperCase(),
        th_Third: this.edu_form.controls.thThirdCtrl.value.toUpperCase(),
        th_Fourth: this.edu_form.controls.thFourthCtrl.value.toUpperCase(),
        th_Fifth: this.edu_form.controls.thFifthCtrl.value.toUpperCase(),
        th_Sixth: this.edu_form.controls.thSixthCtrl.value.toUpperCase(),
        th_Seventh: this.edu_form.controls.thSeventhCtrl.value.toUpperCase(),
        th_Eight: this.edu_form.controls.thEightCtrl.value.toUpperCase(),
        th_Ninth: this.edu_form.controls.thNinthCtrl.value.toUpperCase(),
        th_Tenth: this.edu_form.controls.thTenthCtrl.value.toUpperCase(),

        ia_First: this.edu_form.controls.iaFirstCtrl.value.toUpperCase(),
        ia_Second: this.edu_form.controls.iaSecondCtrl.value.toUpperCase(),
        ia_Third: this.edu_form.controls.iaThirdCtrl.value.toUpperCase(),
        ia_Fourth: this.edu_form.controls.iaFourthCtrl.value.toUpperCase(),
        ia_Fifth: this.edu_form.controls.iaFifthCtrl.value.toUpperCase(),
        ia_Sixth: this.edu_form.controls.iaSixthCtrl.value.toUpperCase(),
        ia_Seventh: this.edu_form.controls.iaSeventhCtrl.value.toUpperCase(),
        ia_Eight: this.edu_form.controls.iaEightCtrl.value.toUpperCase(),
        ia_Ninth: this.edu_form.controls.iaNinthCtrl.value.toUpperCase(),
        ia_Tenth: this.edu_form.controls.iaTenthCtrl.value.toUpperCase(),

        course_code_first: this.subjectName
          ? this.subjectName["Course_code"]
          : this.withoutCodeSub,
        course_code_second: this.subjectName2
          ? this.subjectName2["Course_code"]
          : this.withoutCodeSub2,
        course_code_third: this.subjectName3
          ? this.subjectName3["Course_code"]
          : this.withoutCodeSub3,
        course_code_fourth: this.subjectName4
          ? this.subjectName4["Course_code"]
          : this.withoutCodeSub4,
        course_code_fifth: this.subjectName5
          ? this.subjectName5["Course_code"]
          : this.withoutCodeSub5,
        course_code_sixth: this.subjectName6
          ? this.subjectName6["Course_code"]
          : this.withoutCodeSub6,
        course_code_seventh: this.subjectName7
          ? this.subjectName7["Course_code"]
          : this.withoutCodeSub7,
        course_code_eight: this.subjectName8
          ? this.subjectName8["Course_code"]
          : this.withoutCodeSub8,
        course_code_ninth: this.subjectName9
          ? this.subjectName9["Course_code"]
          : this.withoutCodeSub9,
        course_code_tenth: this.subjectName10
          ? this.subjectName10["Course_code"]
          : this.withoutCodeSub10,

        course_code_edit_first: this.edu_form.controls.courseEdit1Ctrl.value.toUpperCase(),
        course_code_edit_second: this.edu_form.controls.courseEdit2Ctrl.value.toUpperCase(),
        course_code_edit_third: this.edu_form.controls.courseEdit3Ctrl.value.toUpperCase(),
        course_code_edit_fourth: this.edu_form.controls.courseEdit4Ctrl.value.toUpperCase(),
        course_code_edit_fifth: this.edu_form.controls.courseEdit5Ctrl.value.toUpperCase(),
        course_code_edit_sixth: this.edu_form.controls.courseEdit6Ctrl.value.toUpperCase(),
        course_code_edit_seventh: this.edu_form.controls.courseEdit7Ctrl.value.toUpperCase(),
        course_code_edit_eight: this.edu_form.controls.courseEdit8Ctrl.value.toUpperCase(),
        course_code_edit_ninth: this.edu_form.controls.courseEdit9Ctrl.value.toUpperCase(),
        course_code_edit_tenth: this.edu_form.controls.courseEdit10Ctrl.value.toUpperCase(),


        subject_edit_First: this.edu_form.controls.subjectEditFirstCtrl.value.toUpperCase(),
        subject_edit_Second: this.edu_form.controls.subjectEditSecondCtrl.value.toUpperCase(),
        subject_edit_Third: this.edu_form.controls.subjectEditThirdCtrl.value.toUpperCase(),
        subject_edit_Fourth: this.edu_form.controls.subjectEditFourthCtrl.value.toUpperCase(),
        subject_edit_Fifth: this.edu_form.controls.subjectEditFifthCtrl.value.toUpperCase(),
        subject_edit_Sixth: this.edu_form.controls.subjectEditSixthCtrl.value.toUpperCase(),
        subject_edit_Seventh: this.edu_form.controls.subjectEditSeventhCtrl.value.toUpperCase(),
        subject_edit_Eight: this.edu_form.controls.subjectEditEightCtrl.value.toUpperCase(),
        subject_edit_Ninth: this.edu_form.controls.subjectEditNinthCtrl.value.toUpperCase(),
        subject_edit_Tenth: this.edu_form.controls.subjectEditTenthCtrl.value.toUpperCase(),

        remarks: this.edu_form.controls.remarksCtrl.value,
        result: this.edu_form.controls.resultCtrl.value,
        footnotes : this.edu_form.controls.footnotesCtrl.value,
        sgpiInstruction : this.edu_form.controls.sgpiInstCtrl.value,
        mcom_sem_I_Details : this.edu_form.controls.sem1detailsctrl.value,
        mcom_sem_II_Details : this.edu_form.controls.sem2detailsctrl.value,
        mcom_sem_III_Details : this.edu_form.controls.sem3detailsctrl.value,
        stillStdMonth : this.edu_form.controls.stlStdmonthCtrl.value,

      }

      this.api.setEducationalValues(edu_data)
        .subscribe(
          (data: any) => {
            this.ref.close(data);
            err => console.error(err)
          });
    }
  }

  dismiss() {
    this.ref.close();
  }

  getTotalCredits() {
    this.totalMarks = 0
    
    if (this.edu_form.controls.markSecondCtrl.value != '' && this.edu_form.controls.markThirdCtrl.value != '' && this.edu_form.controls.markFourthCtrl.value != '' && this.edu_form.controls.markFifthCtrl.value != '' && this.edu_form.controls.markSixthCtrl.value != '' && this.edu_form.controls.markSeventhCtrl.value != '' && this.edu_form.controls.markEighthCtrl.value != '') {
      this.totalMarks = (Number(this.edu_form.controls.markFirstCtrl.value) + Number(this.edu_form.controls.markSecondCtrl.value) + Number(this.edu_form.controls.markThirdCtrl.value) + Number(this.edu_form.controls.markFourthCtrl.value) + Number(this.edu_form.controls.markFifthCtrl.value) + Number(this.edu_form.controls.markSixthCtrl.value) + Number(this.edu_form.controls.markSeventhCtrl.value) + Number(this.edu_form.controls.markEighthCtrl.value))
      
    } else if (this.edu_form.controls.markSecondCtrl.value != '' && this.edu_form.controls.markThirdCtrl.value != '' && this.edu_form.controls.markFourthCtrl.value != '' && this.edu_form.controls.markFifthCtrl.value != '' && this.edu_form.controls.markSixthCtrl.value != '' && this.edu_form.controls.markSeventhCtrl.value != '') {
      this.totalMarks = (Number(this.edu_form.controls.markFirstCtrl.value) + Number(this.edu_form.controls.markSecondCtrl.value) + Number(this.edu_form.controls.markThirdCtrl.value) + Number(this.edu_form.controls.markFourthCtrl.value) + Number(this.edu_form.controls.markFifthCtrl.value) + Number(this.edu_form.controls.markSixthCtrl.value) + Number(this.edu_form.controls.markSeventhCtrl.value))
      
    } else if (this.edu_form.controls.markSecondCtrl.value != '' && this.edu_form.controls.markThirdCtrl.value != '' && this.edu_form.controls.markFourthCtrl.value != '' && this.edu_form.controls.markFifthCtrl.value != '' && this.edu_form.controls.markSixthCtrl.value != '') {
      this.totalMarks = (Number(this.edu_form.controls.markFirstCtrl.value) + Number(this.edu_form.controls.markSecondCtrl.value) + Number(this.edu_form.controls.markThirdCtrl.value) + Number(this.edu_form.controls.markFourthCtrl.value) + Number(this.edu_form.controls.markFifthCtrl.value) + Number(this.edu_form.controls.markSixthCtrl.value))
      
    } else if (this.edu_form.controls.markSecondCtrl.value != '' && this.edu_form.controls.markThirdCtrl.value != '' && this.edu_form.controls.markFourthCtrl.value != '' && this.edu_form.controls.markFifthCtrl.value != '') {
      this.totalMarks = (Number(this.edu_form.controls.markFirstCtrl.value) + Number(this.edu_form.controls.markSecondCtrl.value) + Number(this.edu_form.controls.markThirdCtrl.value) + Number(this.edu_form.controls.markFourthCtrl.value) + Number(this.edu_form.controls.markFifthCtrl.value))
      
    } else if (this.edu_form.controls.markSecondCtrl.value != '' && this.edu_form.controls.markThirdCtrl.value != '' && this.edu_form.controls.markFourthCtrl.value != '') {
      this.totalMarks = (Number(this.edu_form.controls.markFirstCtrl.value) + Number(this.edu_form.controls.markSecondCtrl.value) + Number(this.edu_form.controls.markThirdCtrl.value) + Number(this.edu_form.controls.markFourthCtrl.value))
      
    } else if (this.edu_form.controls.markSecondCtrl.value != '' && this.edu_form.controls.markThirdCtrl.value != '') {
      this.totalMarks = (Number(this.edu_form.controls.markFirstCtrl.value) + Number(this.edu_form.controls.markSecondCtrl.value) + Number(this.edu_form.controls.markThirdCtrl.value))
      
    } else if (this.edu_form.controls.markSecondCtrl.value != '') {
      this.totalMarks = (Number(this.edu_form.controls.markSecondCtrl.value) + Number(this.edu_form.controls.markFirstCtrl.value))
      
    }

    if (this.totalCnG && this.totalMarks) {
      this.totalcgpa = Number(this.totalCnG) / Number(this.creditTotal)
      this.totalcgpa = Number(this.totalcgpa.toFixed(2))
    }
  }

  totalsMarksObtainedMyFunc() {
    this.totalMarksObtainedmyFunc = 0
    if (this.edu_form.controls.markObtSecondCtrl.value != '' && this.edu_form.controls.markObtThirdCtrl.value != '' && this.edu_form.controls.markObtFourthCtrl.value != '' && this.edu_form.controls.markObtFifthCtrl.value != '' && this.edu_form.controls.markObtSixthCtrl.value != '' && this.edu_form.controls.markObtSeventhCtrl.value != '' && this.edu_form.controls.markObtEightCtrl.value != '' && this.edu_form.controls.markObtNinthCtrl.value != '' && this.edu_form.controls.markObtTenthCtrl.value != '') {
      this.totalMarksObtainedmyFunc = (Number(this.edu_form.controls.markObtFirstCtrl.value) + Number(this.edu_form.controls.markObtSecondCtrl.value) + Number(this.edu_form.controls.markObtThirdCtrl.value) + Number(this.edu_form.controls.markObtFourthCtrl.value) + Number(this.edu_form.controls.markObtFifthCtrl.value) + Number(this.edu_form.controls.markObtSixthCtrl.value) + Number(this.edu_form.controls.markObtSeventhCtrl.value) + Number(this.edu_form.controls.markObtEightCtrl.value) + Number(this.edu_form.controls.markObtNinthCtrl.value) + Number(this.edu_form.controls.markObtTenthCtrl.value))
    } else if (this.edu_form.controls.markObtSecondCtrl.value != '' && this.edu_form.controls.markObtThirdCtrl.value != '' && this.edu_form.controls.markObtFourthCtrl.value != '' && this.edu_form.controls.markObtFifthCtrl.value != '' && this.edu_form.controls.markObtSixthCtrl.value != '' && this.edu_form.controls.markObtSeventhCtrl.value != '' && this.edu_form.controls.markObtEightCtrl.value != '' && this.edu_form.controls.markObtNinthCtrl.value != '') {
      this.totalMarksObtainedmyFunc = (Number(this.edu_form.controls.markObtFirstCtrl.value) + Number(this.edu_form.controls.markObtSecondCtrl.value) + Number(this.edu_form.controls.markObtThirdCtrl.value) + Number(this.edu_form.controls.markObtFourthCtrl.value) + Number(this.edu_form.controls.markObtFifthCtrl.value) + Number(this.edu_form.controls.markObtSixthCtrl.value) + Number(this.edu_form.controls.markObtSeventhCtrl.value) + Number(this.edu_form.controls.markObtEightCtrl.value) + Number(this.edu_form.controls.markObtNinthCtrl.value))
    } else if (this.edu_form.controls.markObtSecondCtrl.value != '' && this.edu_form.controls.markObtThirdCtrl.value != '' && this.edu_form.controls.markObtFourthCtrl.value != '' && this.edu_form.controls.markObtFifthCtrl.value != '' && this.edu_form.controls.markObtSixthCtrl.value != '' && this.edu_form.controls.markObtSeventhCtrl.value != '' && this.edu_form.controls.markObtEightCtrl.value) {
      this.totalMarksObtainedmyFunc = (Number(this.edu_form.controls.markObtFirstCtrl.value) + Number(this.edu_form.controls.markObtSecondCtrl.value) + Number(this.edu_form.controls.markObtThirdCtrl.value) + Number(this.edu_form.controls.markObtFourthCtrl.value) + Number(this.edu_form.controls.markObtFifthCtrl.value) + Number(this.edu_form.controls.markObtSixthCtrl.value) + Number(this.edu_form.controls.markObtSeventhCtrl.value) + Number(this.edu_form.controls.markObtEightCtrl.value))
    } else if (this.edu_form.controls.markObtSecondCtrl.value != '' && this.edu_form.controls.markObtThirdCtrl.value != '' && this.edu_form.controls.markObtFourthCtrl.value != '' && this.edu_form.controls.markObtFifthCtrl.value != '' && this.edu_form.controls.markObtSixthCtrl.value != '' && this.edu_form.controls.markObtSeventhCtrl.value != '') {
      this.totalMarksObtainedmyFunc = (Number(this.edu_form.controls.markObtFirstCtrl.value) + Number(this.edu_form.controls.markObtSecondCtrl.value) + Number(this.edu_form.controls.markObtThirdCtrl.value) + Number(this.edu_form.controls.markObtFourthCtrl.value) + Number(this.edu_form.controls.markObtFifthCtrl.value) + Number(this.edu_form.controls.markObtSixthCtrl.value) + Number(this.edu_form.controls.markObtSeventhCtrl.value))
    } else if (this.edu_form.controls.markObtSecondCtrl.value != '' && this.edu_form.controls.markObtThirdCtrl.value != '' && this.edu_form.controls.markObtFourthCtrl.value != '' && this.edu_form.controls.markObtFifthCtrl.value != '' && this.edu_form.controls.markObtSixthCtrl.value != '') {
      this.totalMarksObtainedmyFunc = (Number(this.edu_form.controls.markObtFirstCtrl.value) + Number(this.edu_form.controls.markObtSecondCtrl.value) + Number(this.edu_form.controls.markObtThirdCtrl.value) + Number(this.edu_form.controls.markObtFourthCtrl.value) + Number(this.edu_form.controls.markObtFifthCtrl.value) + Number(this.edu_form.controls.markObtSixthCtrl.value))
    } else if (this.edu_form.controls.markObtSecondCtrl.value != '' && this.edu_form.controls.markObtThirdCtrl.value != '' && this.edu_form.controls.markObtFourthCtrl.value != '' && this.edu_form.controls.markObtFifthCtrl.value != '') {
      this.totalMarksObtainedmyFunc = (Number(this.edu_form.controls.markObtFirstCtrl.value) + Number(this.edu_form.controls.markObtSecondCtrl.value) + Number(this.edu_form.controls.markObtThirdCtrl.value) + Number(this.edu_form.controls.markObtFourthCtrl.value) + Number(this.edu_form.controls.markObtFifthCtrl.value))
    } else if (this.edu_form.controls.markObtSecondCtrl.value != '' && this.edu_form.controls.markObtThirdCtrl.value != '' && this.edu_form.controls.markObtFourthCtrl.value != '') {
      this.totalMarksObtainedmyFunc = (Number(this.edu_form.controls.markObtFirstCtrl.value) + Number(this.edu_form.controls.markObtSecondCtrl.value) + Number(this.edu_form.controls.markObtThirdCtrl.value) + Number(this.edu_form.controls.markObtFourthCtrl.value))
    } else if (this.edu_form.controls.markObtSecondCtrl.value != '' && this.edu_form.controls.markObtThirdCtrl.value != '') {
      this.totalMarksObtainedmyFunc = (Number(this.edu_form.controls.markObtFirstCtrl.value) + Number(this.edu_form.controls.markObtSecondCtrl.value) + Number(this.edu_form.controls.markObtThirdCtrl.value))
    } else if (this.edu_form.controls.markObtSecondCtrl.value != '') {
      this.totalMarksObtainedmyFunc = (Number(this.edu_form.controls.markObtFirstCtrl.value) + Number(this.edu_form.controls.markObtSecondCtrl.value))
    }
  }

  totalsMarksOut() {
    this.totalMarksOut = 0
    if (this.edu_form.controls.markSecondOutCtrl.value != '' && this.edu_form.controls.markThirdOutCtrl.value != '' && this.edu_form.controls.markFourthOutCtrl.value != '' && this.edu_form.controls.markFifthOutCtrl.value != '' && this.edu_form.controls.markSixthOutCtrl.value != '' && this.edu_form.controls.markSeventhOutCtrl.value != '' && this.edu_form.controls.markEighthOutCtrl.value) {
      this.totalMarksOut = (Number(this.edu_form.controls.markFirstOutCtrl.value) + Number(this.edu_form.controls.markSecondOutCtrl.value) + Number(this.edu_form.controls.markThirdOutCtrl.value) + Number(this.edu_form.controls.markFourthOutCtrl.value) + Number(this.edu_form.controls.markFifthOutCtrl.value) + Number(this.edu_form.controls.markSixthOutCtrl.value) + Number(this.edu_form.controls.markSeventhOutCtrl.value) + Number(this.edu_form.controls.markEighthOutCtrl.value))
    } else if (this.edu_form.controls.markSecondOutCtrl.value != '' && this.edu_form.controls.markThirdOutCtrl.value != '' && this.edu_form.controls.markFourthOutCtrl.value != '' && this.edu_form.controls.markFifthOutCtrl.value != '' && this.edu_form.controls.markSixthOutCtrl.value != '' && this.edu_form.controls.markSeventhOutCtrl.value != '') {
      this.totalMarksOut = (Number(this.edu_form.controls.markFirstOutCtrl.value) + Number(this.edu_form.controls.markSecondOutCtrl.value) + Number(this.edu_form.controls.markThirdOutCtrl.value) + Number(this.edu_form.controls.markFourthOutCtrl.value) + Number(this.edu_form.controls.markFifthOutCtrl.value) + Number(this.edu_form.controls.markSixthOutCtrl.value) + Number(this.edu_form.controls.markSeventhOutCtrl.value))
    } else if (this.edu_form.controls.markSecondOutCtrl.value != '' && this.edu_form.controls.markThirdOutCtrl.value != '' && this.edu_form.controls.markFourthOutCtrl.value != '' && this.edu_form.controls.markFifthOutCtrl.value != '' && this.edu_form.controls.markSixthOutCtrl.value != '') {
      this.totalMarksOut = (Number(this.edu_form.controls.markFirstOutCtrl.value) + Number(this.edu_form.controls.markSecondOutCtrl.value) + Number(this.edu_form.controls.markThirdOutCtrl.value) + Number(this.edu_form.controls.markFourthOutCtrl.value) + Number(this.edu_form.controls.markFifthOutCtrl.value) + Number(this.edu_form.controls.markSixthOutCtrl.value))
    } else if (this.edu_form.controls.markSecondOutCtrl.value != '' && this.edu_form.controls.markThirdOutCtrl.value != '' && this.edu_form.controls.markFourthOutCtrl.value != '' && this.edu_form.controls.markFifthOutCtrl.value != '') {
      this.totalMarksOut = (Number(this.edu_form.controls.markFirstOutCtrl.value) + Number(this.edu_form.controls.markSecondOutCtrl.value) + Number(this.edu_form.controls.markThirdOutCtrl.value) + Number(this.edu_form.controls.markFourthOutCtrl.value) + Number(this.edu_form.controls.markFifthOutCtrl.value))
    } else if (this.edu_form.controls.markSecondOutCtrl.value != '' && this.edu_form.controls.markThirdOutCtrl.value != '' && this.edu_form.controls.markFourthOutCtrl.value != '') {
      this.totalMarksOut = (Number(this.edu_form.controls.markFirstOutCtrl.value) + Number(this.edu_form.controls.markSecondOutCtrl.value) + Number(this.edu_form.controls.markThirdOutCtrl.value) + Number(this.edu_form.controls.markFourthOutCtrl.value))
    } else if (this.edu_form.controls.markSecondOutCtrl.value != '' && this.edu_form.controls.markThirdOutCtrl.value != '') {
      this.totalMarksOut = (Number(this.edu_form.controls.markFirstOutCtrl.value) + Number(this.edu_form.controls.markSecondOutCtrl.value) + Number(this.edu_form.controls.markThirdOutCtrl.value))
    } else if (this.edu_form.controls.markSecondOutCtrl.value != '') {
      this.totalMarksOut = (Number(this.edu_form.controls.markFirstOutCtrl.value) + Number(this.edu_form.controls.markSecondOutCtrl.value))
    }
  }

  hetmarksObt() {
    // hetmarksObt
    this.creditTotal = 0
    if (this.edu_form.controls.creditsEarnedCFirstCtrl.value && this.edu_form.controls.creditsEarnedCSecondCtrl.value && this.edu_form.controls.creditsEarnedCThirdCtrl.value && this.edu_form.controls.creditsEarnedCFourthCtrl.value && this.edu_form.controls.creditsEarnedCSixthCtrl.value && this.edu_form.controls.creditsEarnedCFifthCtrl.value && this.edu_form.controls.creditsEarnedCSevenCtrl.value && this.edu_form.controls.creditsEarnedCEightCtrl.value && this.edu_form.controls.creditsEarnedCNinthCtrl.value && this.edu_form.controls.creditsEarnedCtehthCtrl.value) {
      this.creditTotal = (Number(this.edu_form.controls.creditsEarnedCFirstCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSecondCtrl.value) + Number(this.edu_form.controls.creditsEarnedCThirdCtrl.value) + Number(this.edu_form.controls.creditsEarnedCFourthCtrl.value) + Number(this.edu_form.controls.creditsEarnedCFifthCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSixthCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSevenCtrl.value) + Number(this.edu_form.controls.creditsEarnedCEightCtrl.value) + Number(this.edu_form.controls.creditsEarnedCNinthCtrl.value) + Number(this.edu_form.controls.creditsEarnedCtehthCtrl.value))
    } else if (this.edu_form.controls.creditsEarnedCFirstCtrl.value && this.edu_form.controls.creditsEarnedCSecondCtrl.value && this.edu_form.controls.creditsEarnedCThirdCtrl.value && this.edu_form.controls.creditsEarnedCFourthCtrl.value && this.edu_form.controls.creditsEarnedCSixthCtrl.value && this.edu_form.controls.creditsEarnedCFifthCtrl.value && this.edu_form.controls.creditsEarnedCSevenCtrl.value && this.edu_form.controls.creditsEarnedCEightCtrl.value && this.edu_form.controls.creditsEarnedCNinthCtrl.value) {
      this.creditTotal = (Number(this.edu_form.controls.creditsEarnedCFirstCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSecondCtrl.value) + Number(this.edu_form.controls.creditsEarnedCThirdCtrl.value) + Number(this.edu_form.controls.creditsEarnedCFourthCtrl.value) + Number(this.edu_form.controls.creditsEarnedCFifthCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSixthCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSevenCtrl.value) + Number(this.edu_form.controls.creditsEarnedCEightCtrl.value) + Number(this.edu_form.controls.creditsEarnedCNinthCtrl.value))
    } else if (this.edu_form.controls.creditsEarnedCFirstCtrl.value && this.edu_form.controls.creditsEarnedCSecondCtrl.value && this.edu_form.controls.creditsEarnedCThirdCtrl.value && this.edu_form.controls.creditsEarnedCFourthCtrl.value && this.edu_form.controls.creditsEarnedCSixthCtrl.value && this.edu_form.controls.creditsEarnedCFifthCtrl.value && this.edu_form.controls.creditsEarnedCSevenCtrl.value && this.edu_form.controls.creditsEarnedCEightCtrl.value) {
      this.creditTotal = (Number(this.edu_form.controls.creditsEarnedCFirstCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSecondCtrl.value) + Number(this.edu_form.controls.creditsEarnedCThirdCtrl.value) + Number(this.edu_form.controls.creditsEarnedCFourthCtrl.value) + Number(this.edu_form.controls.creditsEarnedCFifthCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSixthCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSevenCtrl.value) + Number(this.edu_form.controls.creditsEarnedCEightCtrl.value))
    } else if (this.edu_form.controls.creditsEarnedCFirstCtrl.value && this.edu_form.controls.creditsEarnedCSecondCtrl.value && this.edu_form.controls.creditsEarnedCThirdCtrl.value && this.edu_form.controls.creditsEarnedCFourthCtrl.value && this.edu_form.controls.creditsEarnedCSixthCtrl.value && this.edu_form.controls.creditsEarnedCFifthCtrl.value && this.edu_form.controls.creditsEarnedCSevenCtrl.value) {
      this.creditTotal = (Number(this.edu_form.controls.creditsEarnedCFirstCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSecondCtrl.value) + Number(this.edu_form.controls.creditsEarnedCThirdCtrl.value) + Number(this.edu_form.controls.creditsEarnedCFourthCtrl.value) + Number(this.edu_form.controls.creditsEarnedCFifthCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSixthCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSevenCtrl.value))
    } else if (this.edu_form.controls.creditsEarnedCFirstCtrl.value && this.edu_form.controls.creditsEarnedCSecondCtrl.value && this.edu_form.controls.creditsEarnedCThirdCtrl.value && this.edu_form.controls.creditsEarnedCFourthCtrl.value && this.edu_form.controls.creditsEarnedCSixthCtrl.value && this.edu_form.controls.creditsEarnedCFifthCtrl.value) {
      this.creditTotal = (Number(this.edu_form.controls.creditsEarnedCFirstCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSecondCtrl.value) + Number(this.edu_form.controls.creditsEarnedCThirdCtrl.value) + Number(this.edu_form.controls.creditsEarnedCFourthCtrl.value) + Number(this.edu_form.controls.creditsEarnedCFifthCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSixthCtrl.value))
    } else if (this.edu_form.controls.creditsEarnedCFirstCtrl.value && this.edu_form.controls.creditsEarnedCSecondCtrl.value && this.edu_form.controls.creditsEarnedCThirdCtrl.value && this.edu_form.controls.creditsEarnedCFourthCtrl.value && this.edu_form.controls.creditsEarnedCFifthCtrl.value) {
      this.creditTotal = (Number(this.edu_form.controls.creditsEarnedCFirstCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSecondCtrl.value) + Number(this.edu_form.controls.creditsEarnedCThirdCtrl.value) + Number(this.edu_form.controls.creditsEarnedCFourthCtrl.value) + Number(this.edu_form.controls.creditsEarnedCFifthCtrl.value))
    } else if (this.edu_form.controls.creditsEarnedCFirstCtrl.value && this.edu_form.controls.creditsEarnedCSecondCtrl.value && this.edu_form.controls.creditsEarnedCThirdCtrl.value && this.edu_form.controls.creditsEarnedCFourthCtrl.value) {
      this.creditTotal = (Number(this.edu_form.controls.creditsEarnedCFirstCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSecondCtrl.value) + Number(this.edu_form.controls.creditsEarnedCThirdCtrl.value) + Number(this.edu_form.controls.creditsEarnedCFourthCtrl.value))
    } else if (this.edu_form.controls.creditsEarnedCFirstCtrl.value && this.edu_form.controls.creditsEarnedCSecondCtrl.value && this.edu_form.controls.creditsEarnedCThirdCtrl.value) {
      this.creditTotal = (Number(this.edu_form.controls.creditsEarnedCFirstCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSecondCtrl.value) + Number(this.edu_form.controls.creditsEarnedCThirdCtrl.value))
    } else if (this.edu_form.controls.creditsEarnedCFirstCtrl.value && this.edu_form.controls.creditsEarnedCSecondCtrl.value) {
      this.creditTotal = (Number(this.edu_form.controls.creditsEarnedCFirstCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSecondCtrl.value))
    }

  }
  myFunc() {
    this.totalMarksmyFunc = 0
    this.totalMarksOutmyFunc = 0
    if (this.edu_form.controls.internalMarksCtrl.value && this.edu_form.controls.semEndFirstCtrl.value) {
      this.totalValue = parseInt(this.edu_form.controls.semEndFirstCtrl.value) + parseInt(this.edu_form.controls.internalMarksCtrl.value)
      if (this.totalValue > 0) {
        this.totalMarksmyFunc = this.totalMarksmyFunc + this.totalValue;
        this.totalMarksOutmyFunc = this.totalMarksOutmyFunc + 100
      }
    }
    if (this.edu_form.controls.internalMarksSecondCtrl.value && this.edu_form.controls.semEndSecondCtrl.value) {

      this.totalValue2 = parseInt(this.edu_form.controls.internalMarksSecondCtrl.value) + parseInt(this.edu_form.controls.semEndSecondCtrl.value)
      if (this.totalValue2 > 0) {
        this.totalMarksmyFunc = this.totalMarksmyFunc + this.totalValue2;
        this.totalMarksOutmyFunc = this.totalMarksOutmyFunc + 100
      }
    }

    if (this.edu_form.controls.internalMarksThirdCtrl.value && this.edu_form.controls.semEndThirdCtrl.value) {

      this.totalValue3 = parseInt(this.edu_form.controls.internalMarksThirdCtrl.value) + parseInt(this.edu_form.controls.semEndThirdCtrl.value)
      if (this.totalValue3 > 0) {
        this.totalMarksmyFunc = this.totalMarksmyFunc + this.totalValue3;
        this.totalMarksOutmyFunc = this.totalMarksOutmyFunc + 100
      }
    }
    if (this.edu_form.controls.internalMarksFourthCtrl.value && this.edu_form.controls.semEndFourthCtrl.value) {

      this.totalValue4 = parseInt(this.edu_form.controls.internalMarksFourthCtrl.value) + parseInt(this.edu_form.controls.semEndFourthCtrl.value)
      if (this.totalValue4 > 0) {
        this.totalMarksmyFunc = this.totalMarksmyFunc + this.totalValue4;
        this.totalMarksOutmyFunc = this.totalMarksOutmyFunc + 100
      }

    }
    if (this.edu_form.controls.internalMarksFifthCtrl.value && this.edu_form.controls.semEndFifthCtrl.value) {

      this.totalValue5 = parseInt(this.edu_form.controls.internalMarksFifthCtrl.value) + parseInt(this.edu_form.controls.semEndFifthCtrl.value)
      if (this.totalValue5 > 0) {
        this.totalMarksmyFunc = this.totalMarksmyFunc + this.totalValue5;
        this.totalMarksOutmyFunc = this.totalMarksOutmyFunc + 100
      }
    }
    if (this.edu_form.controls.internalMarksSixthCtrl.value && this.edu_form.controls.semEndSixthCtrl.value) {

      this.totalValue6 = parseInt(this.edu_form.controls.internalMarksSixthCtrl.value) + parseInt(this.edu_form.controls.semEndSixthCtrl.value)
      if (this.totalValue6 > 0) {
        this.totalMarksmyFunc = this.totalMarksmyFunc + this.totalValue6;
        this.totalMarksOutmyFunc = this.totalMarksOutmyFunc + 100
      }
    }
    if (this.edu_form.controls.internalMarksSeventhCtrl.value && this.edu_form.controls.semEndSeventhCtrl.value) {

      this.totalValue7 = parseInt(this.edu_form.controls.internalMarksSeventhCtrl.value) + parseInt(this.edu_form.controls.semEndSeventhCtrl.value)
      if (this.totalValue7 > 0) {
        this.totalMarksmyFunc = this.totalMarksmyFunc + this.totalValue7;
        this.totalMarksOutmyFunc = this.totalMarksOutmyFunc + 100
      }
    }
    if (this.edu_form.controls.internalMarksEightCtrl.value && this.edu_form.controls.semEndEightCtrl.value) {

      this.totalValue8 = parseInt(this.edu_form.controls.internalMarksEightCtrl.value) + parseInt(this.edu_form.controls.semEndEightCtrl.value)
      if (this.totalValue8 > 0) {
        this.totalMarksmyFunc = this.totalMarksmyFunc + this.totalValue8;
        this.totalMarksOutmyFunc = this.totalMarksOutmyFunc + 100
      }

    }
    if (this.edu_form.controls.internalMarksNineCtrl.value && this.edu_form.controls.semEndNinthCtrl.value) {

      this.totalValue9 = parseInt(this.edu_form.controls.internalMarksNineCtrl.value) + parseInt(this.edu_form.controls.semEndNinthCtrl.value)
      if (this.totalValue9 > 0) {
        this.totalMarksmyFunc = this.totalMarksmyFunc + this.totalValue9;
        this.totalMarksOutmyFunc = this.totalMarksOutmyFunc + 100
      }

    }
    if (this.edu_form.controls.internalMarksTenCtrl.value && this.edu_form.controls.semEndTenthCtrl.value) {

      this.totalValue10 = parseInt(this.edu_form.controls.internalMarksTenCtrl.value) + parseInt(this.edu_form.controls.semEndTenthCtrl.value)
      if (this.totalValue10 > 0) {
        this.totalMarksmyFunc = this.totalMarksmyFunc + this.totalValue10;
        this.totalMarksOutmyFunc = this.totalMarksOutmyFunc + 100
      }
    }


  }

  getTotalCnG() {
    this.totalCnG = 0;
    if (this.edu_form.controls.gradecreditsFirstCtrl.value && this.edu_form.controls.gradecreditsSecondCtrl.value && this.edu_form.controls.gradecreditsThirdCtrl.value && this.edu_form.controls.gradecreditsFourthCtrl.value && this.edu_form.controls.gradecreditsFifthCtrl.value && this.edu_form.controls.gradecreditsSixthCtrl.value && this.edu_form.controls.gradecreditsSeventhCtrl.value && this.edu_form.controls.gradecreditsEighthCtrl.value && this.edu_form.controls.gradecreditsNinthCtrl.value && this.edu_form.controls.gradecreditsTenthCtrl.value) {
      this.totalCnG = (Number(this.edu_form.controls.gradecreditsFirstCtrl.value) + Number(this.edu_form.controls.gradecreditsSecondCtrl.value) + Number(this.edu_form.controls.gradecreditsThirdCtrl.value) + Number(this.edu_form.controls.gradecreditsFourthCtrl.value) + Number(this.edu_form.controls.gradecreditsFifthCtrl.value) + Number(this.edu_form.controls.gradecreditsSixthCtrl.value) + Number(this.edu_form.controls.gradecreditsSeventhCtrl.value) + Number(this.edu_form.controls.gradecreditsEighthCtrl.value) + Number(this.edu_form.controls.gradecreditsNinthCtrl.value) + Number(this.edu_form.controls.gradecreditsTenthCtrl.value))
    } else if (this.edu_form.controls.gradecreditsFirstCtrl.value && this.edu_form.controls.gradecreditsSecondCtrl.value && this.edu_form.controls.gradecreditsThirdCtrl.value && this.edu_form.controls.gradecreditsFourthCtrl.value && this.edu_form.controls.gradecreditsFifthCtrl.value && this.edu_form.controls.gradecreditsSixthCtrl.value && this.edu_form.controls.gradecreditsSeventhCtrl.value && this.edu_form.controls.gradecreditsEighthCtrl.value && this.edu_form.controls.gradecreditsNinthCtrl.value) {
      this.totalCnG = (Number(this.edu_form.controls.gradecreditsFirstCtrl.value) + Number(this.edu_form.controls.gradecreditsSecondCtrl.value) + Number(this.edu_form.controls.gradecreditsThirdCtrl.value) + Number(this.edu_form.controls.gradecreditsFourthCtrl.value) + Number(this.edu_form.controls.gradecreditsFifthCtrl.value) + Number(this.edu_form.controls.gradecreditsSixthCtrl.value) + Number(this.edu_form.controls.gradecreditsSeventhCtrl.value) + Number(this.edu_form.controls.gradecreditsEighthCtrl.value) + Number(this.edu_form.controls.gradecreditsNinthCtrl.value))
    } else if (this.edu_form.controls.gradecreditsFirstCtrl.value && this.edu_form.controls.gradecreditsSecondCtrl.value && this.edu_form.controls.gradecreditsThirdCtrl.value && this.edu_form.controls.gradecreditsFourthCtrl.value && this.edu_form.controls.gradecreditsFifthCtrl.value && this.edu_form.controls.gradecreditsSixthCtrl.value && this.edu_form.controls.gradecreditsSeventhCtrl.value && this.edu_form.controls.gradecreditsEighthCtrl.value) {
      this.totalCnG = (Number(this.edu_form.controls.gradecreditsFirstCtrl.value) + Number(this.edu_form.controls.gradecreditsSecondCtrl.value) + Number(this.edu_form.controls.gradecreditsThirdCtrl.value) + Number(this.edu_form.controls.gradecreditsFourthCtrl.value) + Number(this.edu_form.controls.gradecreditsFifthCtrl.value) + Number(this.edu_form.controls.gradecreditsSixthCtrl.value) + Number(this.edu_form.controls.gradecreditsSeventhCtrl.value) + Number(this.edu_form.controls.gradecreditsEighthCtrl.value))
    } else if (this.edu_form.controls.gradecreditsFirstCtrl.value && this.edu_form.controls.gradecreditsSecondCtrl.value && this.edu_form.controls.gradecreditsThirdCtrl.value && this.edu_form.controls.gradecreditsFourthCtrl.value && this.edu_form.controls.gradecreditsFifthCtrl.value && this.edu_form.controls.gradecreditsSixthCtrl.value && this.edu_form.controls.gradecreditsSeventhCtrl.value) {
      this.totalCnG = (Number(this.edu_form.controls.gradecreditsFirstCtrl.value) + Number(this.edu_form.controls.gradecreditsSecondCtrl.value) + Number(this.edu_form.controls.gradecreditsThirdCtrl.value) + Number(this.edu_form.controls.gradecreditsFourthCtrl.value) + Number(this.edu_form.controls.gradecreditsFifthCtrl.value) + Number(this.edu_form.controls.gradecreditsSixthCtrl.value) + Number(this.edu_form.controls.gradecreditsSeventhCtrl.value))
    } else if (this.edu_form.controls.gradecreditsFirstCtrl.value && this.edu_form.controls.gradecreditsSecondCtrl.value && this.edu_form.controls.gradecreditsThirdCtrl.value && this.edu_form.controls.gradecreditsFourthCtrl.value && this.edu_form.controls.gradecreditsFifthCtrl.value && this.edu_form.controls.gradecreditsSixthCtrl.value) {
      this.totalCnG = (Number(this.edu_form.controls.gradecreditsFirstCtrl.value) + Number(this.edu_form.controls.gradecreditsSecondCtrl.value) + Number(this.edu_form.controls.gradecreditsThirdCtrl.value) + Number(this.edu_form.controls.gradecreditsFourthCtrl.value) + Number(this.edu_form.controls.gradecreditsFifthCtrl.value) + Number(this.edu_form.controls.gradecreditsSixthCtrl.value))
    } else if (this.edu_form.controls.gradecreditsFirstCtrl.value && this.edu_form.controls.gradecreditsSecondCtrl.value && this.edu_form.controls.gradecreditsThirdCtrl.value && this.edu_form.controls.gradecreditsFourthCtrl.value && this.edu_form.controls.gradecreditsFifthCtrl.value) {
      this.totalCnG = (Number(this.edu_form.controls.gradecreditsFirstCtrl.value) + Number(this.edu_form.controls.gradecreditsSecondCtrl.value) + Number(this.edu_form.controls.gradecreditsThirdCtrl.value) + Number(this.edu_form.controls.gradecreditsFourthCtrl.value) + Number(this.edu_form.controls.gradecreditsFifthCtrl.value))
    } else if (this.edu_form.controls.gradecreditsFirstCtrl.value && this.edu_form.controls.gradecreditsSecondCtrl.value && this.edu_form.controls.gradecreditsThirdCtrl.value && this.edu_form.controls.gradecreditsFourthCtrl.value) {
      this.totalCnG = (Number(this.edu_form.controls.gradecreditsFirstCtrl.value) + Number(this.edu_form.controls.gradecreditsSecondCtrl.value) + Number(this.edu_form.controls.gradecreditsThirdCtrl.value) + Number(this.edu_form.controls.gradecreditsFourthCtrl.value))
    } else if (this.edu_form.controls.gradecreditsFirstCtrl.value && this.edu_form.controls.gradecreditsSecondCtrl.value && this.edu_form.controls.gradecreditsThirdCtrl.value) {
      this.totalCnG = (Number(this.edu_form.controls.gradecreditsFirstCtrl.value) + Number(this.edu_form.controls.gradecreditsSecondCtrl.value) + Number(this.edu_form.controls.gradecreditsThirdCtrl.value))
    } else if (this.edu_form.controls.gradecreditsFirstCtrl.value && this.edu_form.controls.gradecreditsSecondCtrl.value) {
      this.totalCnG = (Number(this.edu_form.controls.gradecreditsFirstCtrl.value) + Number(this.edu_form.controls.gradecreditsSecondCtrl.value))
    }

    if (this.totalCnG && this.totalMarks) {
      this.totalcgpa = Number(this.totalCnG) / Number(this.creditTotal)
      this.totalcgpa = Number(this.totalcgpa.toFixed(2))
    }
  }

  // getTotalCourseCredits() {
  //   this.totalCourseCredits = 0;
  //   if (this.edu_form.controls.markFirstOutCtrl.value && this.edu_form.controls.markSecondOutCtrl.value && this.edu_form.controls.markThirdOutCtrl.value && this.edu_form.controls.markFourthOutCtrl.value && this.edu_form.controls.markFifthOutCtrl.value && this.edu_form.controls.markSixthOutCtrl.value && this.edu_form.controls.markSeventhOutCtrl.value && this.edu_form.controls.markEighthOutCtrl.value && this.edu_form.controls.markNinthOutCtrl.value && this.edu_form.controls.markTenthOutCtrl.value) {
  //     this.totalCourseCredits = (Number(this.edu_form.controls.markFirstOutCtrl.value) + Number(this.edu_form.controls.markSecondOutCtrl.value) + Number(this.edu_form.controls.markThirdOutCtrl.value) + Number(this.edu_form.controls.markFourthOutCtrl.value) + Number(this.edu_form.controls.markFifthOutCtrl.value) + Number(this.edu_form.controls.markSixthOutCtrl.value) + Number(this.edu_form.controls.markSeventhOutCtrl.value) + Number(this.edu_form.controls.markEighthOutCtrl.value) + Number(this.edu_form.controls.markNinthOutCtrl.value) + Number(this.edu_form.controls.markTenthOutCtrl.value))
  //   } else if (this.edu_form.controls.markFirstOutCtrl.value && this.edu_form.controls.markSecondOutCtrl.value && this.edu_form.controls.markThirdOutCtrl.value && this.edu_form.controls.markFourthOutCtrl.value && this.edu_form.controls.markFifthOutCtrl.value && this.edu_form.controls.markSixthOutCtrl.value && this.edu_form.controls.markSeventhOutCtrl.value && this.edu_form.controls.markEighthOutCtrl.value && this.edu_form.controls.markNinthOutCtrl.value) {
  //     this.totalCourseCredits = (Number(this.edu_form.controls.markFirstOutCtrl.value) + Number(this.edu_form.controls.markSecondOutCtrl.value) + Number(this.edu_form.controls.markThirdOutCtrl.value) + Number(this.edu_form.controls.markFourthOutCtrl.value) + Number(this.edu_form.controls.markFifthOutCtrl.value) + Number(this.edu_form.controls.markSixthOutCtrl.value) + Number(this.edu_form.controls.markSeventhOutCtrl.value) + Number(this.edu_form.controls.markEighthOutCtrl.value) + Number(this.edu_form.controls.markNinthOutCtrl.value))
  //   } else if (this.edu_form.controls.markFirstOutCtrl.value && this.edu_form.controls.markSecondOutCtrl.value && this.edu_form.controls.markThirdOutCtrl.value && this.edu_form.controls.markFourthOutCtrl.value && this.edu_form.controls.markFifthOutCtrl.value && this.edu_form.controls.markSixthOutCtrl.value && this.edu_form.controls.markSeventhOutCtrl.value && this.edu_form.controls.markEighthOutCtrl.value) {
  //     this.totalCourseCredits = (Number(this.edu_form.controls.markFirstOutCtrl.value) + Number(this.edu_form.controls.markSecondOutCtrl.value) + Number(this.edu_form.controls.markThirdOutCtrl.value) + Number(this.edu_form.controls.markFourthOutCtrl.value) + Number(this.edu_form.controls.markFifthOutCtrl.value) + Number(this.edu_form.controls.markSixthOutCtrl.value) + Number(this.edu_form.controls.markSeventhOutCtrl.value) + Number(this.edu_form.controls.markEighthOutCtrl.value))
  //   } else if (this.edu_form.controls.markFirstOutCtrl.value && this.edu_form.controls.markSecondOutCtrl.value && this.edu_form.controls.markThirdOutCtrl.value && this.edu_form.controls.markFourthOutCtrl.value && this.edu_form.controls.markFifthOutCtrl.value && this.edu_form.controls.markSixthOutCtrl.value && this.edu_form.controls.markSeventhOutCtrl.value) {
  //     this.totalCourseCredits = (Number(this.edu_form.controls.markFirstOutCtrl.value) + Number(this.edu_form.controls.markSecondOutCtrl.value) + Number(this.edu_form.controls.markThirdOutCtrl.value) + Number(this.edu_form.controls.markFourthOutCtrl.value) + Number(this.edu_form.controls.markFifthOutCtrl.value) + Number(this.edu_form.controls.markSixthOutCtrl.value) + Number(this.edu_form.controls.markSeventhOutCtrl.value))
  //   } else if (this.edu_form.controls.markFirstOutCtrl.value && this.edu_form.controls.markSecondOutCtrl.value && this.edu_form.controls.markThirdOutCtrl.value && this.edu_form.controls.markFourthOutCtrl.value && this.edu_form.controls.markFifthOutCtrl.value && this.edu_form.controls.markSixthOutCtrl.value) {
  //     this.totalCourseCredits = (Number(this.edu_form.controls.markFirstOutCtrl.value) + Number(this.edu_form.controls.markSecondOutCtrl.value) + Number(this.edu_form.controls.markThirdOutCtrl.value) + Number(this.edu_form.controls.markFourthOutCtrl.value) + Number(this.edu_form.controls.markFifthOutCtrl.value) + Number(this.edu_form.controls.markSixthOutCtrl.value))
  //   } else if (this.edu_form.controls.markFirstOutCtrl.value && this.edu_form.controls.markSecondOutCtrl.value && this.edu_form.controls.markThirdOutCtrl.value && this.edu_form.controls.markFourthOutCtrl.value && this.edu_form.controls.markFifthOutCtrl.value) {
  //     this.totalCourseCredits = (Number(this.edu_form.controls.markFirstOutCtrl.value) + Number(this.edu_form.controls.markSecondOutCtrl.value) + Number(this.edu_form.controls.markThirdOutCtrl.value) + Number(this.edu_form.controls.markFourthOutCtrl.value) + Number(this.edu_form.controls.markFifthOutCtrl.value))
  //   } else if (this.edu_form.controls.markFirstOutCtrl.value && this.edu_form.controls.markSecondOutCtrl.value && this.edu_form.controls.markThirdOutCtrl.value && this.edu_form.controls.markFourthOutCtrl.value) {
  //     this.totalCourseCredits = (Number(this.edu_form.controls.markFirstOutCtrl.value) + Number(this.edu_form.controls.markSecondOutCtrl.value) + Number(this.edu_form.controls.markThirdOutCtrl.value) + Number(this.edu_form.controls.markFourthOutCtrl.value))
  //   } else if (this.edu_form.controls.markFirstOutCtrl.value && this.edu_form.controls.markSecondOutCtrl.value && this.edu_form.controls.markThirdOutCtrl.value) {
  //     this.totalCourseCredits = (Number(this.edu_form.controls.markFirstOutCtrl.value) + Number(this.edu_form.controls.markSecondOutCtrl.value) + Number(this.edu_form.controls.markThirdOutCtrl.value))
  //   } else if (this.edu_form.controls.markFirstOutCtrl.value && this.edu_form.controls.markSecondOutCtrl.value) {
  //     this.totalCourseCredits = (Number(this.edu_form.controls.markFirstOutCtrl.value) + Number(this.edu_form.controls.markSecondOutCtrl.value))
  //   }
  // }

  getTotalCourseCredits() {

    if (this.edu_form.controls.courseCreditsSecondCtrl.value != '' && this.edu_form.controls.courseCreditsThirdCtrl.value != '' && this.edu_form.controls.courseCreditsFourthCtrl.value != '' && this.edu_form.controls.courseCreditsFifthCtrl.value != '' && this.edu_form.controls.courseCreditsSixthCtrl.value != '' && this.edu_form.controls.courseCreditsSeventhCtrl.value != '' && this.edu_form.controls.courseCreditsEightCtrl.value != '' && this.edu_form.controls.courseCreditsNinthCtrl.value != '' && this.edu_form.controls.courseCreditsTenthCtrl.value != '') {
      this.totalMarks = (Number(this.edu_form.controls.courseCreditsFirstCtrl.value) + Number(this.edu_form.controls.courseCreditsSecondCtrl.value) + Number(this.edu_form.controls.courseCreditsThirdCtrl.value) + Number(this.edu_form.controls.courseCreditsFourthCtrl.value) + Number(this.edu_form.controls.courseCreditsFifthCtrl.value) + Number(this.edu_form.controls.courseCreditsSixthCtrl.value) + Number(this.edu_form.controls.courseCreditsSeventhCtrl.value) + Number(this.edu_form.controls.courseCreditsEightCtrl.value) + Number(this.edu_form.controls.courseCreditsNinthCtrl.value) + Number(this.edu_form.controls.courseCreditsTenthCtrl.value))

    }
    else if (this.edu_form.controls.courseCreditsSecondCtrl.value != '' && this.edu_form.controls.courseCreditsThirdCtrl.value != '' && this.edu_form.controls.courseCreditsFourthCtrl.value != '' && this.edu_form.controls.courseCreditsFifthCtrl.value != '' && this.edu_form.controls.courseCreditsSixthCtrl.value != '' && this.edu_form.controls.courseCreditsSeventhCtrl.value != '' && this.edu_form.controls.courseCreditsEightCtrl.value != '' && this.edu_form.controls.courseCreditsNinthCtrl.value != '') {
      this.totalMarks = (Number(this.edu_form.controls.courseCreditsFirstCtrl.value) + Number(this.edu_form.controls.courseCreditsSecondCtrl.value) + Number(this.edu_form.controls.courseCreditsThirdCtrl.value) + Number(this.edu_form.controls.courseCreditsFourthCtrl.value) + Number(this.edu_form.controls.courseCreditsFifthCtrl.value) + Number(this.edu_form.controls.courseCreditsSixthCtrl.value) + Number(this.edu_form.controls.courseCreditsSeventhCtrl.value) + Number(this.edu_form.controls.courseCreditsEightCtrl.value) + Number(this.edu_form.controls.courseCreditsNinthCtrl.value))

    }
    else if (this.edu_form.controls.courseCreditsSecondCtrl.value != '' && this.edu_form.controls.courseCreditsThirdCtrl.value != '' && this.edu_form.controls.courseCreditsFourthCtrl.value != '' && this.edu_form.controls.courseCreditsFifthCtrl.value != '' && this.edu_form.controls.courseCreditsSixthCtrl.value != '' && this.edu_form.controls.courseCreditsSeventhCtrl.value != '' && this.edu_form.controls.courseCreditsEightCtrl.value != '') {
      this.totalMarks = (Number(this.edu_form.controls.courseCreditsFirstCtrl.value) + Number(this.edu_form.controls.courseCreditsSecondCtrl.value) + Number(this.edu_form.controls.courseCreditsThirdCtrl.value) + Number(this.edu_form.controls.courseCreditsFourthCtrl.value) + Number(this.edu_form.controls.courseCreditsFifthCtrl.value) + Number(this.edu_form.controls.courseCreditsSixthCtrl.value) + Number(this.edu_form.controls.courseCreditsSeventhCtrl.value) + Number(this.edu_form.controls.courseCreditsEightCtrl.value))
      
    } else if (this.edu_form.controls.courseCreditsSecondCtrl.value != '' && this.edu_form.controls.courseCreditsThirdCtrl.value != '' && this.edu_form.controls.courseCreditsFourthCtrl.value != '' && this.edu_form.controls.courseCreditsFifthCtrl.value != '' && this.edu_form.controls.courseCreditsSixthCtrl.value != '' && this.edu_form.controls.courseCreditsSeventhCtrl.value != '') {
      this.totalMarks = (Number(this.edu_form.controls.courseCreditsFirstCtrl.value) + Number(this.edu_form.controls.courseCreditsSecondCtrl.value) + Number(this.edu_form.controls.courseCreditsThirdCtrl.value) + Number(this.edu_form.controls.courseCreditsFourthCtrl.value) + Number(this.edu_form.controls.courseCreditsFifthCtrl.value) + Number(this.edu_form.controls.courseCreditsSixthCtrl.value) + Number(this.edu_form.controls.courseCreditsSeventhCtrl.value))
      
    } else if (this.edu_form.controls.courseCreditsSecondCtrl.value != '' && this.edu_form.controls.courseCreditsThirdCtrl.value != '' && this.edu_form.controls.courseCreditsFourthCtrl.value != '' && this.edu_form.controls.courseCreditsFifthCtrl.value != '' && this.edu_form.controls.courseCreditsSixthCtrl.value != '') {
      this.totalMarks = (Number(this.edu_form.controls.courseCreditsFirstCtrl.value) + Number(this.edu_form.controls.courseCreditsSecondCtrl.value) + Number(this.edu_form.controls.courseCreditsThirdCtrl.value) + Number(this.edu_form.controls.courseCreditsFourthCtrl.value) + Number(this.edu_form.controls.courseCreditsFifthCtrl.value) + Number(this.edu_form.controls.courseCreditsSixthCtrl.value))
      

    } else if (this.edu_form.controls.courseCreditsSecondCtrl.value != '' && this.edu_form.controls.courseCreditsThirdCtrl.value != '' && this.edu_form.controls.courseCreditsFourthCtrl.value != '' && this.edu_form.controls.courseCreditsFifthCtrl.value != '') {
      this.totalMarks = (Number(this.edu_form.controls.courseCreditsFirstCtrl.value) + Number(this.edu_form.controls.courseCreditsSecondCtrl.value) + Number(this.edu_form.controls.courseCreditsThirdCtrl.value) + Number(this.edu_form.controls.courseCreditsFourthCtrl.value) + Number(this.edu_form.controls.courseCreditsFifthCtrl.value))

      
    } else if (this.edu_form.controls.courseCreditsSecondCtrl.value != '' && this.edu_form.controls.courseCreditsThirdCtrl.value != '' && this.edu_form.controls.courseCreditsFourthCtrl.value != '') {
      this.totalMarks = (Number(this.edu_form.controls.courseCreditsFirstCtrl.value) + Number(this.edu_form.controls.courseCreditsSecondCtrl.value) + Number(this.edu_form.controls.courseCreditsThirdCtrl.value) + Number(this.edu_form.controls.courseCreditsFourthCtrl.value))

      
    } else if (this.edu_form.controls.courseCreditsSecondCtrl.value != '' && this.edu_form.controls.courseCreditsThirdCtrl.value != '') {
      this.totalMarks = (Number(this.edu_form.controls.courseCreditsFirstCtrl.value) + Number(this.edu_form.controls.courseCreditsSecondCtrl.value) + Number(this.edu_form.controls.courseCreditsThirdCtrl.value))

      
    } else if (this.edu_form.controls.courseCreditsSecondCtrl.value != '') {
      this.totalMarks = (Number(this.edu_form.controls.courseCreditsFirstCtrl.value) + Number(this.edu_form.controls.courseCreditsSecondCtrl.value))
      
    }

    this.totalCourseCredits = 0;
    if (this.edu_form.controls.courseCreditsFirstCtrl.value && this.edu_form.controls.courseCreditsSecondCtrl.value && this.edu_form.controls.courseCreditsThirdCtrl.value && this.edu_form.controls.courseCreditsFourthCtrl.value && this.edu_form.controls.courseCreditsFifthCtrl.value && this.edu_form.controls.courseCreditsSixthCtrl.value && this.edu_form.controls.courseCreditsSeventhCtrl.value && this.edu_form.controls.courseCreditsEighthCtrl.value && this.edu_form.controls.courseCreditsNinthOutCtrl.value && this.edu_form.controls.courseCreditsTenthOutCtrl.value) {
      this.totalCourseCredits = (Number(this.edu_form.controls.courseCreditsFirstCtrl.value) + Number(this.edu_form.controls.courseCreditsSecondCtrl.value) + Number(this.edu_form.controls.courseCreditsThirdCtrl.value) + Number(this.edu_form.controls.courseCreditsFourthCtrl.value) + Number(this.edu_form.controls.courseCreditsFifthCtrl.value) + Number(this.edu_form.controls.courseCreditsSixthCtrl.value) + Number(this.edu_form.controls.courseCreditsSeventhCtrl.value) + Number(this.edu_form.controls.courseCreditsEighthCtrl.value) + Number(this.edu_form.controls.courseCreditsNinthOutCtrl.value) + Number(this.edu_form.controls.courseCreditsTenthOutCtrl.value))
    } else if (this.edu_form.controls.courseCreditsFirstCtrl.value && this.edu_form.controls.courseCreditsSecondCtrl.value && this.edu_form.controls.courseCreditsThirdCtrl.value && this.edu_form.controls.courseCreditsFourthCtrl.value && this.edu_form.controls.courseCreditsFifthCtrl.value && this.edu_form.controls.courseCreditsSixthCtrl.value && this.edu_form.controls.courseCreditsSeventhCtrl.value && this.edu_form.controls.courseCreditsEighthCtrl.value && this.edu_form.controls.courseCreditsNinthOutCtrl.value) {
      this.totalCourseCredits = (Number(this.edu_form.controls.courseCreditsFirstCtrl.value) + Number(this.edu_form.controls.courseCreditsSecondCtrl.value) + Number(this.edu_form.controls.courseCreditsThirdCtrl.value) + Number(this.edu_form.controls.courseCreditsFourthCtrl.value) + Number(this.edu_form.controls.courseCreditsFifthCtrl.value) + Number(this.edu_form.controls.courseCreditsSixthCtrl.value) + Number(this.edu_form.controls.courseCreditsSeventhCtrl.value) + Number(this.edu_form.controls.courseCreditsEighthCtrl.value) + Number(this.edu_form.controls.courseCreditsNinthOutCtrl.value))
    } else if (this.edu_form.controls.courseCreditsFirstCtrl.value && this.edu_form.controls.courseCreditsSecondCtrl.value && this.edu_form.controls.courseCreditsThirdCtrl.value && this.edu_form.controls.courseCreditsFourthCtrl.value && this.edu_form.controls.courseCreditsFifthCtrl.value && this.edu_form.controls.courseCreditsSixthCtrl.value && this.edu_form.controls.courseCreditsSeventhCtrl.value && this.edu_form.controls.courseCreditsEighthCtrl.value) {
      this.totalCourseCredits = (Number(this.edu_form.controls.courseCreditsFirstCtrl.value) + Number(this.edu_form.controls.courseCreditsSecondCtrl.value) + Number(this.edu_form.controls.courseCreditsThirdCtrl.value) + Number(this.edu_form.controls.courseCreditsFourthCtrl.value) + Number(this.edu_form.controls.courseCreditsFifthCtrl.value) + Number(this.edu_form.controls.courseCreditsSixthCtrl.value) + Number(this.edu_form.controls.courseCreditsSeventhCtrl.value) + Number(this.edu_form.controls.courseCreditsEighthCtrl.value))
    } else if (this.edu_form.controls.courseCreditsFirstCtrl.value && this.edu_form.controls.courseCreditsSecondCtrl.value && this.edu_form.controls.courseCreditsThirdCtrl.value && this.edu_form.controls.courseCreditsFourthCtrl.value && this.edu_form.controls.courseCreditsFifthCtrl.value && this.edu_form.controls.courseCreditsSixthCtrl.value && this.edu_form.controls.courseCreditsSeventhCtrl.value) {
      this.totalCourseCredits = (Number(this.edu_form.controls.courseCreditsFirstCtrl.value) + Number(this.edu_form.controls.courseCreditsSecondCtrl.value) + Number(this.edu_form.controls.courseCreditsThirdCtrl.value) + Number(this.edu_form.controls.courseCreditsFourthCtrl.value) + Number(this.edu_form.controls.courseCreditsFifthCtrl.value) + Number(this.edu_form.controls.courseCreditsSixthCtrl.value) + Number(this.edu_form.controls.courseCreditsSeventhCtrl.value))
    } else if (this.edu_form.controls.courseCreditsFirstCtrl.value && this.edu_form.controls.courseCreditsSecondCtrl.value && this.edu_form.controls.courseCreditsThirdCtrl.value && this.edu_form.controls.courseCreditsFourthCtrl.value && this.edu_form.controls.courseCreditsFifthCtrl.value && this.edu_form.controls.courseCreditsSixthCtrl.value) {
      this.totalCourseCredits = (Number(this.edu_form.controls.courseCreditsFirstCtrl.value) + Number(this.edu_form.controls.courseCreditsSecondCtrl.value) + Number(this.edu_form.controls.courseCreditsThirdCtrl.value) + Number(this.edu_form.controls.courseCreditsFourthCtrl.value) + Number(this.edu_form.controls.courseCreditsFifthCtrl.value) + Number(this.edu_form.controls.courseCreditsSixthCtrl.value))
    } else if (this.edu_form.controls.courseCreditsFirstCtrl.value && this.edu_form.controls.courseCreditsSecondCtrl.value && this.edu_form.controls.courseCreditsThirdCtrl.value && this.edu_form.controls.courseCreditsFourthCtrl.value && this.edu_form.controls.courseCreditsFifthCtrl.value) {
      this.totalCourseCredits = (Number(this.edu_form.controls.courseCreditsFirstCtrl.value) + Number(this.edu_form.controls.courseCreditsSecondCtrl.value) + Number(this.edu_form.controls.courseCreditsThirdCtrl.value) + Number(this.edu_form.controls.courseCreditsFourthCtrl.value) + Number(this.edu_form.controls.courseCreditsFifthCtrl.value))
    } else if (this.edu_form.controls.courseCreditsFirstCtrl.value && this.edu_form.controls.courseCreditsSecondCtrl.value && this.edu_form.controls.courseCreditsThirdCtrl.value && this.edu_form.controls.courseCreditsFourthCtrl.value) {
      this.totalCourseCredits = (Number(this.edu_form.controls.courseCreditsFirstCtrl.value) + Number(this.edu_form.controls.courseCreditsSecondCtrl.value) + Number(this.edu_form.controls.courseCreditsThirdCtrl.value) + Number(this.edu_form.controls.courseCreditsFourthCtrl.value))
    } else if (this.edu_form.controls.courseCreditsFirstCtrl.value && this.edu_form.controls.courseCreditsSecondCtrl.value && this.edu_form.controls.courseCreditsThirdCtrl.value) {
      this.totalCourseCredits = (Number(this.edu_form.controls.courseCreditsFirstCtrl.value) + Number(this.edu_form.controls.courseCreditsSecondCtrl.value) + Number(this.edu_form.controls.courseCreditsThirdCtrl.value))
    } else if (this.edu_form.controls.courseCreditsFirstCtrl.value && this.edu_form.controls.courseCreditsSecondCtrl.value) {
      this.totalCourseCredits = (Number(this.edu_form.controls.courseCreditsFirstCtrl.value) + Number(this.edu_form.controls.courseCreditsSecondCtrl.value))
    }
  }

  copyHoursValue() {
    
    if (this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value) {
      if (this.edu_form.controls.subjectFirstCtrl.value && this.edu_form.controls.subjectSecondCtrl.value && this.edu_form.controls.subjectThirdCtrl.value && this.edu_form.controls.subjectFourthCtrl.value && this.edu_form.controls.subjectFifthCtrl.value && this.edu_form.controls.subjectSixthCtrl.value && this.edu_form.controls.subjectSeventhCtrl.value && this.edu_form.controls.subjectEighthCtrl.value && this.edu_form.controls.subjectSixthCtrl.value && this.edu_form.controls.subjectNinthCtrl.value && this.edu_form.controls.subjectTenthCtrl.value) {
        this.hourValue = this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
        this.hourValue2 = this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
        this.hourValue3 = this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
        this.hourValue4 = this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
        this.hourValue5 = this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
        this.hourValue6 = this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
        this.hourValue7 = this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
        this.hourValue8 = this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
        this.hourValue9 = this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
        this.hourValue10 = this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;




      } else if (this.edu_form.controls.subjectFirstCtrl.value && this.edu_form.controls.subjectSecondCtrl.value && this.edu_form.controls.subjectThirdCtrl.value && this.edu_form.controls.subjectFourthCtrl.value && this.edu_form.controls.subjectFifthCtrl.value && this.edu_form.controls.subjectSixthCtrl.value && this.edu_form.controls.subjectSeventhCtrl.value && this.edu_form.controls.subjectEighthCtrl.value && this.edu_form.controls.subjectSixthCtrl.value && this.edu_form.controls.subjectNinthCtrl.value) {
        this.hourValue = this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
        this.hourValue2 = this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
        this.hourValue3 = this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
        this.hourValue4 = this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
        this.hourValue5 = this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
        this.hourValue6 = this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
        this.hourValue7 = this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
        this.hourValue8 = this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
        this.hourValue9 = this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;




      } else if (this.edu_form.controls.subjectFirstCtrl.value && this.edu_form.controls.subjectSecondCtrl.value && this.edu_form.controls.subjectThirdCtrl.value && this.edu_form.controls.subjectFourthCtrl.value && this.edu_form.controls.subjectFifthCtrl.value && this.edu_form.controls.subjectSixthCtrl.value && this.edu_form.controls.subjectSeventhCtrl.value && this.edu_form.controls.subjectEighthCtrl.value) {
        this.hourValue = this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
        this.hourValue2 = this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
        this.hourValue3 = this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
        this.hourValue4 = this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
        this.hourValue5 = this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
        this.hourValue6 = this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
        this.hourValue7 = this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
        this.hourValue8 = this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;




      } else if (this.edu_form.controls.subjectFirstCtrl.value && this.edu_form.controls.subjectSecondCtrl.value && this.edu_form.controls.subjectThirdCtrl.value && this.edu_form.controls.subjectFourthCtrl.value && this.edu_form.controls.subjectFifthCtrl.value && this.edu_form.controls.subjectSixthCtrl.value && this.edu_form.controls.subjectSeventhCtrl.value) {
        this.hourValue = this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
        this.hourValue2 = this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
        this.hourValue3 = this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
        this.hourValue4 = this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
        this.hourValue5 = this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
        this.hourValue6 = this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
        this.hourValue7 = this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
      } else if (this.edu_form.controls.subjectFirstCtrl.value && this.edu_form.controls.subjectSecondCtrl.value && this.edu_form.controls.subjectThirdCtrl.value && this.edu_form.controls.subjectFourthCtrl.value && this.edu_form.controls.subjectFifthCtrl.value && this.edu_form.controls.subjectSixthCtrl.value) {
        this.hourValue = this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
        this.hourValue2 = this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
        this.hourValue3 = this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
        this.hourValue4 = this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
        this.hourValue5 = this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
        this.hourValue6 = this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;

      } else if (this.edu_form.controls.subjectFirstCtrl.value && this.edu_form.controls.subjectSecondCtrl.value && this.edu_form.controls.subjectThirdCtrl.value && this.edu_form.controls.subjectFourthCtrl.value && this.edu_form.controls.subjectFifthCtrl.value) {
        this.hourValue = this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
        this.hourValue2 = this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
        this.hourValue3 = this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
        this.hourValue4 = this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
        this.hourValue5 = this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;

      } else if (this.edu_form.controls.subjectFirstCtrl.value && this.edu_form.controls.subjectSecondCtrl.value && this.edu_form.controls.subjectThirdCtrl.value && this.edu_form.controls.subjectFourthCtrl.value) {
        this.hourValue = this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
        this.hourValue2 = this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
        this.hourValue3 = this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
        this.hourValue4 = this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;

      } else if (this.edu_form.controls.subjectFirstCtrl.value && this.edu_form.controls.subjectSecondCtrl.value && this.edu_form.controls.subjectThirdCtrl.value) {
        this.hourValue = this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
        this.hourValue2 = this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
        this.hourValue3 = this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;


      } else if (this.edu_form.controls.subjectFirstCtrl.value && this.edu_form.controls.subjectSecondCtrl.value) {
        this.hourValue = this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
        this.hourValue2 = this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;



      }


    }
  }

  copyLecValue() {
    if (this.edu_form.controls.lecturehourFirstCtrl.value) {
      if (this.edu_form.controls.subjectFirstCtrl.value && this.edu_form.controls.subjectSecondCtrl.value && this.edu_form.controls.subjectThirdCtrl.value && this.edu_form.controls.subjectFourthCtrl.value && this.edu_form.controls.subjectFifthCtrl.value && this.edu_form.controls.subjectSixthCtrl.value && this.edu_form.controls.subjectSeventhCtrl.value && this.edu_form.controls.subjectEighthCtrl.value && this.edu_form.controls.subjectSixthCtrl.value && this.edu_form.controls.subjectNinthCtrl.value && this.edu_form.controls.subjectTenthCtrl.value) {
        this.lecVal1 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal2 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal3 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal4 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal5 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal6 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal7 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal8 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal9 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal10 = this.edu_form.controls.lecturehourFirstCtrl.value;
      } else if (this.edu_form.controls.subjectFirstCtrl.value && this.edu_form.controls.subjectSecondCtrl.value && this.edu_form.controls.subjectThirdCtrl.value && this.edu_form.controls.subjectFourthCtrl.value && this.edu_form.controls.subjectFifthCtrl.value && this.edu_form.controls.subjectSixthCtrl.value && this.edu_form.controls.subjectSeventhCtrl.value && this.edu_form.controls.subjectEighthCtrl.value && this.edu_form.controls.subjectSixthCtrl.value && this.edu_form.controls.subjectNinthCtrl.value) {
        this.lecVal1 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal2 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal3 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal4 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal5 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal6 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal7 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal8 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal9 = this.edu_form.controls.lecturehourFirstCtrl.value;

      } else if (this.edu_form.controls.subjectFirstCtrl.value && this.edu_form.controls.subjectSecondCtrl.value && this.edu_form.controls.subjectThirdCtrl.value && this.edu_form.controls.subjectFourthCtrl.value && this.edu_form.controls.subjectFifthCtrl.value && this.edu_form.controls.subjectSixthCtrl.value && this.edu_form.controls.subjectSeventhCtrl.value && this.edu_form.controls.subjectEighthCtrl.value) {
        this.lecVal1 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal2 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal3 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal4 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal5 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal6 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal7 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal8 = this.edu_form.controls.lecturehourFirstCtrl.value;
      } else if (this.edu_form.controls.subjectFirstCtrl.value && this.edu_form.controls.subjectSecondCtrl.value && this.edu_form.controls.subjectThirdCtrl.value && this.edu_form.controls.subjectFourthCtrl.value && this.edu_form.controls.subjectFifthCtrl.value && this.edu_form.controls.subjectSixthCtrl.value && this.edu_form.controls.subjectSeventhCtrl.value) {
        this.lecVal1 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal2 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal3 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal4 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal5 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal6 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal7 = this.edu_form.controls.lecturehourFirstCtrl.value;

      } else if (this.edu_form.controls.subjectFirstCtrl.value && this.edu_form.controls.subjectSecondCtrl.value && this.edu_form.controls.subjectThirdCtrl.value && this.edu_form.controls.subjectFourthCtrl.value && this.edu_form.controls.subjectFifthCtrl.value && this.edu_form.controls.subjectSixthCtrl.value) {
        this.lecVal1 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal2 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal3 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal4 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal5 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal6 = this.edu_form.controls.lecturehourFirstCtrl.value;


      } else if (this.edu_form.controls.subjectFirstCtrl.value && this.edu_form.controls.subjectSecondCtrl.value && this.edu_form.controls.subjectThirdCtrl.value && this.edu_form.controls.subjectFourthCtrl.value && this.edu_form.controls.subjectFifthCtrl.value) {
        this.lecVal1 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal2 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal3 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal4 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal5 = this.edu_form.controls.lecturehourFirstCtrl.value;

      } else if (this.edu_form.controls.subjectFirstCtrl.value && this.edu_form.controls.subjectSecondCtrl.value && this.edu_form.controls.subjectThirdCtrl.value && this.edu_form.controls.subjectFourthCtrl.value) {
        this.lecVal1 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal2 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal3 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal4 = this.edu_form.controls.lecturehourFirstCtrl.value;


      } else if (this.edu_form.controls.subjectFirstCtrl.value && this.edu_form.controls.subjectSecondCtrl.value && this.edu_form.controls.subjectThirdCtrl.value) {
        this.lecVal1 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal2 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal3 = this.edu_form.controls.lecturehourFirstCtrl.value;

      } else if (this.edu_form.controls.subjectFirstCtrl.value && this.edu_form.controls.subjectSecondCtrl.value) {
        this.lecVal1 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal2 = this.edu_form.controls.lecturehourFirstCtrl.value;


      }
    }
  }

  onChange(event, no) {
    if (no == '1') {
      if (event.checked == true) {
        this.instruction1 = true;
        this.special_instruction1 = '@ As per University of Mumbai Ordinance 0.5042A/0.5043A/0.5044A'
      }
      if (event.checked == false) {
        this.instruction1 = false;
        this.special_instruction1 = null
      }
    } else if (no == '2') {
      if (event.checked == true) {
        this.instruction2 = true;
        this.special_instruction2 = '& Scaled Down, Cir. No. UG/61 of 2013-2014'
      }
      if (event.checked == false) {
        this.instruction2 = false;
        this.special_instruction2 = null
      }
    } else if (no == '3') {
      if (event.checked == true) {
        this.instruction3 = true;
        this.special_instruction3 = '+ Carried Forward Marks as per Ordinance of University of Mumbai'
      }
      if (event.checked == false) {
        this.instruction3 = false;
        this.special_instruction3 = null
      }
    } else if (no == '4') {
      if (event.checked == true) {
        this.instruction4 = true;
        this.special_instruction4 = '* As per University of Mumbai Ordinance 0.5045a'
      }
      if (event.checked == false) {
        this.instruction4 = false;
        this.special_instruction4 = null
      }
    } else if (no == '5') {
      if (event.checked == true) {
        this.instruction5 = true;
        this.special_instruction5 = '$ - Carried forward grade as per ordinance of the University of Mumbai'
      }
      if (event.checked == false) {
        this.instruction5 = false;
        this.special_instruction5 = null
      }
    } else if (no == '6') {
      if (event.checked == true) {
        this.instruction6 = true;
        this.special_instruction6 = '# As per University of Mumbai, Ordinance 0.229'
      }
      if (event.checked == false) {
        this.instruction6 = false;
        this.special_instruction6 = null
      }
    }else if(no=='7'){
        if(event.checked == true){
          this.instruction7 = true;
          this.special_instruction7 = '& As per University of Mumbai Ordinance. O.224'
        }
        if(event.checked == false){
          this.instruction7 = false;
          this.special_instruction7 = null
        }
      }

  }

  updateSpecialInstruction(val) {
    this.specialInstruction = val
  }

  getSpecialInst(event: any) {

    this.specialInstruction = event.target.value

  }

  updateGradeSpecialInstruction(val) {
    
    this.GradespecialInstruction = val
  }

  getGradeSpecialInst(event: any) {

    this.GradespecialInstruction = event.target.value

  }

  showcoursecodeDropdown() {
    this.showcodeDropdown = true;
  }

  showcoursecodeDropdown2() {
    this.showcodeDropdown2 = true;
  }

  showcoursecodeDropdown3() {
    this.showcodeDropdown3 = true;
  }

  showcoursecodeDropdown4() {
    this.showcodeDropdown4 = true;
  }

  showcoursecodeDropdown5() {
    this.showcodeDropdown5 = true;
  }

  showcoursecodeDropdown6() {
    this.showcodeDropdown6 = true;
  }

  showcoursecodeDropdown7() {
    this.showcodeDropdown7 = true;
  }

  showcoursecodeDropdown8() {
    this.showcodeDropdown8 = true;
  }

  showcoursecodeDropdown9() {
    this.showcodeDropdown9 = true;
  }

  showcoursecodeDropdown10() {
    this.showcodeDropdown10 = true;
  }


}